export const formDataSaqDsp = [
   // Page 10
   {
    _uid: "e9f0354a-d2d4-457f-a3c0-212b1ede86c0",
    layout: "form",
    component: "page",
    title: "Assessment Information",
    label: "Instructions for Submission",
    simplifiedLabel: "",
    caption:
      "This document must be completed as a declaration of the results of the merchant’s self-assessment against the Payment Card Industry Data Security Standard (PCI DSS) Requirements and Testing Procedures. Complete all sections. The merchant is responsible for ensuring that each section is completed by the relevant parties, as applicable. Contact the entity(ies) to which the Attestation of Compliance (AOC) will be submitted for reporting and submission procedures.",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "d8286d28-f60b-43c2-b392-f969ad4993bb",
        component: "text",
        type: "text",
        label: "Company Name",
        simplifiedLabel: "Company Name",
        maxLength: "68",
      },
      {
        _uid: "5174ec78-8bc2-43d7-ba07-cff93ab2e737",
        component: "text",
        type: "text",
        label: "DBA (doing business as):",
        simplifiedLabel: "DBA (doing business as):",
        maxLength: "68",
      },
      {
        _uid: "4595839c-90fc-4692-84dc-a4597e635b13",
        component: "text",
        type: "text",
        label: "Company mailing address:",
        simplifiedLabel: "Company mailing address:",
        maxLength: "68",
      },
      {
        _uid: "7e6768ef-c046-4d39-82d0-6bdc6af3f79d",
        component: "text",
        type: "text",
        label: "Company main website:",
        simplifiedLabel: "Company main website:",
        maxLength: "68",
      },
      {
        _uid: "0ab0a774-b4c2-43fe-bcfc-77155900ae1c",
        component: "text",
        type: "text",
        label: "Company contact name:",
        simplifiedLabel: "Company contact name:",
        maxLength: "68",
      },
      {
        _uid: "a67c6ac6-d624-4843-bbfb-947dff788695",
        component: "text",
        type: "text",
        label: "Company contact title:",
        simplifiedLabel: "Company contact title:",
        maxLength: "68",
      },
      {
        _uid: "68ef902a-7f26-43c4-b493-ceab3c6d69e2",
        component: "text",
        type: "text",
        label: "Contact phone number:",
        simplifiedLabel: "Contact phone number:",
        maxLength: "68",
      },
      {
        _uid: "248627b6-0c99-402d-9ab8-1118f4fbca46",
        component: "text",
        type: "text",
        label: "Contact e-mail address:",
        simplifiedLabel: "Contact e-mail address:",
        maxLength: "68",
      },
      {
        _uid: "881a928e-fa3f-4ca4-8240-c84a58e35a4e",
        component: "label",
        type: "",
        label: "Part 1b. Assessor",
        simplifiedLabel: "",
        maxLength: "13",
      },
      {
        _uid: "efcc2336-cfb1-4dbf-96c7-7ed83b9b1894",
        component: "label",
        type: "",
        label:
          "Provide the following information for all assessors involved in the assessment. If there was no assessor for a given assessor type, followings are Not Applicable.",
        simplifiedLabel: "",
        maxLength: "120",
      },
      {
        _uid: "7dd93e19-49cb-430c-b1f3-8841a5aba091",
        component: "label",
        type: "",
        label: "PCI SSC Internal Security Assessor(s)",
        simplifiedLabel: "",
        maxLength: "13",
      },
      {
        _uid: "76603005-75e8-4992-b248-da95ddcdbe4b",
        component: "text",
        type: "text",
        label: "ISA name(s):",
        simplifiedLabel: "",
        maxLength: "68",
        col: "12",
      },
      {
        _uid: "c8d8d852-50fd-4440-8082-814073afe5eb",
        component: "label",
        type: "",
        label: "Qualified Security Assessor",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bfa8f531-460c-4b37-8743-fd09797942b4",
        component: "text",
        type: "text",
        label: "Company name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "39ba999d-b41a-4fcb-8312-aa1a05c16d87",
        component: "text",
        type: "text",
        label: "Company mailing address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "e3b3b310-9079-4df9-8767-d152a7e1b6f7",
        component: "text",
        type: "text",
        label: "Company website:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "862d75b4-2710-42cc-be34-26c82a56d8a6",
        component: "text",
        type: "text",
        label: "Lead Assessor Name:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "bea46930-82b4-40ac-9d2b-a40254c9c4f4",
        component: "text",
        type: "text",
        label: "Assessor phone number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "91e3cf83-2ff3-438f-b828-b4ff656533b3",
        component: "text",
        type: "text",
        label: "Assessor e-mail address: ",
        simplifiedLabel: "",
        maxLength: "68",
      },
      {
        _uid: "4bdda341-517c-44a9-ac6e-cecbd8800af6",
        component: "text",
        type: "text",
        label: "Assessor certificate number:",
        simplifiedLabel: "",
        maxLength: "68",
      },
    ],
  },
  // Page 11
  {
    _uid: "b68afcd7-c86a-4ef0-a7c4-970778f8a0da",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Part 2. Executive Summary",
    caption: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "aace1f9a-b460-4be8-b839-2831d313cddb",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        boldCaption: [ "Part 2a. Scope Verification((continued))",
          "Services that are provided by the service provider but were NOT INCLUDED in the scope of the PCI DSS Assessment (select all that apply):", ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "8c810ab6-98f0-4617-9194-a5e2190f37d0",
                component: "col",
                label: "",
                simplifiedLabel: [ "Name of service(s) not assessed:" ],
                hasLi: "no",
                type: "",
                col: "",
                width: "30%",
              },
              {
                _uid: "a51b6408-3a48-4857-a388-63c048ff9cd3",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "text",
                maxLength:"66",
                col: "",
                width: "70%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "341d8fb1-8d24-4699-9d56-a9824c2ab4a8",
                component: "col",
                label: "",
                simplifiedLabel: [ "Type of service(s) not assessed:" ],
                hasLi: "no",
                type: "",
                col: "",
                width: "20%",
              },
              {
                _uid: "dbb5f3b8-a84c-40e5-997a-b625ad84a778",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "text",
                maxLength:"72",
                textareaRows: "1",
                col: "",
                width: "80%",
              },
            ],
          },
        ],
      },
      {
        _uid: "fcff5cb7-4ad8-4a9d-a2e8-428c642f83d1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        boldCaption: [],
        simplifiedCaption: [],
        headers: [ "Hosting Provider:", "Managed Services:", "Payment Processing:" ],
        fields: [
          {
            fields: [
              {
                _uid: "11054565-8de8-47ed-acbe-57873050a09a",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Applications / software",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "914a41c2-24ac-4d9d-bec2-fc039e068bea",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Systems security services",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "d1149781-cb8c-4a0a-9733-50a154269b48",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "POI / card present",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "598e5d74-4fce-4691-9cc3-e37f7aa875f8",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Hardware",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "ecad1347-e834-41f4-87d0-9221f4e5ec99",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "IT support",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "408df2c7-5de2-4298-b8b0-88a08c7e866d",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Internet / e-commerce",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bc18578d-9ec5-491f-bae2-5320fbb67ef8",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Infrastructure / Network",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "1525f0c1-b70b-44e2-bbbb-c1de27ae8f2d",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Physical security",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "5fd72fab-e216-407c-a90d-4811582f2367",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "MOTO / Call Center",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d66833e2-7c12-417e-b669-fd3882ebd069",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Physical space (co-location)",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "7fb07cba-a9a9-4ca5-ba06-82f13e2405af",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Terminal Management System",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "79ccadf9-cd82-425c-a3cc-681dbc561a44",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "ATM",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8fdc246e-a24a-4d47-afda-5ac75069a3a4",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Storage",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "6ded4afa-de69-4b27-8ccd-b4058e3723ad",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Other services (specify):",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "d159e886-7271-47e4-bbe0-920e1cc569cd",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Other processing (specify):",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "93636737-4d89-4983-8146-9f0b69df4a1e",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Web-hosting services",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "734dab1c-56e7-454c-a467-c1e8ec149333",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "be84ac94-f283-4972-8f35-c6f4839daa3b",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7e236007-8222-45c5-83c8-216bb5ea2ef2",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Security services",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "1d9c5c2e-92b7-4962-a898-b67cdea3fe86",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "c0d5d5a6-9966-45e8-a5c7-78e62b68ea54",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bb6cbfc5-2cd7-4089-a313-840ff095fcee",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "3-D Secure Hosting Provider",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "2f3ea03e-06fc-4295-8995-beca9a47d71e",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "c3028b0d-6ae9-4da2-a532-213630c7fb3d",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1a7c5059-e0b7-45a2-9231-60773e75f3d3",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Multi-Tenant Service Provider",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "a1242207-1119-4179-a7a9-47ac2dd1e84c",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "c1735cbb-08ec-4d17-8df2-2d720cd59208",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2f0b549f-e0bf-4db7-b232-6df8563468b6",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Other Hosting (specify):",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "43abbc29-1304-4d36-93b1-cc16e9f6c5f9",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "37664ad5-ae62-4c92-96ab-263065d89ca3",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dde2b184-a64e-4213-a8f6-1116269117b6",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Account Management",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "6733da09-c25c-4d2b-96bc-4889c299a99c",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Fraud and Chargeback",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "4e4e9c86-b8fd-4489-aea4-561f084ac17d",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Payment Gateway/Switch",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "144d7a7a-c4c4-41a3-a852-bc2d27f59f00",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Back-Office Services ",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "32286b6e-8259-4c0b-ab24-09ff6d130250",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Issuer Processing",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "eaf6f430-a60c-4a71-a54b-820a616c2f9a",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Prepaid Services",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6ffef6c0-573c-441d-b118-2036c2e90190",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Billing Management",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "0a221899-5d88-46bc-9640-f043a6d9e53d",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Loyalty Programs",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "e15fc4e2-5862-4bbb-9ab9-046136481b1a",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Records Management",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d017b2f6-56c8-496d-b59b-62380aa8f899",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Clearing and Settlement",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "83cc8012-7f95-4c44-827e-fd7a9eee8f1c",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Merchant Services",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "44d994af-c370-43fc-ae29-88f26b9e324b",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Tax/Government Payments",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6f52a7b9-87b9-4766-b570-6aed7b5f4506",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Network Provider",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "a3e5fadb-7c5c-49ce-bb1a-dbec5d1fd7a0",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "7ce5171a-2c9a-4b76-b430-8786371e63f5",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bf009adb-9ed5-4cbc-a8bd-d705f129bddb",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Others (specify):",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "40ccb6ea-4f6a-48f1-b8f8-dbb1da3bbebf",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "89195303-b13b-4214-a453-ea2482b04990",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "25427192-721d-46a5-90eb-1be1be5b6f7a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Note: These categories are provided for assistance only and are not intended to limit or predetermine an entity’s service description. If these categories do not apply to the assessed service, complete “Others.” If it is not clear whether a category could apply to the assessed service, consult with the entity(ies) to which this AOC will be submitted.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                colSpan: 3,
                width: "100%",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page 12
  {
    _uid: "b8cd015d-4f02-46a8-a102-9994a583eb45",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Part 2. Executive Summary",
    caption: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "1a43f1c8-0ab3-49cd-b17b-17bd25748be5",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        boldCaption: [ "Part 2a. Scope Verification((continued))",
          "Services that are provided by the service provider but were NOT INCLUDED in the scope of the PCI DSS Assessment (select all that apply):", ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "e2b9c31f-6ccd-4ffc-aef9-d1d3b3f1868c",
                component: "col",
                label: "",
                simplifiedLabel: [ "Name of service(s) not assessed:" ],
                hasLi: "no",
                type: "",
                col: "",
                width: "30%",
              },
              {
                _uid: "04e5cd96-1f2b-4f5e-8d03-4b3ab92f5ee1",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "text",
                textareaRows: "1",
                maxLength:"63",
                col: "",
                width: "70%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d82d8cdc-9f9f-4a09-ac49-8dc91989cc16",
                component: "col",
                label: "",
                simplifiedLabel: [ "Type of service(s) not assessed:" ],
                hasLi: "no",
                type: "",
                col: "",
                width: "20%",
              },
              {
                _uid: "3da8323e-a0e0-44bf-b3ec-f04e96cbac72",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "text",
                textareaRows: "1",
                maxLength:"68",
                col: "",
                width: "80%",
              },
            ],
          },
        ],
      },
      {
        _uid: "72882ee7-fa9c-47f8-bfea-1adbcc5efad1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        boldCaption: [],
        simplifiedCaption: [],
        headers: [ "Hosting Provider:", "Managed Services:", "Payment Processing:" ],
        fields: [
          {
            fields: [
              {
                _uid: "6158137f-20dc-40d5-9392-b963293d6a74",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Applications / software",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "94a1f4ea-287c-41cf-8e8e-665a3e1484e9",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Systems security services",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "6069e68e-25e3-4d33-a1f0-cb7274bab6e6",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "POI / card present",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "31f75638-dfdc-4678-b678-87b01bde3221",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Hardware",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "b04a506b-c8c8-4e30-8b33-29443fb3a484",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "IT support",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "de924a91-bb03-441e-b841-fa3f8c885c10",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Internet / e-commerce",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "243b91da-e6dd-4120-83b9-fa30494530c0",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Infrastructure / Network",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "48555310-c1a6-48fe-a811-24429d0bff72",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Physical security",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "a1da3b2c-27e9-4965-9758-df64591234ef",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "MOTO / Call Center",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "608758e0-457e-4311-827e-dd3a7e636888",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Physical space (co-location)",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "c8fb0d4a-f1c6-4a95-829e-644d23464dae",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Terminal Management System",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "ddafa9ff-6217-4457-803b-eb9401b75b3b",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "ATM",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7434401a-0594-4894-825e-da66ba6b2c62",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Storage",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "f897338f-491a-40f6-a273-f4d52f8ba18e",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Other services (specify):",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "6f361e07-c3e8-4664-aee3-fc5ca3533fa9",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Other processing (specify):",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "aa89e29f-33b0-4a75-b5cc-7cc761b3e5ca",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Web-hosting services",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "5b2f4325-c8e2-4ad2-9324-ee7e84263d45",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "c6c2d476-2065-4e8c-a5f1-46716bdcd614",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6df4fa40-cf69-4e2f-98af-031c76174312",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Security services",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "dea9d515-21d1-405c-bb99-3828dbd7fe02",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "8cfbed03-3290-42d0-9ce8-cec3599bab3a",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2118e1a3-db10-408b-bbf2-07f464e03334",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "3-D Secure Hosting Provider",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "af56d0e6-80df-4be0-8b1b-484d881edda7",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "03e779a5-584a-4d21-9869-7bb06ff8c8e5",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "096dcb71-e4a4-4af6-82cf-b716565f7769",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Multi-Tenant Service Provider",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "bb56d3cb-9f26-44db-9347-4005c4a70979",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "3fe4d97a-f2e8-4e10-a37a-e32dff2c77f8",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "994191ad-e329-47e9-9d60-116241d58ce1",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Other Hosting (specify):",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "a66c91be-9a32-4f5e-a317-7f8d16bcd65a",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "d9bb7eef-e70f-4e33-a602-107562c766c6",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b350a49c-0a8d-485f-af59-4d435759ff46",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Account Management",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "238b71bc-6ff9-4114-bdb1-d9709e66393a",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Fraud and Chargeback",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "dcedfa5b-7c8b-4d86-a5c1-dea1ed28a569",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Payment Gateway/Switch",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bfc83142-904c-4623-937e-8d59ddc9c972",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Back-Office Services ",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "a1e3e024-d17b-4571-9791-4f5ea728e153",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Issuer Processing",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "3151d01b-cd92-4bd5-b072-9a7e2531f605",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Prepaid Services",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6648439d-0779-4ddf-8aa4-6afa63d1c8ff",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Billing Management",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "4eeeb481-937d-4bf6-b9b9-93101efbebfc",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Loyalty Programs",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "9f491499-8f43-4350-874c-5c9cca3c1ecb",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Records Management",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "10d28a1b-41f6-4d28-8285-216d5e0648a3",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Clearing and Settlement",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "8d5f05fd-8f13-4cf2-9e7d-3b48b586b00e",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Merchant Services",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "4e3ce6ea-5c2f-4c8e-b200-f17f6e486fb8",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Tax/Government Payments",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b2475ab8-8d9c-4d20-8933-d132bb087871",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "Network Provider",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "19987e47-29d5-49b7-9120-bfe79d511cc1",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "73e567b3-f378-43ac-bcc1-6049b0073693",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5e853c38-6475-41cb-8935-e284decaa1eb",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "3-D Secure Hosting Provider",
                value: "yes",
                width: "30%",
              },
              {
                _uid: "1d6221a9-919c-4fec-8176-ea5263de30a0",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "40%",
              },
              {
                _uid: "70db3699-3422-4a02-9b1e-ea3501fbf286",
                component: "label",
                type: "",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "30%",
              },
            ],
          },
        ],
      },
      {
        _uid: "c39fc93d-4ff8-45f2-8e3e-4f5f71b7b378",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [ "" ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "639291de-7e28-42fa-9ce0-a07943d7725b",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Provide a brief explanation why any checked services were not included in the assessment:",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "9fc3deeb-8321-47b9-bd4b-53b2220693eb",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: 46,
                col: "12",
                width: "50%",
              },
            ],
          },
        ],
      },
      {
        _uid: "a1f52488-5cd5-4e4a-8aeb-ec62c1efbf5b",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        boldCaption: [ "Part 2c. Description of Payment Card Environment" ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "b562e662-3acf-415b-a6fc-52d9f8f4ccbb",
                component: "col",
                label: "",
                simplifiedLabel: [ "Describe how the business stores, processes, and/or transmits account data" ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "bcdf31d1-e953-490a-a663-3b0352e7032e",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: 49,
                col: "12",
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "bdd96301-0897-4645-a696-f929da8ecbda",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Describe how the business is otherwise involved in or has the ability to impact the security of its customers’ account data",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "dfbe1ef2-ea6e-4679-8002-7658a4ea9844",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: 49,
                col: "12",
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d0e45178-784d-4e1a-9a75-0b43fb8e3bad",
                component: "col",
                label: "",
                simplifiedLabel: [ "Describe system components that could impact the security of account data." ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "9c9629d5-c0e7-4e8e-8fdd-00a3602c180f",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: 49,
                col: "12",
                width: "50%",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page 13
  {
    _uid: "272eaabf-1e84-49fd-825d-e5e6cedbfb5c",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Part 2. Executive Summary (continued)",
    caption: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "31a9db8f-58ef-4652-98ce-b95eac326dff",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        boldCaption: [ "Part 2c. Description of Payment Card Environment" ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "2bde7286-8572-48ce-9ad4-e87e48e35b54",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Provide a high-level description of the environment covered by this assessment.",
                  "For example:",
                  "Connections into and out of the cardholder data environment (CDE).",
                  "Critical system components within the CDE, such as POI devices, databases, web servers, etc., and any other necessary payment components, as applicable.",
                  "System components that could impact the security of account data.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "50%",
              },
              {
                _uid: "65c8932a-c344-4919-bd76-f9040a57ec25",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "8",
                maxLength: "300",
                col: "12",
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2c352136-6c7c-47b7-a88b-13c9381f4982",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Indicate whether the environment includes segmentation to reduce the scope of the assessment.",
                  "(Refer to “Segmentation” section of PCI DSS for guidance on segmentation.)",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "70%",
              },

              {
                _uid: "d64b5973-1566-43e1-9b8f-874b1fde5985",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "30%",
                doNotDisplayLabel: "",
              },
            ],
          },
        ],
      },
      {
        _uid: "c928b6b0-95c5-4f74-97f9-aa4337210a12",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "e3ad86e1-1c6e-4073-a9f4-da9860600702",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2d. In-Scope Locations/Facilities",
                subBoldLabel:
                  "List all types of physical locations/facilities (for example, retail locations, corporate offices, data centers, call centers, and mail rooms) in scope for the PCI DSS assessment.",
                hasLi: "yes",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
        ],
      },
      {
        _uid: "f532f41b-7a47-4164-9665-2d6497998370",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: [
          "Facility Type",
          [ "Total number of locations", "(How many locations of this type are in scope)" ],
          "Location(s) of facility (city, country)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "f538e4fb-d0ac-4a62-a9f2-528eda4a4e10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "acf5d0af-3f42-442f-800e-4d6c222b6351",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "9d917ce7-1041-4f79-870f-1b4c39ee603c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4e21fb8b-f941-41a2-baba-728508c9d5e7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "cc43fff6-bf6d-4fd2-8f27-dd05739eb088",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "8976e226-42f4-4623-873e-253d2e9b813a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7dafe126-42b5-43ad-af9d-f9b1c04292d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "99d91a88-dc68-4ccd-86b5-f9062f0634cd",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "87469c76-72f0-4c65-a4aa-3ad546651328",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3fd13af2-ff06-4a89-8065-49d9312289b9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "38480e9b-5ba4-4c37-be48-32033a5f1cce",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "afe658c1-09ca-43bc-a1c6-d9c27d50930a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8a41379e-f356-4293-a495-5feee49f0b73",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "003752c8-ce7b-4082-963b-e822647a915f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "6bbac7ef-44fe-418f-aa3d-033ff84d30f2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e172cf04-218b-4289-b04f-0da438a8df10",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "51a688d4-e852-409b-b521-49ca21d681e6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "14f3a088-0a71-4190-af9c-dddfc05edcd7",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "216d893f-c246-4c7a-a4ba-6bc4bd82a3d2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "a1709a35-c76f-40e5-9163-b022945aef2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "a38dbab5-d50b-48e7-a952-1aa490b4186e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be1c6190-cf0d-4811-a1d5-2a0ccac73702",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "57fb74a7-b50f-4792-9291-32d1fb8a80be",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "66f7fe42-0057-4e43-84cc-cf28e2577ab1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "70735d49-2dbb-4170-84e5-258f9f356e1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
              {
                _uid: "884f0186-8179-4211-863d-df53adb66d3c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "4",
              },
              {
                _uid: "3d2273d0-fcec-4f8d-8aca-38cf9fc68a7c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "37",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page 14
  {
    _uid: "f56653e8-3f32-4dfd-8b17-03c0a670d138",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: [ "Part 2. Executive Summary (continued)" ],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "a89467ec-e1b2-4db7-9910-d0bb46c97936",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "328cb050-79f9-4945-a06c-50feba6d6f5a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2e. PCI SSC Validated Products and Solutions",
                subBoldLabel: "",
                hasLi: "yes",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8dc8633d-b76c-46cb-9d7f-945fba5fe4ab",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Does the merchant use any item identified on any PCI SSC Lists of Validated Products and Solutions*?",
                boldLabel: "",
                subBoldLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "cd991465-68c7-49d9-82ba-2769db9bb9f8",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "20%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: [ "no" ],
                  _uids: [
                    "857d8004-08b2-4aea-b555-d72df62dce09",
                    "af826cd7-9a19-4125-a398-1daca49c93b0",
                    "2825014b-e992-463f-bc4a-9cf9195e509a",
                    "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                    "6ae39d41-7512-4548-8961-587d4df0197a",
                    "4ea9b5d7-3616-46bf-ac0a-53ae99959724",
                    "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                    "f971e7b0-2b1f-40af-a24f-83429fc13077",
                    "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                    "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                    "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                    "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                    "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                    "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                    "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                    "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                    "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                    "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                    "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                    "da5394e3-10e8-4508-baa3-81999f827530",
                    "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                    "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                    "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                    "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                    "10858523-2cc8-42fe-8c64-b81d620b5602",
                    "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                    "70398dd7-a086-45ac-b91e-72912d800505",
                    "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                    "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                    "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                    "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                    "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                    "72e92d2c-0158-4ab3-8194-2ab827652d49",
                    "73dc086f-719a-43ad-a5a4-77ae1e702737",
                    "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                    "1e5f30f3-db60-41fc-be94-99394652aab5",
                    "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                    "470582c3-2690-4bdc-9482-c21593e80306",
                    "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                    "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                    "8413cd02-9a1e-4e99-a021-da94cb98964d",
                    "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                    "d82e5669-4111-45c0-ac13-2fba7e575e91",
                    "3e0115af-7b42-481f-acee-badb6ed4cee9",
                    "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                    "da9bd7e1-7756-4680-9791-7f6e96431209",
                    "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                    "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                    "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                    "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                  ],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "025ab84f-6a71-4eb7-8f04-2689074c13ab",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [],
        headers: [
          "Name of PCI SSC validated Product or Solution",
          "Version of Product or Solution",
          "PCI SSC Standard to which product or solution was validated",
          "PCI SSC listing reference number",
          ["Expiry date of listing","(YYYY-MM-DD)"]
        ],
        conditional: {
          value: "yes",
          field: "51ca7282-7b1f-4a2f-b782-79be8343e7c1_cd991465-68c7-49d9-82ba-2769db9bb9f8",
        },
        fields: [
          {
            fields: [
              {
                _uid: "857d8004-08b2-4aea-b555-d72df62dce09",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "af826cd7-9a19-4125-a398-1daca49c93b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "2825014b-e992-463f-bc4a-9cf9195e509a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "4df9f04a-07f5-4770-9d75-ebd77c0a1896",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "6ae39d41-7512-4548-8961-587d4df0197a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ce066dfd-332a-4aed-ba09-1ca15acb0eb2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "82aa6ede-c17b-4d1f-a7e3-bd483c568b14",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "f971e7b0-2b1f-40af-a24f-83429fc13077",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "2eef5cb4-f928-455d-8cfb-b6f0f36bed53",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "9e74c805-23ee-4d16-a51f-f6c74cced99d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "c7ed367f-43d0-4ae2-8c1a-c6045c801ee6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "e26d57c6-3a3b-4908-ba34-32ce92edbb1a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "bd11db13-964a-4d58-8e5c-fbd3f928d6a9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "ebd07abd-71e3-4d65-9ec7-b0215ce104a0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "0052d931-bdc3-44ec-b63e-43a66b7cd9e2",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da5394e3-10e8-4508-baa3-81999f827530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "e3b24f73-2afd-4a73-97bf-55ddf596cf85",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "65527b4a-b7f3-4a0c-902b-39a57ac6d2dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "610d8d7f-5e35-44bf-99b8-2bbc4fa9beb9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "0aa1aeb9-3855-4252-b555-6c0bdb43dcd0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "10858523-2cc8-42fe-8c64-b81d620b5602",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "4041dfdc-cff4-407f-b5f2-2798986d9d7f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "3fe30fc7-1ec7-45b7-824e-de1033c9ab2c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "e3589b4b-efc8-448e-a5af-5f41bfe45638",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "eb96339c-3c4c-4b39-8dbb-46967128fe1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d97f3c62-8e0e-4578-b4fc-ff5cf1a78b2b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "cb6cdb85-004e-44a6-b15a-1fab33d5ba8d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "cfbb800e-d27e-4f53-94ee-b07ed951e057",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "70398dd7-a086-45ac-b91e-72912d800505",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "9aca9baf-fe5a-4690-910a-bc184d4393b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a63a6f8c-62e8-47ef-80ab-797aa7787dfe",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "73dc086f-719a-43ad-a5a4-77ae1e702737",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "72e92d2c-0158-4ab3-8194-2ab827652d49",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "baedccd9-9b99-4088-9912-cc5d5f7d8db1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "8c9550d9-f51b-40dc-b9b1-0baf2710b295",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d9918a42-a4ad-4c24-a00e-7fab87cd2892",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "e15ab8bc-f493-43d3-9bc2-50c736e8ee3a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "470582c3-2690-4bdc-9482-c21593e80306",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "1bc8df3e-0a42-407c-9f65-0d74bcb978af",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "1e5f30f3-db60-41fc-be94-99394652aab5",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f5674449-542b-4fa6-a2eb-eb465ddf60f9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "3e0115af-7b42-481f-acee-badb6ed4cee9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "d82e5669-4111-45c0-ac13-2fba7e575e91",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "e1d91b30-35d8-4a4f-b61d-d5da2fe1e31b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "8413cd02-9a1e-4e99-a021-da94cb98964d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da9bd7e1-7756-4680-9791-7f6e96431209",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "8cece52a-5580-4f53-b4a5-d4d3cb645e1b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "28ff9b09-8bc3-4ed4-b958-06ef93afed1f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "22f1cffe-98c5-4c82-a1c3-e5b481888280",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "72b89f3e-2f02-4e69-925d-b31f19ff38b0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "2db59afe-278f-4b86-bbc4-ac81bfc7e65f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "22",
              },
              {
                _uid: "aba94212-b44a-4db1-a4f7-6fedcee8a088",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "12",
              },
              {
                _uid: "66b7e2f1-acdb-4e88-bba1-16952457391b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "30%",
                maxLength: "20",
              },
              {
                _uid: "50e7d770-6fdb-4263-bfd3-80221c923409",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "10%",
                maxLength: "15",
              },
              {
                _uid: "5fde4761-84ea-4bfa-9373-deec9de1e5d9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "12",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page 15
  {
    _uid: "4458e8f7-e370-4374-9236-fedb568d386c",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: [ "Part 2. Executive Summary (continued)" ],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "12dd2ae9-c92c-4cbb-a27b-508800ccd13d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "64c692c1-9203-42d1-afd0-4f9f92f1c627",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "Part 2f. Third-Party Service Providers",
                subBoldLabel:
                  "Does the merchant have relationships with one or more third-party service providers that:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "77a713ed-4ff6-452a-b734-da1efd99d5ca",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Store, process, or transmit account data on the merchant’s behalf (for example, payment gateways, payment processors, payment service providers (PSPs), and off-site storage)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "f6008d00-b75a-4365-ba05-d8bf3ecbc1ef",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: [ "no" ],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6db36531-1ce3-4165-b52d-9a2374fb8c42",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Manage system components included in the scope of the merchant’s PCI DSS assessment⎯for example, via network security control services, anti-malware services, security incident and event management (SIEM), contact and call centers, web-hosting services, and IaaS, PaaS, SaaS, and FaaS cloud providers.",
                hasLi: "no",
                type: "",
                col: "12",
                width: "75%",
              },
              {
                _uid: "81f787dd-10d8-46b1-a23a-ee14b6023f9d",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: [ "no" ],
                  _uids: [],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "23c7a84b-4643-4273-b554-3f91d30b3e77",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Could impact the security of the merchant’s CDE (for example, vendors providing support via remote access, and/or bespoke software developers)",
                hasLi: "no",
                type: "",
                col: "12",
                width: "80%",
              },
              {
                _uid: "8f9739c3-7fc5-4f0c-b332-f162c9d7aed1",
                component: "col",
                label: "",
                type: "radio",
                options: [
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                col: "12",
                width: "25%",
                doNotDisplayLabel: "",
                resetFields: {
                  value: [ "no" ],
                  _uids: [],
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "078a098c-1de1-42b0-a949-53901fb446b1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: "",
        marginBottom: 0,
        fields: [
          {
            fields: [
              {
                _uid: "",
                component: "col",
                label: "",
                simplifiedLabel: "",
                boldLabel: "If Yes:",
                subBoldLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "100%",
                colSpan: "2",
              },
            ],
          },
        ],
      },
      {
        _uid: "2f338460-a095-4ffb-b4a8-22a3d9fb5893",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        description: "",
        headers: [ "Name of service provider:", "Description of service(s) provided:" ],
        fields: [
          {
            fields: [
              {
                _uid: "f35caf1e-3a60-4746-9ef5-d007213511dc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "28bfc7d7-e540-4e88-95a2-547518438ba6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84b9c58d-9986-4eb0-bc08-7f8cf0c0e524",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "fbd53ce8-3f9e-46b0-aabe-79323c139bfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fd603daf-0b36-4383-aeeb-f58e5692e985",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "399fb414-c456-4931-8808-33c05cfab7bc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "eb0bc36b-82dc-40fa-b7aa-7ff5e0af4cfb",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "0101ea03-da19-4f76-a45b-857dfb4ee9f4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1970ac65-2a00-4f3c-b8d2-5c21077d1719",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "42aeb606-9f62-40f7-99b3-a1f6b12a4b5a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d23c6de6-160a-40e4-b881-e498e2d51259",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "64a6951d-2d21-42ab-9f79-cd0f3366382e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "fe9f7390-8933-4d12-8a05-df59c6cdf31e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "ef7743a3-aa47-45c9-949d-685025e9f75c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8c646ef1-b638-4136-970d-7871d2eeffa0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "135d1557-8797-43f0-a0c8-efc873846530",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "878df552-46e2-4fdd-ae6e-b21c32d017ab",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "9bdaab35-c22e-430a-a756-84d69d7f084a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b84a619d-150f-45a6-be23-0080e3572762",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "45",
              },
              {
                _uid: "9f4dfcce-65a5-4cc6-9508-225e668ea9da",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "600%",
                maxLength: "52",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "07b21b02-0f67-4a37-acba-d860060e9b21",
                component: "col",
                label: "",
                simplifiedLabel: "Note: Requirement 12.8 applies to all entities in this list.",
                placeholder: "",
                type: "",
                textareaRows: "2",
                col: "12",
                width: "100%",
                maxLength: "320",
                colSpan: "2",
              },
            ],
          },
        ],
      },
    ],
  },

  // Page 16
  {
    _uid: "1979dffb-311b-4c6b-a5bd-728b94f3a09a",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: [ "Part 2. Executive Summary (continued)" ],
    caption: "",
    simplifiedCaption: [],
    fields: [
      {
        _uid: "7ffdc48b-43c6-4c98-b0be-708567a854d1",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "ccc08788-a53e-4573-b624-b94ea78b2736",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Part 2g. Summary of Assessment",
                  "(SAQ Section 2 and related appendices)",
                  "Indicate below all responses provided within each principal PCI DSS requirement.",
                  "For all requirements identified as either “Not Applicable” or “Not Tested,” complete the “Justification for Approach” table below.",
                ],
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ccc08788-a53e-4573-b624-b94ea78b2736",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Note: One table to be completed for each service covered by this AOC. Additional copies of this section are available on the PCI SSC website",
                  "Name of Service Assessed:",
                ],
                boldLabel: "",
                subBoldLabel: "",
                type: "",
                width: "100%",
                col: "12",
              },
            ],
          },
        ],
      },
      {
        _uid: "28b86930-17c4-4d25-ab53-d3fccacec03d",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: [ "PCI DSS Requirement *", "", "", "Requirement Responses", "" ],
        fields: [
          {
            fields: [
              {
                _uid: "4a042793-9fa8-40e4-a886-910b49be7f64",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "894c0e11-bdec-4d35-9c08-053a4e0892c5",
                component: "col",
                label: "",
                simplifiedLabel: "In Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "16%",
              },
              {
                _uid: "2a5ef996-9789-4d82-9a7a-85b6ceea4edf",
                component: "col",
                label: "",
                simplifiedLabel: "In Place with CCW",
                hasLi: "no",
                type: "",
                col: "12",
                width: "16%",
              },
              {
                _uid: "dd4bf0c5-bcc7-4fa5-8ffa-916c69770fd5",
                component: "col",
                label: "",
                simplifiedLabel: "Not Applicable",
                hasLi: "no",
                type: "",
                col: "12",
                width: "16%",
              },
              {
                _uid: "b52ca32a-ce27-4a80-ab7e-f57fcf388b4f",
                component: "col",
                label: "",
                simplifiedLabel: "Not Tested",
                hasLi: "no",
                type: "",
                col: "12",
                width: "16%",
              },
              {
                _uid: "35d88a10-345f-4474-9c5a-d36b8f4164a0",
                component: "col",
                label: "",
                simplifiedLabel: "Not in Place",
                hasLi: "no",
                type: "",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "51d357ee-4d64-4701-971e-b0bcd5bff181",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 1:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6a2e1eb7-0335-40eb-9e70-c57038e41aeb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "30283186-8784-45bf-b8a1-f1a3287a5c23",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "58a2ee47-768f-4c63-a131-fd126a5c125f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "a5f130e1-d2eb-4ae7-8450-829c8b4544a2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "d4807ba0-29ce-490a-8aec-f17fb1d85595",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_1_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "be7e92ae-e202-4df9-8340-8c8e38738fdd",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 2:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "83483870-440a-4692-87c0-bd4b452cc5e6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "3f957dfe-807a-44ea-9d07-5341d0c04327",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "99b311d0-504d-4835-a4e6-d918a461561c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "71684da6-f18a-4773-9e13-ee07dab1ce44",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "3320a5b6-414d-4d2d-8cf2-38a54f01a264",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_2_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a89de058-db5e-4a7d-907f-340c6cc5b873",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 3:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d74498b3-96f3-4ea3-9bd2-8a054d8fc876",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "2b03a47c-d91f-4853-92f9-5e7e80fcc6d0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "e94cee9b-0a6f-4677-ae95-4f69775b638d",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "84c0ed98-5ce1-40df-992d-da6cab16b510",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "f763fa5e-8e3e-4058-9a34-088057f216dd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_3_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7a3a33b7-8928-4d72-bd5d-bf22e96eb715",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 4:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "dc2f913b-9138-4add-b5da-3c5492b86527",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "55b4351d-3e10-4770-bf24-e9e076ced7af",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "a9a188ae-5ff3-4b48-80aa-6494150b0a10",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "ce9ac983-c1a7-4d76-8cb7-8067e365514c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "e61db5c5-bdaf-4064-844e-c231ca0bad07",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_4_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a30443b1-95c9-4769-aae3-0a816c102b5e",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 5:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "c4cc5916-8e94-47b4-a07a-8a4e49ae5a80",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "f4b84bf1-344c-4e17-82f2-e94faf1b50d9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "43a7e864-dc18-433c-b328-a6d367d66089",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "6fe45241-d04a-4e50-86be-6e8fd3b55ba0",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "8252e2f6-96ed-45b8-be11-c5973253ce14",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_5_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b4d424b9-913d-4c37-a468-8b7f57d705d1",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 6:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "a19bb29e-d722-4863-90d0-3c486cb85118",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "68e7f630-a0b1-491c-89a2-f6115f3e3316",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "859de499-676f-4ddd-84ff-bbd282d3d616",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "de17a526-a7e9-4151-be86-7a7dd4517090",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "07299892-5bf3-480d-888f-8cdb4f097f7e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_6_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "871e1bac-9b07-402b-acff-e5830369b8bf",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 7:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "5004e877-881d-48dd-a07a-bbdf08734692",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "ec5fe712-203f-47c0-92fc-f03c3aa702e4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "ae0dbf9f-b780-490f-9b82-ec3e70e7786f",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "f35dfe4c-ede8-420c-8503-8bdab40c04b7",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "4c9f1905-43ee-4b19-b37d-ddb00553c2e9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_7_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "8e249f70-e94c-4fea-a0d8-2ef0f4e3a168",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 8:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "6785db61-e5fa-4ee6-a999-0b77dd7c2492",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "7b7a9017-5ad1-4e63-b999-9f32b48a8e54",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "cee30fd0-06b2-4e5e-9df5-27eb3ded7f74",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "7ef257be-f653-4984-a4c7-6b04f5a485aa",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "c47fbe40-d723-41ff-a616-2dd335369c08",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_8_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "afc55d56-558c-4972-999c-647b52b319c0",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 9:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "112fdc6c-d2ba-4884-be04-8ffd5eccafb5",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "c0700179-ddd9-413c-a9f0-9bdc04b00108",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "3d1bdb4f-532a-4b89-94ed-1af2c997b866",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "a7795f6a-9ddb-483a-8ee6-3765ce74b41b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "bffb79f6-dbb8-4f1b-8ac5-0f2bb32d5210",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_9_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b1c2e826-1f53-4085-b667-73641e15621a",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 10:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "f8e36543-61f1-4766-906c-d395210b15ff",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "994e3f62-4bc4-4928-a24c-e6ef705e55ce",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "257fe755-9846-48bb-b31c-6fd2948ad229",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "bc588eb6-f408-4e95-9deb-d91197e3a296",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "c152ecc3-6a36-4001-ab17-25237af736fb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_10_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1c4e1fa-d2ef-4eec-aa61-93d01419b8b5",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 11:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "d985904e-543b-46c5-abf3-496c389a0c67",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "6ea5fa98-f6cd-4e59-9758-91fc6d703c82",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "526b27a9-f398-4940-96e2-37afe1393309",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "5c3268c0-d19e-4a1f-b674-73518463da8c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "eeee435a-0da8-4611-af63-6cc6367af20b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_11_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "56c7306a-4cbb-46ab-8f21-c84926a5ffff",
                component: "col",
                label: "",
                simplifiedLabel: "Requirement 12:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "fca7f4a9-f065-4f18-a367-130e62dc1e04",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "fb698b06-b4a8-4614-bc58-8357e5c2dad6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "e863bdc1-4d51-449e-ba9b-f8cfa68f7b07",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "16de5c41-388b-473d-bd82-6befe7893962",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "20e88de4-ff63-491d-9422-d1db9a480d77",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "requirement_12_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a68eeb90-c55f-4e52-b5a0-e0bd217b6c8e",
                component: "col",
                label: "",
                simplifiedLabel: "Appendix A1:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "af6373c1-cec5-445f-b7f7-cad4eaf55acc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a1_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "2a532078-c575-4937-9988-e1fa6c4cdd29",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a1_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "a6701180-f342-42f7-a65b-f5d42d43650b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a1_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "85636a81-4aab-4057-b2ae-91b5ef9bf4cb",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a1_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "109769bd-56ac-4de6-b723-1cb61a268244",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a1_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "73efe58a-f8df-40e1-8de4-4168f9405396",
                component: "col",
                label: "",
                simplifiedLabel: "Appendix A2:",
                hasLi: "no",
                type: "",
                col: "12",
                width: "20%",
              },
              {
                _uid: "adfcf7ba-09f7-40ae-b59b-eb134c0003b6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_in_place",
                col: "12",
                width: "16%",
              },
              {
                _uid: "bd001013-355a-4571-a888-d16a377e77d3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_in_place_with_ccw",
                col: "12",
                width: "16%",
              },
              {
                _uid: "ba36db02-2f73-41ed-a131-000de0bf3e03",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_na",
                col: "12",
                width: "16%",
              },
              {
                _uid: "270caa5b-9620-4acf-8f14-ee6c0a3c788a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_not_tested",
                col: "12",
                width: "16%",
              },
              {
                _uid: "207972eb-b828-47af-bf7d-a9a07a51666a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                hasLi: "no",
                type: "checkbox",
                value: "appendix_a2_not_in_place",
                col: "12",
                width: "16%",
              },
            ],
          },
        ],
      },
    ],
  },
  
  // Page 17 NA
  // Page 18
{
  _uid: "feb41e01-a94e-4109-b23b-fc6f93f1ab8c",
  layout: "form",
  component: "page",
  label: "",
  simplifiedLabel: "Storage of Account Data",
  caption: "",
  simplifiedCaption: [
    "Identify all databases, tables, and files storing account data and provide the following details.",
  ],
  fields: [
    {
      _uid: "12e143ec-e660-4cdf-8613-f3641ac7e07b",
      component: "table",
      label: "",
      simplifiedLabel: "",
      type: "table",
      caption: "",
      simplifiedCaption: "",
      headers: [
        [ "Data Store", " Database name, file server name, etc." ],
        [ "File name(s), Table names(s) and/or Field names" ],
        [ "Account data elements stored", " For example, PAN, expiry, name, etc." ],
        [ "How data is secured", " For example, what type of encryption and strength, etc." ],
        [
          "How access to data stores is logged",
          " Description of logging mechanism used for logging access to data— for example, describe the enterprise log management solution, application-level logging, operating system logging, etc. in place",
        ],
      ],
      fields: [
        {
          fields: [
            {
              _uid: "100946b1-0772-4563-99f6-3c555d46d949",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "01cc9b91-11a3-4b9e-9f5e-3ce7e479b739",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "ddef79cb-1502-4c7f-b438-1eb48f2b2a9d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "370a27c6-f0ae-4fbe-8016-e3a22c591abf",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "8a85bd2a-9e25-4aa5-9114-84c2c8019055",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d76e7067-8e51-4ae0-b60e-294b7327e444",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "0c749577-e89d-475d-8db5-7b0f4766a6d7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "45082270-f801-44d1-a6ab-2be7542f8d29",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "a3f9b8ff-1e4b-4e8b-880c-9a078a086eb0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "0dc3bcf9-18e1-4fb0-be1a-9eb69412f80e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d75d9219-6b70-4bf7-a4e0-605a4277dd14",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "4c25b76a-1820-451e-a9fd-774e6dab86a8",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "dcb425e2-2eff-4e53-9615-271c9f0bef2b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "d3603d2e-bbd6-440a-b30d-be226484e396",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "92db3fbe-a5a7-4b7f-a96d-28806c97c813",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9ba2d857-0bae-4212-851e-49e1f87c6441",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "074aece0-b005-41f1-b68c-57c439fc6dbd",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "4d02e47a-af7d-4edd-8f47-783e51dc0f47",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "e2e02fd9-94b2-454b-9de8-d48a29bc7bf3",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "47ce9c3c-d896-4553-aae5-3df8c3064320",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ba340984-b926-4eb5-964f-12d439b8f574",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "b0e8ed75-6d96-4458-a515-ad9457d1980b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "fc34dde9-5617-4abb-bc84-7bccf42c7422",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "f65f9e1e-305d-410f-bd2f-44f05e8ad140",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "ea49a8cf-2962-4f6d-a594-f28f1bfad7dd",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "564c3cda-04fc-43c4-8c48-785586e6105d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "336b01a5-5bd8-44ff-9ae7-825f948ad0f6",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "8dd322b5-8dd0-4d50-a8a7-9d87da825447",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "d57c7b47-efb2-46e5-b4fd-7c3c97f56b10",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "4aa34ccc-a49c-4bb3-99a1-5482aacf210e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "36afc19d-3e7c-4fd9-8d47-6693921caedc",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "667cb43b-3dfb-4fbd-93f8-0fb4d5da97f5",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "4f8e78d7-3d6c-48c1-818f-e90e259985d2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "e457fe91-5a1b-4eed-93cd-b0fe3342c375",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "20ee5082-083d-4b38-99ea-cb4f9a010b93",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "63391d3e-8e68-4125-beb8-e6d4a342f284",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "fdfd9ce5-b305-4ce0-9279-2ff5371dde68",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "28",
            },
            {
              _uid: "6e6df016-8bb7-4b3e-832e-4ed3f0a177e7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "f038fbed-59e8-41da-9b7b-d9e94b0d81f4",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "30",
            },
            {
              _uid: "4df37e3e-5dfd-4640-80a6-2dda6ac649ae",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
      ],
    },
    {
      _uid: "7be1e082-6353-4dd2-acf5-67ec6ac20a39",
      component: "table",
      label: "",
      simplifiedLabel: "",
      type: "table",
      caption: "",
      boldCaption: [ "Storage of SAD" ],
      simplifiedCaption: [
        "Identify all databases, tables, and files storing Sensitive Account Data (SAD) and provide the following details.",
        "Note: The list of files and tables that SAD in the table below must be supported by an inventory created (or obtained from the assessed entity) and retained by the assessor in the workpapers.",
      ],
      headers: [
        [ "Data Store", " Database name, file server name, etc." ],
        [ "File name(s), Table names(s) and/or Field names" ],
        [ "Is SAD stored pre-authorization?" ],
        [ "Is SAD stored as part of Issuer Functions ?" ],
        [ "How data is secured", " For example, what type of encryption and strength, etc." ],
      ],
      fields: [
        {
          fields: [
            {
              _uid: "a78ac25f-312a-4586-93ca-285a3bf72744",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "34fbb0af-4797-47b4-bf82-9dec662d1863",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "901c90c6-a8c6-45cb-b588-9f9c1304a409",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "502c17f2-2864-4a02-b94a-7c05dba41eb2" ],
              },
            },
            {
              _uid: "8fda2a97-53be-4bda-9099-65a30fa9e0e4",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "1375f30b-b265-4c90-8175-e04945604fde" ],
              },
            },
            {
              _uid: "9a5b4356-1491-4956-814b-384a83fc522c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1632a760-5c12-43b7-97ab-1f8a1e8b14ff",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "6304b3b7-5f58-488c-a9ad-7483a3a1e6d5",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "16a21db2-9c75-4204-960c-bb519b811693",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "02d49b5d-97d7-4788-b80e-8b37b047c1c1" ],
              },
            },
            {
              _uid: "0ea29e8d-7078-47fe-a703-1fd8d24cf425",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "019e7728-80c6-462f-bd52-71ac5a0161c4" ],
              },
            },
            {
              _uid: "298d3797-2efc-4add-83b8-893069408cd9",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a25aaa91-d73c-479a-b91f-d53ddfe6155c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "89e0df97-1256-4be4-8603-a12cc3cadabb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "dcd3694e-d546-4c58-b22d-f60515669cc8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "18267bec-8b89-4e44-b374-2740584c8fa3" ],
              },
            },
            {
              _uid: "4c9aa9a3-1813-4db3-a209-1873dea2e975",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "c3b1e3fa-198c-432e-83cf-af6e09623cd0" ],
              },
            },
            {
              _uid: "435d2ef8-d032-4b67-8c08-213b0358f38d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b88b078b-8264-4084-8292-3568436a40ee",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "28e17b3b-2449-4d16-be2d-4b96392d57ab",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "64d6615e-b6a1-40d8-956f-4fc1b933a8be",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "6b2ac186-4ad9-4df9-9755-c3c94a14c97b" ],
              },
            },
            {
              _uid: "b739cfbe-2bc0-4ded-b655-2d6369e0b70b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "8d06d526-5a56-4a6e-b17d-386015bf1593" ],
              },
            },
            {
              _uid: "aadc6caf-d90f-4f9f-9ff4-dff2f954c97c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7c7b63bc-3a5e-46a5-8645-ba336c7b8361",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "65dad2b1-3c62-49c0-a9e8-7a0db6c76797",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "5063ac8b-b61a-4b42-936c-0449d4d6deac",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "33ed8eed-feea-413f-9a0b-5a377fb6d624" ],
              },
            },
            {
              _uid: "4e5ac268-7b77-469f-bbce-2c6bd93fe55c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "0912d1b3-2d88-4995-8f95-2e93aa4f450b" ],
              },
            },
            {
              _uid: "b8c87f04-05ef-4eb1-ba1a-2509d2bcbaf8",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8226bae8-d5ed-4a4c-8693-d797f2353b1d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "f9f76b06-9866-4985-be72-c6083aed2698",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "d6e3a9f2-5dbc-44a8-92f2-4f207cdd4750",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "5548f2fa-8db1-41ff-8cfc-1d433dede042" ],
              },
            },
            {
              _uid: "5d071ed9-337c-4b33-b188-2a6725400f38",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "4f09fd4a-1375-465f-a39c-79d2e3128769" ],
              },
            },
            {
              _uid: "1465a998-2a32-48ba-8ad2-f8f2103e2e4e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3ef93691-ce11-48b7-a5f0-4e839258b10d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "d1f3cacd-5256-439b-a2dd-5f6cdfbcc468",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "b53258d1-05db-4cc6-9ca9-fa4167630641",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "ea77ea30-618d-40bc-b2a1-3a9ac29dbef3" ],
              },
            },
            {
              _uid: "ebea7c70-a257-4017-8df0-b58ece919830",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "87841a44-2f22-4ba6-9639-9b65f640b569" ],
              },
            },
            {
              _uid: "108642a4-9117-4358-b7ca-1bd26620f1a7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5265a3e4-ea9c-499c-8f74-9da8002add13",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "18",
            },
            {
              _uid: "ff853e3f-fb7e-4b32-956c-d1cebc0b6c57",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "32",
            },
            {
              _uid: "6bff2004-3f7a-4e7e-b938-2c3e985de4d1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "3363adc9-2a7f-45d5-9985-df054f328015" ],
              },
            },
            {
              _uid: "403183f7-258c-41bd-afb1-bfb2e6f664da",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              value: "yes",
              options: [
                {
                  component: "option",
                  label: "Yes",
                  simplifiedLabel: "Yes",
                  value: "yes",
                },
                {
                  component: "option",
                  label: "No",
                  simplifiedLabel: "No",
                  value: "no",
                },
              ],
              width: "20%",
              resetFields: {
                value: "yes",
                _uids: [ "71dc6805-dfb1-489f-8d6c-37a4af72061d" ],
              },
            },
            {
              _uid: "5bf432a4-30ff-4c28-97b3-70838919ab66",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "",
              type: "textarea",
              textareaRows: "2",
              col: "12",
              width: "20%",
              maxLength: "52",
            },
          ],
        },
      ],
    },
  ],
},
  
  // Page 19 NA
  // Page 20
  {
    _uid: "e19dcab4-5bc9-468c-9552-73e344cfce26",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "",
    caption: "",
    simplifiedCaption: [ "" ],
    fields: [
      {
        _uid: "b1eccf44-b266-4c88-af54-dcd4a9c1399c",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [
          "For each in-scope system component type, even if it resides within another system component, list below with each component with different roles, vendors, or make/model/version on separate rows. If extra rows are needed, document that separately and consult with the entity to which this SAQ will be submitted about how to provide that information.",
        ],
        headers: [
          [
            "Type of System Component",
            "For example, application, firewall, server, IDS, Anti-malware software, database, etc.",
          ],
          [ "Total number of system components", "How many system components of this type are in scope" ],
          [ "Vendor" ],
          [ "Product Name and Version" ],
          [ "Role/ Function Description" ],
        ],
        fields: [
          {
            fields: [
              {
                _uid: "d88b0acd-66bb-4777-9ea6-b2b2c51f587b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "28f8de9f-69a6-415a-af3d-0fe9c6153347",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "85b10dff-5276-45c8-a2ed-59cd01892683",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "dbe37aa9-13e1-4256-8221-03454b656118",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "d6b11029-d05a-4a65-bbf1-0f2412249018",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "907fc9b7-dc89-4290-80a3-527a650b953e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "10432eb1-7504-4281-93eb-4227c7f39892",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "8c9be5ca-7ee3-4ec9-b1e0-b9e72d299d04",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "06ca7467-83a8-4f03-a6f3-2113c50e1f81",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "c58fe3ad-8c5b-41b2-b317-000e3d08e43c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "0a2603a4-d741-470c-9798-758909c6840b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "a783df3d-8982-49a2-a478-3f170d753e33",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "c191a0d9-0f03-4372-99b4-431c7d164138",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "39ac5af2-b7b9-45de-9dc4-65f0bf09bc18",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "6d0be6af-b315-4079-9d18-fbc88bf9ae07",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b1f65d79-7a64-4fe9-94cb-e00b184e62ce",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "7720bc80-9aa8-490f-85bb-be50e885ef05",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "3025c8d0-3af9-4b94-b6ba-8fa348501528",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "7ee100be-7b88-4a5c-84fd-a30a5ab84221",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "60f165cf-b242-4113-9505-b538a299a03c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "715fdf2b-e3c2-4d1c-8efd-9ce087de2fa4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "750b5502-f3fd-4efe-b777-16fb07282382",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "d51438fe-2d5e-4ff6-977d-9678d74fe3d1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "b59fa4dc-2b82-4e38-995f-320de03886ac",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "08346f70-db8f-41d9-9364-a3b3e8638445",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4ffafc2c-bfcc-48ed-8f03-c6044a115f96",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "6be02fa4-9810-4584-8b89-fa941982db35",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "7fed4039-3b93-4528-8316-9b1031904779",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "303ae8e3-0312-4dd4-a044-3a546c773309",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "f395e1ed-b4ba-4189-851c-bc37b58d500e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b4ab6520-c46b-48c0-9c08-633efc40718a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "2f8ca2a2-1ef2-4279-8d25-ec6b6c0aeef0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "b2e2e3c3-136d-44b6-bf78-a54155f9acab",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "6c4022eb-abf0-44d5-ae9e-60601a48b017",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "337abccd-fe26-4aaa-bd8a-15e7c0f15c68",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "25190474-2bd2-4951-b295-9b8655238108",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "ac78b883-6d7e-4ac1-9ca9-f235556cf5f1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "56a559b9-a208-4e79-a104-e69b087ca7e9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "e8ae387b-3dfe-43eb-a00d-755c31e6ab60",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "14667eab-a9b9-4b42-99e6-fec15494a421",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1463c81-969f-4406-9855-4450b2a59c5d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "08c971d9-2b68-4fc3-9175-2e5e859d3503",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "10c1cbb8-84c1-40ca-9172-24c3c61bd723",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "e7da5640-ff72-45b2-9e00-68cd043a1fa0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "5261cd15-3807-4687-afe1-f65cfc9e224f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d28c532f-f3be-4c8e-8302-8664b01d881c",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "cf0957ed-0e44-4dab-b5b3-b0fa640655ce",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "d7945d26-6af9-4028-9ef4-02adf3dc2b6e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "e0281d75-2814-4cb6-b64a-a72dc181510e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "c583d352-19de-4bf9-924c-389aa4a4cd66",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b202743d-ea71-4d35-b27b-b43af8d91a4f",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "51048b07-3d32-4cd8-80f3-cc0bfab9febf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "21fd3519-f12d-4612-b8ce-aae32dc56bab",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "5571e91c-b5c9-4f80-960e-aebc2a261533",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "94dee268-3987-4529-bdfc-f4e521d24992",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "defbfc7d-9c0f-4576-a86b-6db23e3982c3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "02dbb8d5-026d-4bcd-81cc-aaf5823a31b8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "05b11faf-3f51-4285-95ee-3ebb41493368",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "4f527f8b-2135-432c-80f4-fae3e7e09407",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "6f00fa42-4e9c-4ed7-8ffa-6d5d04ffec29",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "b34618b4-1a64-447b-91e5-04f89f1d3247",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "4c8ebbd5-0bd6-4572-9c5b-1294a7e5ed83",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "65e3b940-5140-4656-a71e-6e265bd5f250",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "ead1b821-30f3-4227-94ac-15c5eee5b1be",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "52eaf7f6-367c-4dff-9ef8-d710205b09f9",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ec4248e9-ee89-4712-a1ce-7c7987047222",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "f4f43799-f48f-4697-a214-3518c8c070ae",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "47ac2e32-dc0f-4f57-8240-b9d1627c9690",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "6eeb4cb5-72ec-41dd-beff-24b41e5a7d8d",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "712796a5-a2cb-4862-89af-508916b9c5a3",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "20ab05d8-f6eb-4156-aa0c-acc095480572",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "c3e0240b-53fc-4cb4-841a-d3952892fc58",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "258d3082-4fc0-4d70-9895-300d5fdddc98",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "c3c8bae5-6cda-4c48-8786-f8dc8975f40a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "3806094e-18ea-4909-ac70-637cc4d416d8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7aa6d995-669c-4e67-9cd9-fe7618a9db83",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "e3a4f2c6-dadd-43da-b826-30b13bb661e1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "bd724275-dc01-4a6e-952f-df72a9c569e4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "ba9269d0-7c09-4f00-a747-3e644305dd33",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "fb7080bb-be0a-4b5d-ba89-64bb026b3b44",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a7e6b2c8-e3d8-49d9-85df-c30f093f91a0",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "e418fb83-9fb4-4873-98c6-8eba525dbc4a",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "118e50f6-9ce8-45f9-908b-0efa96506798",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "bd151279-6c7f-414d-96b8-4aed98d137d6",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "229011d0-9011-42ea-8c50-abee8c848701",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "889c0aee-4ff4-48e5-b0e7-e26dfbb3cf87",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "29",
              },
              {
                _uid: "fa1254c0-0d88-4bfe-925e-557d20c98d5b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "26",
              },
              {
                _uid: "fba4396f-001b-4ae4-93e6-7cf41d7202e1",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "22",
              },
              {
                _uid: "8adf06ee-8920-459b-9801-c45c56ce69ec",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "21",
              },
              {
                _uid: "d599680e-29ce-4624-846b-a02f65dd42da",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "20%",
                maxLength: "44",
              },
            ],
          },
        ],
      },
    ],
  },

  
  // Page 21
  {
    _uid: "feb41e01-a94e-4109-b23b-fc6f93f1ab8c",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Quarterly Scan Results",
    caption: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "7be1e082-6353-4dd2-acf5-67ec6ac20a39",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: [
          "In the table below identify each quarterly ASV scan performed within the last 12 months.",
          "Note: It is not required that four passing quarterly scans must be completed for initial PCI DSS compliance if the assessor verified:",
          "The most recent scan result was a passing scan",
          "The entity has documented policies and procedures requiring quarterly scanning going forward, and",
          "Any vulnerabilities noted in the initial scan have been corrected as shown in a re-scan.",
          "For subsequent years after the initial PCI DSS review, four passing quarterly scans must have occurred.",
        ],
        headers: [
          "Date of the scan(s)",
          "Name of ASV that performed the scan",
          "Were any vulnerabilities found that resulted in a failed initial scan?",
          "For all scans resulting in a Fail, provide date(s) of re-scans showing that the vulnerabilities have been corrected",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "78343e0a-6858-4904-87f6-2382c3722e82",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "0da4a00e-36a8-4162-b1da-8699a5520afe",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "8c266a04-068b-4276-b984-ed3906182ac8",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "10%",
                resetFields: {
                  value: "no",
                  _uids: [ "c1faa7b3-480f-4452-8dd7-10f2a30bf5bf" ],
                },
              },
              {
                _uid: "71220ca4-8a25-4dfc-b10c-1b6620905d55",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "71",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d220d636-db80-4e9a-8dff-c6ee9971174b",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "1511a487-c968-4097-bfc1-a9fad45348c4",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "3960eb0e-6c40-4046-906a-2b66059f9275",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "10%",
                resetFields: {
                  value: "yes",
                  _uids: [ "e9a4b4af-d2cb-4a70-807d-ea23666b07ae" ],
                },
              },
              {
                _uid: "78c5e7e6-8030-47b6-9a97-81ab89987f06",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "71",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "e45986e8-2532-43da-af1e-52f651e5ca5e",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "1071ebe4-a894-4305-b2b9-765cf58c3adf",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "8cfabfc0-226b-4484-84fc-0b2d648d2492",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "10%",
                resetFields: {
                  value: "yes",
                  _uids: [ "0b74eb92-b944-4dd6-bcdd-bfa2c436fe84" ],
                },
              },
              {
                _uid: "43bdd74c-fd09-4efe-9448-6c3c99d3cf07",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "71",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "786904d6-11fe-4b14-80c0-5e02ee3f1320",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "3ffd0671-4e05-44e2-891f-600a4c7ebcc8",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "25%",
                maxLength: "28",
              },
              {
                _uid: "f520c716-4d6b-4522-8551-034a23113a36",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "10%",
                resetFields: {
                  value: "yes",
                  _uids: [ "c92bf175-0e59-4b09-a28a-d5c98b2561d5" ],
                },
              },
              {
                _uid: "43a65bb6-37e5-4ef6-ba28-28ed6dd91cdc",
                component: "text",
                label: "",
                simplifiedLabel: "",
                placeholder: "",
                type: "textarea",
                textareaRows: "2",
                col: "12",
                width: "40%",
                maxLength: "71",
              },
            ],
          },
        ],
      },
      {
        _uid: "7704e055-5b3a-4e87-914b-966b792757e8",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "5d4b1736-abaf-460a-89aa-795e3363dc00",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Indicate whether this is the assessed entity’s initial PCI DSS compliance validation ",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "60%",
              },
              {
                _uid: "7834bf02-138d-49bd-abb3-e530c90886f2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "10%",
                resetFields: {
                  value: "no",
                  _uids: [ "70886967-a3be-4b5e-a793-c966bbe8fbff", "7ae6e25f-695d-4c8c-a18a-b5998e683acd" ],
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "da0e021e-8dee-487b-867c-097d866b897a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "If yes, Identify the name of the document the assessor verified to include the entity’s documented policies and procedures requiring quarterly scanning going forward.",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "60%",
              },
              {
                _uid: "70886967-a3be-4b5e-a793-c966bbe8fbff",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "2",
                maxLength: 120,
                col: "12",
                width: "40%",
                conditional: {
                  value: "yes",
                  field: "b54a4fdb-2dbb-4362-b3b3-e8e48b8b0771_7834bf02-138d-49bd-abb3-e530c90886f2",
                },
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ddb14171-a0dc-4002-8ac6-17596a62eee7",
                component: "col",
                label: "",
                simplifiedLabel: [ "Assessor comments, if applicable:." ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "60%",
              },
              {
                _uid: "7ae6e25f-695d-4c8c-a18a-b5998e683acd",
                component: "col",
                label: "",
                simplifiedLabel: [],
                hasLi: "",
                type: "textarea",
                textareaRows: "1",
                maxLength: 74,
                col: "12",
                width: "40%",
                conditional: {
                  value: "yes",
                  field: "b0f9ffd5-2f9e-4109-9f69-20866c74f553_7834bf02-138d-49bd-abb3-e530c90886f2",
                },
              },
            ],
          },
        ],
      },
      {
        _uid: "283b9226-4733-46c8-a2d6-3c7d3a83cfec",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        boldCaption: [ "Attestations of scan compliance" ],
        simplifiedCaption: [
          "Scan must cover all externally accessible (Internet-facing) IP addresses in existence at the entity, in accordance with the PCI DSS Approved Scanning Vendors ( ASV ) Program Guide.",
        ],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "7d5b5d11-c29d-429a-81d4-e7401c641cfe",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Indicate whether the ASV and the entity completed the Attestations of Scan Compliance confirming that all externally accessible (Internet-facing) IP addresses in existence at the entity were appropriately scoped for the ASV scans?",
                ],
                hasLi: "yes",
                type: "",
                col: "12",
                width: "60%",
              },
              {
                _uid: "81fcef2c-5bbd-44b3-8422-044b09fc0c9c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "10%",
                resetFields: {
                  value: "yes",
                  _uids: [ "c42b91d7-9839-423d-8462-2227fab57e54" ],
                },
              },
            ],
          },
        ],
      },
    ],
  },
  
  
// page 22 - 140
{
  _uid: "f239cdfc-6976-4ab0-8155-9e0af1f9e8e7",
  layout: "form",
  component: "page",
  label: "",
  simplifiedLabel: "Section 2: Self-Assessment Questionnaire D for Merchants",
  caption: "",
  simplifiedCaption: [
    "Note: The following requirements mirror the requirements in the PCI DSS Requirements and Testing Procedures document.",
  ],
  fields: [
    {
      _uid: "e5988b84-e67e-46f2-a1bd-7dd082524f62",
      component: "table",
      label: "",
      simplifiedLabel: "",
      type: "table",
      caption: "",
      simplifiedCaption: "",
      headers: ["", "PCI DSS Requirement", "Expected Testing", "Response (Check one response for each question)"],
      fields: [
        {
          fields: [
            {
              _uid: "3b5ca71f-e339-4c63-9426-3973a292a5d3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "65%",
              colSpan: 3,
            },
            {
              _uid: "9f739807-7c2e-4d13-a3b6-a254049ab92d",
              component: "col",
              label: [""],
              simplifiedLabel: [""],
              hasLi: "no",
              type: "select",
              options: [
                {
                  value: "in_place",
                  label: "In Place",
                },
                {
                  value: "in_place_with_CCW",
                  label: "In Place with CCW",
                },
                {
                  value: "na",
                  label: "Not Applicable",
                },
                {
                  value: "not_tested",
                  label: "Not Tested",
                },
                {
                  value: "not_in_place",
                  label: "Not in Place",
                },
              ],
              col: "12",
              width: "35%",
              colSpan: 2,
            },
          ],
        },

        // 22
        {
          fields: [
            {
              _uid: "2e7ad09e-e0f9-4133-98e5-80f08fc1cf98",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Build and Maintain a Secure Network and Systems",
                "Requirement 1: Install and maintain network security controls",
                "1.1 Processes and mechanisms for installing and maintaining network security controls are defined and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "71c1f488-9018-4179-9b83-e6da58500fc4",
              component: "col",
              label: "",
              simplifiedLabel: "1.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "20bb8d2a-3bf2-4005-87f9-64a6a3398b68",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 1 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "1ba286a5-fa9b-4866-8439-3b49f3e3b822",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d742abf0-34cf-4c07-9133-2656503b848d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["933b4ad2-3114-4284-bf3a-d1a7fd295eac"],
              },
            },
            {
              _uid: "933b4ad2-3114-4284-bf3a-d1a7fd295eac",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "16318ac7-3394-4213-8799-525c4a85dd71_d742abf0-34cf-4c07-9133-2656503b848d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4826083d-7c3e-49bf-97d1-1edd17a8b707",
              component: "col",
              label: "",
              simplifiedLabel: "1.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "d0ae5488-32d7-4af1-aa8c-33d14e2b08d8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 1 are documented, assigned, and understood.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "88269f4e-535a-41d1-869c-dc9e9a988a79",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b743e9ec-55f5-4b06-b70e-9f08b77350c8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["06530338-655e-4988-93ae-1be6c781d08a"],
              },
            },
            {
              _uid: "06530338-655e-4988-93ae-1be6c781d08a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "7fbe6146-c936-4c48-bce2-052422989d2d_b743e9ec-55f5-4b06-b70e-9f08b77350c8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "10206585-7eaf-4b44-88ac-0bbe15f55f27",
              component: "col",
              label: "",
              simplifiedLabel: ["1.2 Network security controls (NSCs) are configured and maintained."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "fe10fbc5-803a-47e0-8d0a-fbb4727ad4f8",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0e5fc1c9-c8c7-4a29-83ad-001aa86ba289",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Configuration standards for NSC rulesets are:",
                "Defined.",
                "Implemented.",
                "Maintained.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ec3d46f6-2912-4f22-be00-79a79d8d5bee",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine configurations standards.", "Examine configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f7b97316-ceef-4585-85a9-15b0001fef79",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["399a9324-2caf-4ad9-97de-0524f08ab72e"],
              },
            },
            {
              _uid: "399a9324-2caf-4ad9-97de-0524f08ab72e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "45074d97-3bdf-4768-aaea-46bcd4d6193f_f7b97316-ceef-4585-85a9-15b0001fef79",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 23
        {
          fields: [
            {
              _uid: "032bbe7d-a2b7-42b8-b3a6-f8f5fda56c47",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5ce2d7e4-e5f6-49a1-97fd-97263f315335",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All changes to network connections and to configurations of NSCs are approved and managed in accordance with the change control process defined at Requirement 6.5.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "cf3724f1-850d-4d33-a2b7-cc5cada07989",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures.",
                "Examine network configurations.",
                "Examine change control records.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "a07f4f45-a5fe-4b4b-b792-3d635ffc96cf",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["34d11abc-90af-4ae9-9bd6-3e80bf1409f0"],
              },
            },
            {
              _uid: "34d11abc-90af-4ae9-9bd6-3e80bf1409f0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "566dee03-c16b-4361-9b08-8cab71022c84_a07f4f45-a5fe-4b4b-b792-3d635ffc96cf",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b1c3ab41-0773-4f7e-b713-1200411cbdfd",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Changes to network connections include the addition, removal, or modification of a connection.",
                "Changes to NSC configurations include those related to the component itself as well as those affecting how it performs its security function.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ead7f710-1a0a-44b7-b400-84a99193596f",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e882581f-f27d-441f-9222-976bc22af102",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An accurate network diagram(s) is maintained that shows all connections between the CDE and other networks, including any wireless networks.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "9a6bc307-00fa-4a43-bef0-f80ac6f68884",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine network diagrams.",
                "Examine network configurations.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "04d61978-28a7-47be-9176-a17005adec19",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2851905b-3803-415d-9f63-d685de755d6f"],
              },
            },
            {
              _uid: "2851905b-3803-415d-9f63-d685de755d6f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "a93380dc-8864-4d05-a7dd-f0e134a36d8c_04d61978-28a7-47be-9176-a17005adec19",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3f1f41d6-505f-4355-94b6-27ac5ca54bee",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "A current network diagram(s) or other technical or topological solution that identifies network connections and devices can be used to meet this requirement.” This includes files, automated and system-based controls, scripts, settings, infrastructure as code, or other parameters that are backed up, archived, or stored remotely.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 24
        {
          fields: [
            {
              _uid: "b35f5f1a-2008-48d7-8347-4d44246db556",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5d8eef2a-14fa-4e46-be13-b8432df7de6a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An accurate data-flow diagram(s) is maintained that meets the following:",
                "Shows all account data flows across systems and networks.",
                "Updated as needed upon changes to the environment.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fa21ffa0-dd68-4ea3-acca-69311021d26f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine data flow diagrams.",
                "Observe network configurations.",
                "Examine documentation.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "86301a0b-152a-46d8-a244-9a98d21a6c7a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c3b953d4-5297-4731-bffb-cb96896ca98c"],
              },
            },
            {
              _uid: "c3b953d4-5297-4731-bffb-cb96896ca98c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "bdd0929b-80f2-43a6-b437-a52c351db7d6_86301a0b-152a-46d8-a244-9a98d21a6c7a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7b3f3ab5-0866-4337-9977-bab03175629d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "A data-flow diagram(s) or other technical or topological solution that identifies flows of account data across systems and networks can be used to meet this requirement.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "35d8651c-b379-4016-88cc-f24a07569683",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c83d561d-52f8-4726-aff2-ed6db7929c6c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All services, protocols and ports allowed are identified, approved, and have a defined business need.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2ce73a01-accb-406e-8660-c79301c8f0cf",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Examine configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cdaa3646-53db-4ae4-81e3-e23e8058442b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d31a0e2c-00f6-4d4b-a58b-31f586135659"],
              },
            },
            {
              _uid: "d31a0e2c-00f6-4d4b-a58b-31f586135659",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "8ef2ebe3-2493-474c-bde4-c648088b1d50_cdaa3646-53db-4ae4-81e3-e23e8058442b",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3eac9cad-23db-4755-b659-c3556138c687",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "019dbd84-be91-433e-8d85-446a102f72c5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Security features are defined and implemented for all services, protocols, and ports that are in use and considered to be insecure, such that the risk is mitigated.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "91313d64-3e90-43eb-8af6-841c6a9398d2",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Examine configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "464b0d71-f6e0-4dbf-94c0-e00d427d61ba",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["47da6034-1c89-4d8b-9df0-e4f7256d5961"],
              },
            },
            {
              _uid: "47da6034-1c89-4d8b-9df0-e4f7256d5961",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "f86e961d-3331-498e-bf11-85c64f3b1928_464b0d71-f6e0-4dbf-94c0-e00d427d61ba",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "50299255-5411-4882-82cd-08e789b37016",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "243bf269-1bda-4ea7-8b1f-a3edc48dcedb",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Configurations of NSCs are reviewed at least once every six months to confirm they are relevant and effective.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "9898c906-2533-472e-b642-bd438375eebe",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures.",
                "Examine documentation from reviews performed.",
                "Examine configuration settings.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f768dc52-fe1b-4323-824c-bdd036e097ab",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ed4c62d3-7109-4c3d-9a7f-81977822769a"],
              },
            },
            {
              _uid: "ed4c62d3-7109-4c3d-9a7f-81977822769a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "bdd52119-699f-471e-86b9-4ca1b1556cb7_f768dc52-fe1b-4323-824c-bdd036e097ab",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 25
        {
          fields: [
            {
              _uid: "8e3cb32f-358f-43c6-9777-5566e23c8a57",
              component: "col",
              label: "",
              simplifiedLabel: "1.2.8",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "98d89d6e-a532-4bf1-b1ac-7c8ae81d1ff6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Configuration files for NSCs are:",
                "Secured from unauthorized access.",
                "Kept consistent with active network configurations.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8e8fa4f2-f1d9-4441-bcbb-84337f8a328f",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine NSC configuration files."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cafa9075-4b2a-4275-97ee-3754b5f8405c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e67e52b3-cba1-4bbd-ae5d-102ade43363d"],
              },
            },
            {
              _uid: "e67e52b3-cba1-4bbd-ae5d-102ade43363d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "f5dafaa4-d8ef-4c94-80a2-6bb477300dff_cafa9075-4b2a-4275-97ee-3754b5f8405c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "13ca617b-b90e-497d-b067-e421d4435113",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Any file or setting used to configure or synchronize NSCs is considered to be a “configuration file.” This includes files, automated and system-based controls, scripts, settings, infrastructure as code, or other parameters that are backed up, archived, or stored remotely.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "90a2a96a-4243-4132-b067-8abd6139f127",
              component: "col",
              label: "",
              simplifiedLabel: ["1.3 Network access to and from the cardholder data environment is restricted."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1e7e8818-1f0b-4317-85b4-9b755e518588",
              component: "col",
              label: "",
              simplifiedLabel: "1.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e2143499-aabc-46f8-a49f-78d80d33977a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Inbound traffic to the CDE is restricted as follows:",
                "To only traffic that is necessary.",
                "All other traffic is specifically denied.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "57d8db79-5520-473d-888e-5d673652002e",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine NSC configuration standards.", "Examine NSC configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4678fed8-63e6-4034-9ddf-8328ee39723d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["42623776-9ad9-4eab-89a1-49319a289ec5"],
              },
            },
            {
              _uid: "42623776-9ad9-4eab-89a1-49319a289ec5",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "f1135384-47f5-4898-b4d5-295ce91b0b33_4678fed8-63e6-4034-9ddf-8328ee39723d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c9ae6797-c1d6-4ca1-b713-812da006216d",
              component: "col",
              label: "",
              simplifiedLabel: "1.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "bad106e7-f8d0-4fe1-8bdc-c2918567dc71",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Outbound traffic from the CDE is restricted as follows:",
                "To only traffic that is necessary.",
                "All other traffic is specifically denied.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3b52bdd2-0145-4bbc-8d0c-54a2911a159f",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine NSC configuration standards.", "Examine NSC configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "1c53e5dd-477e-41a4-bc53-faaa0766eda2",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["42e91e2f-4736-433e-ac29-8561d3656164"],
              },
            },
            {
              _uid: "42e91e2f-4736-433e-ac29-8561d3656164",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "a4064168-9828-4d4c-9b85-904a940c1d90_1c53e5dd-477e-41a4-bc53-faaa0766eda2",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "27d19e7c-51cf-47bb-b8a3-bd335c8cce2a",
              component: "col",
              label: "",
              simplifiedLabel: "1.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ab6d4ce5-55a8-4dcc-8816-9029b0691e7d",
              component: "col",
              label: [],
              simplifiedLabel: [
                "NSCs are installed between all wireless networks and the CDE, regardless of whether the wireless network is a CDE, such that:",
                "All wireless traffic from wireless networks into the CDE is denied by default.",
                "Only wireless traffic with an authorized business purpose is allowed into the CDE.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "310a3da8-d22b-40b1-bdb9-71980d84b3a3",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine configuration settings.", "Examine network diagrams."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "699249cb-f9c4-4740-9ad4-bfcbcff91201",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ba651261-2902-4de1-bf06-8ccbc0efdcb3"],
              },
            },
            {
              _uid: "ba651261-2902-4de1-bf06-8ccbc0efdcb3",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "f72de983-6086-46e7-9bad-447290a1b7bd_699249cb-f9c4-4740-9ad4-bfcbcff91201",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7a63090a-5a41-40f8-82c7-ad0bf9501d4b",
              component: "col",
              label: "",
              simplifiedLabel: ["1.4 Network connections between trusted and untrusted networks are controlled."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "07db3884-b9cc-4aa0-94fd-39f9b8e32952",
              component: "col",
              label: "",
              simplifiedLabel: "1.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f13ccae9-11d6-410c-bb63-ff4243d259a5",
              component: "col",
              label: [],
              simplifiedLabel: ["NSCs are implemented between trusted and untrusted networks."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "72d76c6c-f8da-45e0-91fc-a28b0b895390",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine NSC configuration standards.",
                "Examine current network diagrams.",
                "Examine network configurations.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "1b20dee1-39f7-427b-8bb4-82d425fcdfe3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9595a7b1-6c1c-4f31-ab58-2eb357174c80"],
              },
            },
            {
              _uid: "9595a7b1-6c1c-4f31-ab58-2eb357174c80",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "b76811fa-fdff-4b18-8ef7-5fd5ba8bfe01_1b20dee1-39f7-427b-8bb4-82d425fcdfe3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 26
        {
          fields: [
            {
              _uid: "fb180870-db04-4719-a6d6-eb83b0f785bf",
              component: "col",
              label: "",
              simplifiedLabel: "1.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3536f837-4c81-4c84-b27d-559cca72ba50",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Inbound traffic from untrusted networks to trusted networks is restricted to:",
                "Communications with system components that are authorized to provide publicly accessible services, protocols, and ports.",
                "Stateful responses to communications initiated by system components in a trusted network.",
                "All other traffic is denied.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b81200ff-7dbb-411f-8e47-82c34b78325f",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine NSC documentation.", "Examine NSC configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "8f5e2c2d-3dfd-4f02-a1f4-bf04df7c229c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f06c8029-86ba-4f88-b963-fcf97e3d4606"],
              },
            },
            {
              _uid: "f06c8029-86ba-4f88-b963-fcf97e3d4606",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "fb06cde8-0e27-41d7-b7ee-a0d3ea8e73c6_8f5e2c2d-3dfd-4f02-a1f4-bf04df7c229c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "33dd7215-34b9-4e3c-a9f6-e3e8625f3278",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The intent of this requirement is to address communication sessions between trusted and untrusted networks, rather than the specifics of protocols.",
                "This requirement does not limit the use of UDP or other connectionless network protocols if state is maintained by the NSC.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b5ea3adf-9133-4843-960b-3186bc6c2232",
              component: "col",
              label: "",
              simplifiedLabel: "1.4.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "415e631d-b60b-4fd2-a46e-f3571a19f7cf",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Anti-spoofing measures are implemented to detect and block forged source IP addresses from entering the trusted network.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0da2cb07-4b49-4ada-8862-9ef5b2c40e3a",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine NSC documentation.", "Examine NSC configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "98933a66-cd0f-4567-98e6-7c0b77fd6c6c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d9c44ea6-75fc-43bf-b8c9-40c1780cd275"],
              },
            },
            {
              _uid: "d9c44ea6-75fc-43bf-b8c9-40c1780cd275",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "50c24a76-20dd-4b51-854e-266856eea226_98933a66-cd0f-4567-98e6-7c0b77fd6c6c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "77f1e5b6-ddaa-499a-a38f-f8d1061df6b6",
              component: "col",
              label: "",
              simplifiedLabel: "1.4.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2784ee57-b2f9-4741-ba23-4fa1e5d0bac8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "System components that store cardholder data are not directly accessible from untrusted networks.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3942d40c-32a5-4beb-9bbd-1a6c8f9cca51",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the data-flow diagram and network diagram.", "Examine NSC configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c6c9f11e-95f4-4d8e-a529-08ba12410ea0",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b85c77da-d53b-4b2b-8403-1da246b06916"],
              },
            },
            {
              _uid: "b85c77da-d53b-4b2b-8403-1da246b06916",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "b96c4b3b-b324-4619-934e-cd01455d886a_c6c9f11e-95f4-4d8e-a529-08ba12410ea0",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c8605112-b9bd-4c1c-8ff5-d6ed0c9b7903",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to storage of account data in volatile memory but does apply where memory is being treated as persistent storage (for example, RAM disk). Account data can only be stored in volatile memory during the time necessary to support the associated business process (for example, until completion of the related payment card transaction).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 27
        {
          fields: [
            {
              _uid: "18af92d3-28d4-4c8e-b4db-fbf0a4507d08",
              component: "col",
              label: "",
              simplifiedLabel: "1.4.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2308933f-f97d-4bd5-9178-50513043c321",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The disclosure of internal IP addresses and routing information is limited to only authorized parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "138bb7a9-beeb-4225-bb9a-9a8e3bfec0f8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine NSC configurations.",
                "Examine documentation.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "08fb6e01-4b0c-4a76-8a73-ac6fa1f825a5",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a21788f0-9fdc-4333-9680-d3d9608bfef9"],
              },
            },
            {
              _uid: "a21788f0-9fdc-4333-9680-d3d9608bfef9",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "a2077664-d3f2-4759-b2f9-7eb8c792ba92_08fb6e01-4b0c-4a76-8a73-ac6fa1f825a5",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4976a581-d398-4cf7-b384-990d6b25c0b5",
              component: "col",
              label: "",
              simplifiedLabel: [
                "1.5 Risks to the CDE from computing devices that are able to connect to both untrusted networks and the CDE are mitigated.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "58865e16-6a11-4277-9065-cd4454e8b284",
              component: "col",
              label: "",
              simplifiedLabel: "1.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "18489e4f-0710-4f96-b182-35b90b2105f5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Security controls are implemented on any computing devices, including company- and employee-owned devices, that connect to both untrusted networks (including the Internet) and the CDE as follows:",
                "Specific configuration settings are defined to prevent threats being introduced into the entity’s network.",
                "Security controls are actively running.",
                "Security controls are not alterable by users of the computing devices unless specifically documented and authorized by management on a case-by-case basis for a limited period.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "43538371-cf17-4ac0-9465-3221c57f5652",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine data flow diagrams.",
                "Observe network configurations.",
                "Examine documentation.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "3d450785-a99a-4a85-93d3-5f4e5c41a78a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5d01a5f7-a9c8-48eb-b77e-93ee1f8c59e2"],
              },
            },
            {
              _uid: "5d01a5f7-a9c8-48eb-b77e-93ee1f8c59e2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "f086b0c0-037a-4afb-aa9a-f816c7d2b72d_3d450785-a99a-4a85-93d3-5f4e5c41a78a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c0fd95c8-c702-4712-9f97-cce1ca512f90",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "These security controls may be temporarily disabled only if there is legitimate technical need, as authorized by management on a case-by-case basis. If these security controls need to be disabled for a specific purpose, it must be formally authorized. Additional security measures may also need to be implemented for the period during which these security controls are not active. This requirement applies to employee-owned and company-owned computing devices. Systems that cannot be managed by corporate policy introduce weaknesses and provide opportunities that malicious individuals may exploit.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 28
        {
          fields: [
            {
              _uid: "2aa579d2-aaeb-461b-82a0-023d781e77af",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Requirement 2: Apply Secure Configurations to All System Components",
                "2.1 Processes and mechanisms for applying secure configurations to all system components are defined and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "eab987e2-7430-4763-9507-32996082bce51",
              component: "col",
              label: "",
              simplifiedLabel: "2.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "adc72997-386f-4e05-a632-fc6f30118033",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 2 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6936f7ff-7df0-4a3e-b148-2484db0574ad",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ddfb1986-af32-4a94-a729-b0573b86c7ae",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d0d26f26-8b98-4ed6-9250-72026a7be1d2"],
              },
            },
            {
              _uid: "d0d26f26-8b98-4ed6-9250-72026a7be1d2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3cfb22f0-d832-4bc3-bafb-67579f7bb29a_ddfb1986-af32-4a94-a729-b0573b86c7ae",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "be7cc2f3-ad59-4d67-bdea-cb72af4d792b",
              component: "col",
              label: "",
              simplifiedLabel: "2.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "731938c8-a7df-4259-9a52-2d82c3aec600",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 2 are documented, assigned, and understood.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6a165671-dff5-44ed-b8c1-bebda39a3de0",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1a99c4ce-c1ff-4799-a68d-1d4b2560dc67",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3be8b2ba-7122-4b28-8aef-e87b81d5fbde"],
              },
            },
            {
              _uid: "3be8b2ba-7122-4b28-8aef-e87b81d5fbde",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3e13a711-e375-4aef-b3ba-e19e56d5ea19_1a99c4ce-c1ff-4799-a68d-1d4b2560dc67",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "63f66c03-d8af-4780-a228-45c6342c646c",
              component: "col",
              label: "",
              simplifiedLabel: ["2.2 System components are configured and managed securely."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "45d1f3cc-5809-4404-9399-a2b949a18a5e",
              component: "col",
              label: "",
              simplifiedLabel: "2.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a19d0232-e18b-42ea-93f8-729a6d4a29b4",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Configuration standards are developed, implemented, and maintained to:",
                "Cover all system components.",
                "Address all known security vulnerabilities.",
                "Be consistent with industry-accepted system hardening standards or vendor hardening recommendations.",
                "Be updated as new vulnerability issues are identified, as defined in Requirement 6.3.1.",
                "Be applied when new systems are configured and verified as in place before or immediately after a system component is connected to a production environment.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0e3ae496-da4f-4d44-a374-d39b2518b52a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configuration standards.",
                "Review industry-accepted hardening standards.",
                "Examine configuration settings.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a05bcca3-e235-4668-9c96-172ccf56b36c"],
              },
            },
            {
              _uid: "a05bcca3-e235-4668-9c96-172ccf56b36c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "20794f12-1818-424f-9b76-105b7dfed068_2b45c9c6-41fe-44cc-aa62-ef9bb8067781",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 29
        {
          fields: [
            {
              _uid: "b0a7d632-4606-4f25-8f56-e43beaf0e32d",
              component: "col",
              label: "",
              simplifiedLabel: "2.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3536f837-4c81-4c84-b27d-559cca72ba50",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Vendor default accounts are managed as follows:",
                "If the vendor default account(s) will be used, the default password is changed per Requirement 8.3.6.",
                "If the vendor default account(s) will not be used, the account is removed or disabled.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "55a03abf-69ac-4813-8b22-4817d8b31dd3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configuration standards.",
                "Examine vendor documentation.",
                "Observe a system administrator logging on using vendor default accounts.",
                "Examine configuration files.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2ced54de-5b80-4f48-8f4b-4e4e72861154",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["25d7650f-ccf2-4af6-9a73-18a1f2974d35"],
              },
            },
            {
              _uid: "25d7650f-ccf2-4af6-9a73-18a1f2974d35",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "4605b800-5271-44a2-a442-a97b6ef71fd7_2ced54de-5b80-4f48-8f4b-4e4e72861154",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2dc183d4-76b0-41b9-8e3e-bdd6072cd776",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This applies to ALL vendor default accounts and passwords, including, but not limited to, those used by operating systems, software that provides security services, application and system accounts, point-of-sale (POS) terminals, payment applications, and Simple Network Management Protocol (SNMP) defaults.",
                "This requirement also applies where a system component is not installed within an entity’s environment, for example, software and applications that are part of the CDE and are accessed via a cloud subscription service.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ef2e78e2-3f29-40f9-ba2e-6c473866fcac",
              component: "col",
              label: "",
              simplifiedLabel: "2.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "25a11d0c-2552-44e9-9e91-425b4f5358a0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Primary functions requiring different security levels are managed as follows:",
                "Only one primary function exists on a system component,",
                "OR",
                "Primary functions with differing security levels that exist on the same system component are isolated from each other,",
                "OR",
                "Primary functions with differing security levels on the same system component are all secured to the level required by the function with the highest security need.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "aec4076a-935d-4692-8f36-5f968e9c5293",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configuration standards.", "Examine system configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "640e46ca-d2d5-4a17-9555-390ef9cdbe49",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7499eff9-c2d2-45da-8342-d24fdeb5fc79"],
              },
            },
            {
              _uid: "7499eff9-c2d2-45da-8342-d24fdeb5fc79",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "3c0377d1-ac4e-4af9-816d-304c975b8ce5_640e46ca-d2d5-4a17-9555-390ef9cdbe49",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 30
        {
          fields: [
            {
              _uid: "6d244fda-cc37-4593-8fea-b7c52986a223",
              component: "col",
              label: "",
              simplifiedLabel: "2.2.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "79d7e467-c59e-47b5-8a6a-e4f8e628a29a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Only necessary services, protocols, daemons, and functions are enabled, and all unnecessary functionality is removed or disabled.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "580193c4-9844-4335-84ac-938f0c0afd0d",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configuration standards.", "Examine system configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e43637ef-202c-42f9-b11d-bbfb35f7b064",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ab03c23a-9342-485e-8d65-aad4c24f6521"],
              },
            },
            {
              _uid: "ab03c23a-9342-485e-8d65-aad4c24f6521",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "7ef36047-331c-485f-b2f7-4c09eeda97b8_e43637ef-202c-42f9-b11d-bbfb35f7b064",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c0ecfc55-083b-44d6-ac9c-871fdd5cda02",
              component: "col",
              label: "",
              simplifiedLabel: "2.2.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "45941c24-84ec-46f8-ad3c-64302034d718",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If any insecure services, protocols, or daemons are present:",
                "Business justification is documented.",
                "Additional security features are documented and implemented that reduce the risk of using insecure services, protocols, or daemons.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "9a323138-24ff-4d15-a580-aac47173faff",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine configuration standards.",
                "Interview personnel.",
                "Examine configuration settings.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "101bec8b-e69c-4d83-850f-26ab9c73e428",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d2c8cfb4-89cb-4337-b1b2-3636e5aeff6f"],
              },
            },
            {
              _uid: "d2c8cfb4-89cb-4337-b1b2-3636e5aeff6f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "8a194216-2198-4d7f-970f-a6ee5ae0f7d9_101bec8b-e69c-4d83-850f-26ab9c73e428",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ce60c4bf-fa90-4126-a896-42a4670e5b36",
              component: "col",
              label: "",
              simplifiedLabel: "2.2.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "da621350-5326-494c-9506-207ed736c969",
              component: "col",
              label: [],
              simplifiedLabel: ["System security parameters are configured to prevent misuse."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7849bce4-e2dc-4ffb-8dc1-49f1cef79a8c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configuration standards.",
                "Interview personnel.",
                "Examine system configurations.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["cd9de4f9-19ab-4aca-ac9c-d4e9202c2f7d"],
              },
            },
            {
              _uid: "cd9de4f9-19ab-4aca-ac9c-d4e9202c2f7d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "f437381f-f243-4e59-8a98-4a68b50f67a3_dee26b3c-b40b-4049-a59f-ee4fa8ce96d0",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c01ecfc5-fb52-421c-8bd5-feea742a213a",
              component: "col",
              label: "",
              simplifiedLabel: "2.2.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "97b96f6a-9560-4879-a6ac-21667a986af1",
              component: "col",
              label: [],
              simplifiedLabel: ["All non-console administrative access is encrypted using strong cryptography."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e25f9990-8d12-4a0a-975c-64ea43df5cf5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configuration standards.",
                "Observe an administrator log on.",
                "Examine system configurations.",
                "Examine vendor documentation.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6a23a131-b26b-456b-a27f-d4218c43f351"],
              },
            },
            {
              _uid: "6a23a131-b26b-456b-a27f-d4218c43f351",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              conditional: {
                value: "na",
                field: "2dc578c7-be16-4ed7-8bf6-4110a19667b5_cba3a8cd-1c4b-4c82-a3b0-cab2693b025a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "263d4c02-981e-4525-a645-7f738044cbc0",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This includes administrative access via browser-based interfaces and application programming interfaces (APIs).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 31
        {
          fields: [
            {
              _uid: "0833530b-ac5d-4062-94dd-a798fc4e998b",
              component: "col",
              label: "",
              simplifiedLabel: ["2.3 Wireless environments are configured and managed securely."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5ca622cb-0a9b-480c-a3ee-ac0ecb530f58",
              component: "col",
              label: "",
              simplifiedLabel: "2.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1bfee4f6-2610-4b72-ba05-5038bbe94222",
              component: "col",
              label: [],
              simplifiedLabel: [
                "For wireless environments connected to the CDE or transmitting account data, all wireless vendor defaults are changed at installation or are confirmed to be secure, including but not limited to:",
                "Default wireless encryption keys.",
                "Passwords on wireless access points.",
                "SNMP defaults.",
                "Any other security-related wireless vendor defaults.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "39b3b912-7bfb-4210-b7b4-3abda74e1883",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Review vendor documentation.",
                "Examine wireless configuration settings.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1a1bfa4b-5f0a-4534-bb00-13abb8f62b93",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5ced3def-eaf1-4bec-bc35-a844dc093bf2"],
              },
            },
            {
              _uid: "5ced3def-eaf1-4bec-bc35-a844dc093bf2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4209ba0e-60b0-4b32-a5d1-ef6de2c30f48_1a1bfa4b-5f0a-4534-bb00-13abb8f62b93",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f4905d02-f145-4539-bc57-653fea50e093",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This includes, but is not limited to, default wireless encryption keys, passwords on wireless access points, SNMP defaults, and any other security-related wireless vendor defaults.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "465fbc77-08f3-4980-b434-ddc2382af3f6",
              component: "col",
              label: "",
              simplifiedLabel: "2.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "adc8a4bb-6dce-40c2-8397-b0deb23db50e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "For wireless environments connected to the CDE or transmitting account data, wireless encryption keys are changed as follows:",
                "Whenever personnel with knowledge of the key leave the company or the role for which the knowledge was necessary.",
                "Whenever a key is suspected of or known to be compromised.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "83518355-32a5-4194-83b4-11d609c922cf",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine key-management documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8a7c019a-5b68-48c9-975f-7d2299ca9254",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["40b09f2e-79fe-418b-b037-7331c2614d7a"],
              },
            },
            {
              _uid: "40b09f2e-79fe-418b-b037-7331c2614d7a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "aab11913-e6c3-40fd-a021-474372586f62_8a7c019a-5b68-48c9-975f-7d2299ca9254",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 32
        {
          fields: [
            {
              _uid: "13a7b01d-93d4-4e63-a658-75711d55cb20",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Protect Account Data",
                "Requirement 3: Protect Stored Account Data",
                "3.1 Processes and mechanisms for protecting stored account data are defined and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "aa8978a1-43d0-4ae6-b1e0-bf3958f39568",
              component: "col",
              label: "",
              simplifiedLabel: "3.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "38aaf92a-fbc8-492c-a298-6ca4499deebf",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 3 are:",
                "Documented",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "506bae8e-f2c2-42ae-b9a5-06bb2764dc7d",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e23446ac-19c4-400a-b0c2-4db5aabf4883",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ad89e3b1-280a-49e7-8cb1-2236289caa4e"],
              },
            },
            {
              _uid: "ad89e3b1-280a-49e7-8cb1-2236289caa4e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4b6f145b-92ab-42d2-b2b9-e15b6a7d8080_e23446ac-19c4-400a-b0c2-4db5aabf4883",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5747797a-b634-473b-bea6-9c4cb2872d91",
              component: "col",
              label: "",
              simplifiedLabel: "3.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "dcc4ae38-5c32-4f65-827f-1f5b503802de",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 3 are documented, assigned, and understood.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "65db9a78-cbb5-49f0-8cac-3fec2fdd386a",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ce60acb8-b929-4300-92c0-870cc42e9212",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["18f8728b-dca6-4a6c-a8a6-694e917a31eb"],
              },
            },
            {
              _uid: "18f8728b-dca6-4a6c-a8a6-694e917a31eb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "923f234f-65d7-4053-b767-7940cb92811e_ce60acb8-b929-4300-92c0-870cc42e9212",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 33
        {
          fields: [
            {
              _uid: "8b27afe4-7d62-4beb-9a5b-69ec76f8edc5",
              component: "col",
              label: "",
              simplifiedLabel: ["3.2 Storage of account data is kept to a minimum."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "560ea4a6-6e4d-46db-9bc4-1d02975a46eb",
              component: "col",
              label: "",
              simplifiedLabel: "3.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5ec314eb-4a33-4b66-ab00-c4277f258484",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Account data storage is kept to a minimum through implementation of data retention and disposal policies, procedures, and processes that include at least the following:",
                "Coverage for all locations of stored account data.",
                "Coverage for any sensitive authentication data (SAD) stored prior to completion of authorization. This bullet is a best practice until its effective date; refer to Applicability Notes below for details.",
                "Limiting data storage amount and retention time to that which is required for legal or regulatory, and/or business requirements.",
                "Specific retention requirements for stored account data that defines length of retention period and includes a documented business justification.",
                "Processes for secure deletion or rendering account data unrecoverable when no longer needed per the retention policy.",
                "A process for verifying, at least once every three months, that stored account data exceeding the defined retention period has been securely deleted or rendered unrecoverable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "215d43fb-0f77-4135-a372-58f24dbbb481",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the data retention and disposal policies, procedures, and processes.",
                "Interview personnel.",
                "Examine files and system records on system components where account data is stored.",
                "Observe the mechanisms used to render account data unrecoverable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6bba1b81-d646-4b99-9b48-be90fd1e5123",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3f817ad3-5912-477d-8eec-75a360ee5f5b"],
              },
            },
            {
              _uid: "3f817ad3-5912-477d-8eec-75a360ee5f5b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3e3118e7-1845-4a5b-b47e-ab74a1804690_6bba1b81-d646-4b99-9b48-be90fd1e5123",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b54dab54-8335-4796-b0a3-8cd42951faa0",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Where account data is stored by a TPSP (for example, in a cloud environment), entities are responsible for working with their service providers to understand how the TPSP meets this requirement for the entity. Considerations include ensuring that all geographic instances of a data element are securely deleted.",
                "The bullet above (for coverage of SAD stored prior to completion of authorization) is a best practice until 31 March 2025, after which it will be required as part of Requirement 3.2.1 and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 34
        {
          fields: [
            {
              _uid: "c0218266-0d5d-4875-ba35-9f4737b40444",
              component: "col",
              label: "",
              simplifiedLabel: ["3.3 Sensitive authentication data (SAD) is not stored after authorization."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b95618f5-8064-4294-a9c3-91c722a82998",
              component: "col",
              label: "",
              simplifiedLabel: "3.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5ec314eb-4a33-4b66-ab00-c4277f258484",
              component: "col",
              label: [],
              simplifiedLabel: [
                "SAD is not retained after authorization, even if encrypted. All sensitive authentication data received is rendered unrecoverable upon completion of the authorization process.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "a0d0e0b6-bac0-420c-b795-ec3349de31aa",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Examine system configurations.",
                "Observe the secure data deletion processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "884a2baa-c99e-4314-9197-34b8f13fb120",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8c3072bf-c752-4177-aaa7-9a34540061e1"],
              },
            },
            {
              _uid: "8c3072bf-c752-4177-aaa7-9a34540061e1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "afc61f16-89ea-4657-b119-b54401f85372_884a2baa-c99e-4314-9197-34b8f13fb120",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bf50620b-2158-422b-a566-44b4fa168a8d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement does not apply to issuers and companies that support issuing services (where SAD is needed for a legitimate issuing business need) and have a business justification to store the sensitive authentication data.",
                "Refer to Requirement 3.3.3 for additional requirements specifically for issuers. ",
                "Sensitive authentication data includes the data cited in Requirements 3.3.1.1 through 3.3.1.3.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 35
        {
          fields: [
            {
              _uid: "bd370c47-2ece-4538-bdcd-e3a9e0e27a39",
              component: "col",
              label: "",
              simplifiedLabel: "3.3.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6fbeb185-b0f6-4d24-93bc-c7ecd5a35805",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The full contents of any track are not retained upon completion of the authorization process.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ef7be0f1-6c82-45b1-b427-5fa59eb32dac",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine data sources."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fc9809f2-2e5e-4cbe-b030-f33c0f119b13",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3410f1b2-322e-4ebe-aa36-bb62f7cee43f"],
              },
            },
            {
              _uid: "3410f1b2-322e-4ebe-aa36-bb62f7cee43f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c920e87a-d295-4e66-b978-e578b1023cbe_fc9809f2-2e5e-4cbe-b030-f33c0f119b13",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b5485f40-a7ee-464a-9ff9-c38af26d86bf",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "In the normal course of business, the following data elements from the track may need to be retained:",
                "Cardholder name.",
                "Primary account number (PAN).",
                "Expiration date.",
                "Service code.",
                "To minimize risk, store securely only these data elements as needed for business.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f1a444bc-db9c-42fe-b7d6-1275cab35b34",
              component: "col",
              label: "",
              simplifiedLabel: "3.3.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "13d76fcd-09cd-4482-b52d-a6cb8746dcaa",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The card verification code is not retained upon completion of the authorization process.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d39df6bb-412f-4612-a2e4-c2e4674c2618",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine data sources."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6c9ab849-3896-4df7-b259-8df68143f010"],
              },
            },
            {
              _uid: "6c9ab849-3896-4df7-b259-8df68143f010",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2caffed6-23f8-4ebc-86c1-a0b557d25656_bbcb5406-b3b0-44f2-bc67-f05e64ba8080",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a2452436-c68a-48bd-b754-b850dc350828",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The card verification code is the three- or four-digit number printed on the front or back of a payment card used to verify card-not-present transactions.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f1a444bc-db9c-42fe-b7d6-1275cab35b34",
              component: "col",
              label: "",
              simplifiedLabel: "3.3.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "13d76fcd-09cd-4482-b52d-a6cb8746dcaa",
              component: "col",
              label: [],
              simplifiedLabel: [
                " The personal identification number (PIN) and the PIN block are not retained upon completion of the authorization process.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d39df6bb-412f-4612-a2e4-c2e4674c2618",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine data sources."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "4433a0e5-0224-44b7-8285-18dcf1eeebe0",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["af69474f-4214-4303-b94c-a240f9705b67"],
              },
            },
            {
              _uid: "af69474f-4214-4303-b94c-a240f9705b67",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2caffed6-23f8-4ebc-86c1-a0b557d25656_4433a0e5-0224-44b7-8285-18dcf1eeebe0",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a2452436-c68a-48bd-b754-b850dc350828",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "PIN blocks are encrypted during the natural course of transaction processes, but even if an entity encrypts the PIN block again, it is still not allowed to be stored after the completion of the authorization process.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 36
        {
          fields: [
            {
              _uid: "dcd941d6-d04b-4817-a8ed-c007f91d950f",
              component: "col",
              label: "",
              simplifiedLabel: "3.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3c470ed1-909a-4a90-ab94-9726127a4ab3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "SAD that is stored electronically prior to completion of authorization is encrypted using strong cryptography.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0177720e-5b1d-4259-b96b-5eee2b99d649",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine data stores and system configurations.", "Examine vendor documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "5571db8d-ccd8-4779-bdd2-e4c9258da06d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2aa27aca-e6e7-4bdd-9ff7-cb4a1093793d"],
              },
            },
            {
              _uid: "2aa27aca-e6e7-4bdd-9ff7-cb4a1093793d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "821036b5-bc65-4408-8837-7874483aa287_5571db8d-ccd8-4779-bdd2-e4c9258da06d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f3667670-208c-45f1-ab36-99c7df1cd772",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Whether SAD is permitted to be stored prior to authorization is determined by the organizations that manage compliance programs (for example, payment brands and acquirers). Contact the organizations of interest for any additional criteria.",
                "This requirement applies to all storage of SAD, even if no PAN is present in the environment. Refer to Requirement 3.2.1 for an additional requirement that applies if SAD is stored prior to completion of authorization.",
                "This requirement does not apply to issuers and companies that support issuing services where there is a legitimate issuing business justification to store SAD).",
                "Refer to Requirement 3.3.3 for requirements specifically for issuers. ",
                "This requirement does not replace how PIN blocks are required to be managed, nor does it mean that a properly encrypted PIN block needs to be encrypted again.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 37
        {
          fields: [
            {
              _uid: "bff5bdba-3852-4358-9d35-f300167f2148",
              component: "col",
              label: "",
              simplifiedLabel: "3.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f9266728-53a8-4d6d-b3a1-21c6f958a888",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for issuers and companies that support issuing services and store sensitive authentication data:",
                "Any storage of sensitive authentication data is:",
                "Limited to that which is needed for a legitimate issuing business need and is secured.",
                "Encrypted using strong cryptography. This bullet is a best practice until its effective date; refer to Applicability Notes below for details.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6d654b9c-6eec-485d-9f3d-46800e9600f0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies.",
                "Interview personnel.",
                "Examine data stores and system configurations.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "acd7f775-1c7d-4dc0-8253-742e6a7cd084",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["125dc8f0-a30b-4589-b2ab-9c45e55f144a"],
              },
            },
            {
              _uid: "125dc8f0-a30b-4589-b2ab-9c45e55f144a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "cdb731df-22da-432f-8128-03177e955bbc_acd7f775-1c7d-4dc0-8253-742e6a7cd084",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "002baa97-4950-41aa-bcea-00c253d35334",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only to issuers and companies that support issuing services and store sensitive authentication data.",
                "Entities that issue payment cards or that perform or support issuing services will often create and control sensitive authentication data as part of the issuing function. It is allowable for companies that perform, facilitate, or support issuing services to store sensitive authentication data ONLY IF they have a legitimate business need to store such data.",
                "PCI DSS requirements are intended for all entities that store, process, or transmit account data, including issuers. The only exception for issuers and issuer processors is that sensitive authentication data may be retained if there is a legitimate reason to do so. Any such data must be stored securely and in accordance with all PCI DSS and specific payment brand requirements.",
                "The bullet above (for encrypting stored SAD with strong cryptography) is a best practice until 31 March 2025, after which it will be required as part of Requirement 3.3.3 and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 38
        {
          fields: [
            {
              _uid: "6ba0fee2-3d80-428f-8578-ccd82c6d8168",
              component: "col",
              label: "",
              simplifiedLabel: ["3.4 Access to displays of full PAN and ability to copy PAN is restricted."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0fa700d1-c198-4b67-b054-88bd4d4aa779",
              component: "col",
              label: "",
              simplifiedLabel: "3.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0559907f-b0b1-4222-8fc9-0028a7e653e9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "PAN is masked when displayed (the BIN and last four digits are the maximum number of digits to be displayed), such that only personnel with a legitimate business need can see more than the BIN and last four digits of the PAN.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "03353e62-83f8-4885-af49-398db189ce97",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Examine system configurations.",
                "Examine the documented list of roles that need access to more than the BIN and last four digits of the PAN (includes full PAN).",
                "Examine displays of PAN (for example, on screen, on paper receipts).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7897dd44-388e-4287-969a-c59e20b21924",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ec90c4e1-dda6-4272-8b4f-9afdc01040de"],
              },
            },
            {
              _uid: "ec90c4e1-dda6-4272-8b4f-9afdc01040de",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a6a88dbc-5655-4f85-88fa-47c1f1575dc3_7897dd44-388e-4287-969a-c59e20b21924",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "192e6093-78aa-453b-ad54-6bdf95d02991",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement does not supersede stricter requirements in place for displays of cardholder data—for example, legal or payment brand requirements for point-of-sale (POS) receipts.",
                "This requirement relates to protection of PAN where it is displayed on screens, paper receipts, printouts, etc., and is not to be confused with Requirement 3.5.1 for protection of PAN when stored, processed, or transmitted.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 39
        {
          fields: [
            {
              _uid: "816de1c9-21ca-49ef-acb6-f9d837e00393",
              component: "col",
              label: "",
              simplifiedLabel: "3.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ed916e18-0a62-48e9-a24e-710e178a38e6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "When using remote-access technologies, technical controls prevent copy and/or relocation of PAN for all personnel, except for those with documented, explicit authorization and a legitimate, defined business need.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "a7efb7ac-57d6-4148-888a-16f6d8f29b61",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures and documented evidence for technical controls.",
                "Examine configurations for remote-access technologies.",
                "Observe processes.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a2556df3-fcaa-427e-b2fe-1cffe848b5e9",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["580d36e4-c6cd-48e0-b0ff-adfaa923a344"],
              },
            },
            {
              _uid: "580d36e4-c6cd-48e0-b0ff-adfaa923a344",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "efb114be-57f1-4d21-bc04-42039ca47fac_a2556df3-fcaa-427e-b2fe-1cffe848b5e9",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0284e51f-470b-48c3-8372-47b7f9b8743d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Storing or relocating PAN onto local hard drives, removable electronic media, and other storage devices brings these devices into scope for PCI DSS.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        //40
        {
          fields: [
            {
              _uid: "0a29536a-062c-4a84-9dc3-b1dbe2ca7994",
              component: "col",
              label: "",
              simplifiedLabel: ["3.5 Primary account number (PAN) is secured wherever it is stored."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e4af0ec7-1830-4a81-af96-8b9e277270d9",
              component: "col",
              label: "",
              simplifiedLabel: "3.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "8872db15-1fb4-414f-a2a4-5d9a19ed5db1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "PAN is rendered unreadable anywhere it is stored by using any of the following approaches:",
                "One-way hashes based on strong cryptography of the entire PAN.",
                "If hashed and truncated versions of the same PAN, or different truncation formats of the same PAN, are present in an environment, additional controls are in place such that the different versions cannot be correlated to reconstruct the original PAN",
                "Index tokens.",
                "Strong cryptography with associated keymanagement processes and procedures.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0747e8c3-9386-4ac9-9f53-ca8c497b4d36",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documentation about the system used to render PAN unreadable.",
                "Examine data repositories.",
                "Examine audit logs, including payment application logs.",
                "Examine controls to verify that the hashed and truncated PANs cannot be correlated to reconstruct the original PAN.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "70c514ad-8e67-447e-9d77-930889c30b34",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["0a6826f8-101b-4067-aae8-0bf410c19696"],
              },
            },
            {
              _uid: "0a6826f8-101b-4067-aae8-0bf410c19696",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "5f7e33b8-9cf3-4205-8851-d4b13e0118e9_70c514ad-8e67-447e-9d77-930889c30b34",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "46b6fdab-0a90-49ad-891f-3ad9d2db052a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "It is a relatively trivial effort for a malicious individual to reconstruct original PAN data if they have access to both the truncated and hashed version of a PAN.",
                "This requirement applies to PANs stored in primary storage (databases, or flat files such as text files spreadsheets) as well as non-primary storage (backup, audit logs, exception, or troubleshooting logs) must all be protected.",
                "This requirement does not preclude the use of temporary files containing cleartext PAN while encrypting and decrypting PAN.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        //41
        {
          fields: [
            {
              _uid: "c7388cda-1c82-498e-a46f-72af94c8ccaa",
              component: "col",
              label: "",
              simplifiedLabel: "3.5.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2d3b8dea-63d3-4c36-9927-22025218a345",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Hashes used to render PAN unreadable (per the first bullet of Requirement 3.5.1), are keyed cryptographic hashes of the entire PAN, with associated key-management processes and procedures in accordance with Requirements 3.6 and 3.7.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e851c691-d23a-4acf-bde7-5979d1c2efaa",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documentation about the hashing method used",
                "Examine documentation about the key-management procedures and processes.",
                "Examine data repositories.",
                "Examine audit logs, including payment application logs.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3274ccb0-94d0-4c81-b133-a8665ec54018",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["361c8a85-706b-4487-b407-885dd1bc7fe7"],
              },
            },
            {
              _uid: "361c8a85-706b-4487-b407-885dd1bc7fe7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "fe423b75-4dd1-4ff4-922f-cd53bf330296_3274ccb0-94d0-4c81-b133-a8665ec54018",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4c9a2bf3-5f73-47c4-a2a2-623656233f4c",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies to PANs stored in primary storage (databases, or flat files such as text files spreadsheets) as well as non-primary storage (backup, audit logs, exception, or troubleshooting logs) must all be protected.",
                "This requirement does not preclude the use of temporary files containing cleartext PAN while encrypting and decrypting PAN.",
                "This requirement is considered a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        //42
        {
          fields: [
            {
              _uid: "f3bf6ea9-7426-499a-9b91-3690689cab5f",
              component: "col",
              label: "",
              simplifiedLabel: "3.5.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "68cc9a7c-65ff-4105-872d-f1bcc6b18207",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If disk-level or partition-level encryption (rather than file-, column-, or field-level database encryption) is used to render PAN unreadable, it is implemented only as follows:",
                "On removable electronic media.",
                "OR",
                "If used for non-removable electronic media, PAN is also rendered unreadable via another mechanism that meets Requirement 3.5.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f1fe6fd5-3db2-4965-bae2-a134050d9008",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Observe encryption processes.",
                "Examine configurations and/or vendor documentation.",
                "Observe encryption processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "afb5ac2e-b50e-4264-9531-e1cba9e70354",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["cff5272d-49af-459c-af75-8bfa7c9a0ff1"],
              },
            },
            {
              _uid: "cff5272d-49af-459c-af75-8bfa7c9a0ff1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c897c5d0-1828-4837-b96d-dfc34458693a_afb5ac2e-b50e-4264-9531-e1cba9e70354",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "98035b0f-3e4e-4564-acc1-8ed1b8787d9b",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "While disk encryption may still be present on these types of devices, it cannot be the only mechanism used to protect PAN stored on those systems. Any stored PAN must also be rendered unreadable per Requirement 3.5.1—for example, through truncation or a data-level encryption mechanism. Full disk encryption helps to protect data in the event of physical loss of a disk and therefore its use is appropriate only for removable electronic media storage devices.",
                "Media that is part of a data center architecture (for example, hot-swappable drives, bulk tape-backups) is considered non-removable electronic media to which Requirement 3.5.1 applies.",
                "Disk or partition encryption implementations must also meet all other PCI DSS encryption and key-management requirements.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        //43
        {
          fields: [
            {
              _uid: "d1ea91f4-f6a7-406a-9da6-ff4546643377",
              component: "col",
              label: "",
              simplifiedLabel: "3.5.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "d0df14ce-3ca4-48a8-afe3-4ecbcec47110",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If disk-level or partition-level encryption is used (rather than file-, column-, or field--level database encryption) to render PAN unreadable, it is managed as follows:",
                "Logical access is managed separately and independently of native operating system authentication and access control mechanisms",
                "Decryption keys are not associated with user accounts.",
                "Authentication factors (passwords, passphrases, or cryptographic keys) that allow access to unencrypted data are stored securely",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "1f71435b-b070-4b79-9cd2-009fa23aa6f7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configurations.",
                "Observe the authentication process.",
                "Examine files containing authentication factors",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d4e24f44-1310-4709-9ab9-7b506fb9eed1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["51db6cfb-992a-4c92-b44e-165738f8ebf7"],
              },
            },
            {
              _uid: "51db6cfb-992a-4c92-b44e-165738f8ebf7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "753b449a-e116-4576-b1e1-fb92ee6ebe4d_d4e24f44-1310-4709-9ab9-7b506fb9eed1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "86f54fae-cc51-46d0-87bb-306888d23562",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Disk or partition encryption implementations must also meet all other PCI DSS encryption and key-management requirements.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        //44
        {
          fields: [
            {
              _uid: "76cdf72a-db4f-4497-a2bc-d9c1b6324329",
              component: "col",
              label: "",
              simplifiedLabel: ["3.6 Cryptographic keys used to protect stored account data are secured."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2dea88bd-3e73-4262-a3a6-8e2139884ed4",
              component: "col",
              label: "",
              simplifiedLabel: "3.6.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "19125142-6fcc-4324-a3ce-6508da2e734a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Procedures are defined and implemented to protect cryptographic keys used to protect stored account data against disclosure and misuse that include:",
                "Access to keys is restricted to the fewest number of custodians necessary.",
                "Key-encrypting keys are at least as strong as the data-encrypting keys they protect.",
                "Key-encrypting keys are stored separately from data-encrypting keys",
                "Keys are stored securely in the fewest possible locations and forms",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "3fdf8753-6d95-470d-9be6-8ebd3729e2e3",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented keymanagement policies and procedures."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "730ef487-fba5-40fe-bc7c-32757df6cec5",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["740d5fee-0bae-4b7a-8955-930f9d46e543"],
              },
            },
            {
              _uid: "740d5fee-0bae-4b7a-8955-930f9d46e543",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3eb883c4-3d44-4e44-92ca-4a98235042ce_730ef487-fba5-40fe-bc7c-32757df6cec5",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b3009ed6-e333-4891-9d50-dc630f239982",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies to keys used to encrypt stored account data and to keyencrypting keys used to protect data-encrypting keys",
                "The requirement to protect keys used to protect stored account data from disclosure and misuse applies to both data-encrypting keys and key-encrypting keys. Because one keyencrypting key may grant access to many data-encrypting keys, the key-encrypting keys require strong protection measures.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        //45
        {
          fields: [
            {
              _uid: "d1aec225-db4a-4769-9cb9-0d663d0f1b01",
              component: "col",
              label: "",
              simplifiedLabel: "3.6.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "122d7cb7-9bdb-4c20-a953-134febed7a2f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "A documented description of the cryptographic architecture is maintained that includes:",
                "Details of all algorithms, protocols, and keys used for the protection of stored account data, including key strength and expiry date.",
                "Preventing the use of the same cryptographic keys in production and test environments. This bullet is a best practice until its effective date; refer to Applicability Notes below for details",
                "Description of the key usage for each key",
                "Inventory of any hardware security modules (HSMs), key-management systems (KMS), and other secure cryptographic devices (SCDs) used for key management, including type and location of devices, as outlined in Requirement 12.3.3",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2122b8c1-4a06-4673-b39d-bbda9e81d68a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine cryptographic architecture documentation.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "37c1a6f2-cdd3-43f6-84ab-e2a179880236",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5c015d61-8b4d-417c-a0e6-05023fe34b6a"],
              },
            },
            {
              _uid: "5c015d61-8b4d-417c-a0e6-05023fe34b6a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "79acc749-4b4a-4512-b945-2fcde7363afa_37c1a6f2-cdd3-43f6-84ab-e2a179880236",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "dc63956c-1bf1-44a3-8502-3d217b108e08",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider",
                "In cloud HSM implementations, responsibility for the cryptographic architecture according to this Requirement will be shared between the cloud provider and the cloud customer.",
                "The bullet above (for including, in the cryptographic architecture, that the use of the same cryptographic keys in production and test is prevented) is a best practice until 31 March 2025, after which it will be required as part of Requirement 3.6.1.1 and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        //46
        {
          fields: [
            {
              _uid: "59746367-11bb-45a6-9a0c-5f83cea73a53",
              component: "col",
              label: "",
              simplifiedLabel: "3.6.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c4f192ed-95e3-4201-ba44-0dd3e4cf69a0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Secret and private keys used to encrypt/decrypt stored account data are stored in one (or more) of the following forms at all times:",
                "Encrypted with a key-encrypting key that is at least as strong as the data-encrypting key, and that is stored separately from the dataencrypting key.",
                "Within a secure cryptographic device (SCD), such as a hardware security module (HSM) or PTS-approved point-of-interaction device.",
                "As at least two full-length key components or key shares, in accordance with an industry-accepted method.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0d09d87a-774e-4445-8861-e733c471bf89",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures.",
                "Examine system configurations and key storage locations, including for keyencrypting keys.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "790e50e6-2700-4388-8ef8-388ff2fe9968",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["1f04a8bf-0a8f-4f36-9e2c-ef128b67e830"],
              },
            },
            {
              _uid: "1f04a8bf-0a8f-4f36-9e2c-ef128b67e830",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "e010bc5e-e325-45fc-bc8e-f095f3fe0164_790e50e6-2700-4388-8ef8-388ff2fe9968",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "63549f8f-21cb-4ea8-85eb-f608f05706fa",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "It is not required that public keys be stored in one of these forms. ",
                "Cryptographic keys stored as part of a key-management system (KMS) that employs SCDs are acceptable.",
                "A cryptographic key that is split into two parts does not meet this requirement. Secret or private keys stored as key components or key shares must be generated via one of the following:",
                "Using an approved random number generator and within an SCD,",
                "OR",
                "According to ISO 19592 or equivalent industry standard for generation of secret key shares.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d57682df-b1d6-4a33-ac4f-01b22ba99b9d",
              component: "col",
              label: "",
              simplifiedLabel: "3.6.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "423ed9c9-edf3-4668-82f1-dd49ffbe5081",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Access to cleartext cryptographic key components is restricted to the fewest number of custodians necessary.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "865e14ce-ede4-43e5-b8bd-471987a302a3",
              component: "col",
              label: [],
              simplifiedLabel: [" Examine user access lists"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3624e755-7f5b-4760-a2d7-8875d78ef21e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e205c68e-3044-4b26-ba3e-5eb7dadb8e13"],
              },
            },
            {
              _uid: "e205c68e-3044-4b26-ba3e-5eb7dadb8e13",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "1cb1e664-dc80-4072-98da-a0d52023f513_3624e755-7f5b-4760-a2d7-8875d78ef21e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3597b797-682b-4ea0-a6bf-367711a78718",
              component: "col",
              label: "",
              simplifiedLabel: "3.6.1.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "9c513c84-ead5-4adc-a169-7831dce3162e",
              component: "col",
              label: [],
              simplifiedLabel: ["Cryptographic keys are stored in the fewest possible locations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "3e3fa2c8-6757-4ebe-9b7e-6ca815adcd15",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine key storage locations.", "Observe processes."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2be5d43f-dd2d-4a22-8339-5181e10f08f2",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["99a5cfba-d91e-4d07-9491-48abf2dcea82"],
              },
            },
            {
              _uid: "99a5cfba-d91e-4d07-9491-48abf2dcea82",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a9005bad-6921-4d66-9e53-04a580364ca1_2be5d43f-dd2d-4a22-8339-5181e10f08f2",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        //47
        {
          fields: [
            {
              _uid: "5a02dd41-c2ed-43c4-aa02-d12ebc33aa55",
              component: "col",
              label: "",
              simplifiedLabel: [
                "3.7 Where cryptography is used to protect stored account data, key-management processes and procedures covering all aspects of the key lifecycle are defined and implemented.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f83e6aa0-02f5-4e83-8644-e9e70bf33533",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "8b9f3ec9-7698-4843-961a-c81a3a20f193",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Key-management policies and procedures are implemented to include generation of strong cryptographic keys used to protect stored account data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "a5a742e5-79e9-4a36-8839-25909fafd05b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and procedures.",
                "Observe the method for generating keys.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "01255226-2d0e-4d61-b643-da6fae01b447",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2ad63b66-b9e1-45eb-a65f-32e71e439655"],
              },
            },
            {
              _uid: "2ad63b66-b9e1-45eb-a65f-32e71e439655",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "385a08e6-2c18-4602-af8e-444f663ebcd5_01255226-2d0e-4d61-b643-da6fae01b447",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "31a3b003-8d11-4c7f-92a6-6866e67244d4",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "17da4263-04b7-4776-a861-733c18df6a66",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Key-management policies and procedures are implemented to include secure distribution of cryptographic keys used to protect stored account data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0a328389-92d3-4951-93e8-798e1f98d80e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and procedures.",
                "Observe the method for distributing keys.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "16045973-fa74-4dbc-a0bd-42f920c99822",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a59fd87f-4978-4990-ac7b-b67014215df1"],
              },
            },
            {
              _uid: "a59fd87f-4978-4990-ac7b-b67014215df1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "20acdc61-2b99-499c-aa53-145666d133ab_16045973-fa74-4dbc-a0bd-42f920c99822",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0a22db8d-6b91-4cb0-9ca6-828a5873394f",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ee44e5fa-f2c3-40e5-9937-796782d86d85",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Key-management policies and procedures are implemented to include generation of strong cryptographic keys used to protect stored account data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "782ecec5-bbb4-4c33-89d6-f46cbf51b2fd",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and procedures.",
                "Observe the method for generating keys.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d2e64262-ae97-42e0-92d5-e7203e424f5f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9540276d-fb02-4211-bf31-7888c4126156"],
              },
            },
            {
              _uid: "9540276d-fb02-4211-bf31-7888c4126156",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "850aa678-b1e2-4507-9c52-46969c6b6245_d2e64262-ae97-42e0-92d5-e7203e424f5f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d6d7d2d0-ed1b-423e-ae3e-e411a14879d2",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5c538a0c-9822-48e4-886c-d3e1bf930d9b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Key-management policies and procedures are implemented to include generation of strong cryptographic keys used to protect stored account data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f2b876eb-bb6c-4b98-8a2b-19ba8da38161",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and procedures.",
                "Observe the method for generating keys.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6ab01606-bedd-43e3-b4cd-3711019ad863",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3b2d2a8a-fc6b-417b-8711-8dd97a43af37"],
              },
            },
            {
              _uid: "3b2d2a8a-fc6b-417b-8711-8dd97a43af37",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "40382a0c-ee8b-4b0d-8f78-dd9d360f238a_6ab01606-bedd-43e3-b4cd-3711019ad863",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 48
        {
          fields: [
            {
              _uid: "bbc11558-906f-4fef-84a2-5bb8a10236f9",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "30d44472-32fc-45d0-9888-eabb53931afe",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Key-management policies procedures are  implemented to include the retirement,  replacement, or destruction of keys used to protect  stored account data, as deemed necessary when:",
                "The key has reached the end of its defined  cryptoperiod.",
                "The integrity of the key has been weakened,  including when personnel with knowledge of a  cleartext key component leaves the company,  or the role for which the key component was  known.",
                "The key is suspected of or known to be  compromised.",
                "Retired or replaced keys are not used for  encryption operations.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f0a6933c-8171-4ca1-8834-e618c56911ab",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and  procedures.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "efec269e-79d3-498f-8be7-f2c2e5df9ab1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3a43500d-6ae2-471e-a6c5-ca15d011a6dd"],
              },
            },
            {
              _uid: "3a43500d-6ae2-471e-a6c5-ca15d011a6dd",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2b5dac0d-4fcc-438b-a2ae-92d52a9dc12b_efec269e-79d3-498f-8be7-f2c2e5df9ab1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6e908101-d2cd-48e7-b2fc-27ec573e39f3",
              component: "col",
              label: "",
              simplifiedLabel: [
                "If retired or replaced cryptographic keys need to be retained, these keys must be  securely archived (for example, by using a key-encryption key).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 49
        {
          fields: [
            {
              _uid: "6c6ff4a9-a57d-4d7f-a455-d8b91318d29b",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "64756d3a-80c3-47ed-bf18-a93c9652ad44",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Where manual cleartext cryptographic key management operations are performed by  personnel, key-management policies and  procedures are implemented include managing  these operations using split knowledge and dual  control.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ff90bbdb-8935-424e-9af8-aa29c664869471f769ea-6ebe-426d-b2bf-88e8370309c6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and  procedures.",
                "Interview personnel.",
                "Observe processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "52db9fb9-0301-47df-abc7-a773925f46c9",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a44ccad7-1fbd-421f-9384-56c1f9a2f93a"],
              },
            },
            {
              _uid: "a44ccad7-1fbd-421f-9384-56c1f9a2f93a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f83607b4-cab3-417a-a2ee-4c2760a029d4_52db9fb9-0301-47df-abc7-a773925f46c9",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "95b3bd40-34f6-42e2-9134-3ea5f9e8a18a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "This control is applicable for manual key-management operations or where key  management is not controlled by the encryption product.",
                "A cryptographic key that is simply split into two parts does not meet this requirement.  Secret or private keys stored as key components or key shares must be generated via  one of the following:",
                "Using an approved random number generator and within a secure cryptographic  device (SCD), such as a hardware security module (HSM) or PTS-approved point-of interaction device,",
                "OR",
                "According to ISO 19592 or equivalent industry standard for generation of secret key  shares.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a74165fa-1a2e-41d4-bdb0-db7560c51c69",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "70ad2bad-002f-495a-8966-2680d66473ad",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Key-management policies and procedures are  implemented to include the prevention of  unauthorized substitution of cryptographic keys.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7a253069-5060-4863-9f32-01a97eaea935",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and  procedures.",
                "Interview personnel.",
                "Observe processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fac2bd95-202c-4b81-9634-7ce01d576d6f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2ce427c7-627e-4630-a214-3dc409aa5659"],
              },
            },
            {
              _uid: "2ce427c7-627e-4630-a214-3dc409aa5659",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "065f24b9-056f-4653-be1f-5c2dc6de69c4_fac2bd95-202c-4b81-9634-7ce01d576d6f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a8313da1-5f33-4297-9ef4-9ac01109f3d3",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.8",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ec2c9f58-2e2c-4983-889b-20f4b9636076",
              component: "col",
              label: [
                "Key-management policies and procedures are implemented to include that cryptographic key custodians formally acknowledge (in writing or electronically) that they understand and accept their key-custodian responsibilities.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ff90bbdb-8935-424e-9af8-aa29c6648694",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented key management policies and  procedures.",
                "Review documentation or  other evidence of key  custodian acknowledgments.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3e692a96-2164-468c-8550-dc54a00eb1e1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["adabb2bd-7cf9-4007-b154-64ed76b367f2"],
              },
            },
            {
              _uid: "adabb2bd-7cf9-4007-b154-64ed76b367f2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f4735b9e-4e14-4eae-becb-0a25acee1130_3e692a96-2164-468c-8550-dc54a00eb1e1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        //50
        {
          fields: [
            {
              _uid: "42d86645-8330-47c6-8967-8e6f4f2b8127",
              component: "col",
              label: "",
              simplifiedLabel: "3.7.9",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "9e0ffd01-4c83-413d-a288-a6d70d0d9ce3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "Where a service provider shares cryptographic keys with its customers for transmission or storage of account data, guidance on secure transmission, storage and updating of such keys is documented and distributed to the service provider’s customers",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2d14a4b6-05b7-4e71-8c60-ea49ac69d302",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation provided by the service provider to its customers"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "431359de-d7fb-4f02-b72a-ab84bea002ab",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d294c327-5344-405f-ad00-b45d4ac6cecb"],
              },
            },
            {
              _uid: "d294c327-5344-405f-ad00-b45d4ac6cecb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a6fee4e2-b465-4d02-b169-28b1c09437b0_431359de-d7fb-4f02-b72a-ab84bea002ab",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2b6fc9ba-255d-43b4-8394-7b45b38bfdfb",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 51
        {
          fields: [
            {
              _uid: "79fac08b-04d1-41e9-9570-97b633e1b61e",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Requirement 4: Protect Cardholder Data with Strong Cryptography During Transmission Over Open, Public Networks",
                "4.1 Processes and mechanisms for protecting cardholder data with strong cryptography during transmission over open, public networks are defined and documented.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d6a63918-aee7-4bca-ae2d-7b1bc3af7567",
              component: "col",
              label: "",
              simplifiedLabel: "4.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1f015770-ae73-4e3e-b231-749d4a89d94d",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 4 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "574ffa11-35e6-4ba5-882a-99b5007c60a1",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d6b563de-d276-44c8-a093-fb73a928dd9a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d6a28c6b-a876-40d6-9e6c-b0ee4fcb2e48"],
              },
            },
            {
              _uid: "d6a28c6b-a876-40d6-9e6c-b0ee4fcb2e48",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "cd99e615-2540-439a-b5d6-8f2fb4bd4568_d6b563de-d276-44c8-a093-fb73a928dd9a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ffd941e3-ba71-4b73-a0b1-b2032ecb4c2c",
              component: "col",
              label: "",
              simplifiedLabel: "4.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6cb91987-ccac-4ea7-bd30-1348c69ecc89",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 4 are documented, assigned, and understood.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "070374bc-49c0-48fd-b59c-7f96c617b2b9",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "01096367-35a8-4c6d-9ea6-a51b4772d7f2",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a6b69b4d-fbff-4862-888d-985ae749d79c"],
              },
            },
            {
              _uid: "a6b69b4d-fbff-4862-888d-985ae749d79c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "df2b0aa3-60bb-48b0-847c-e53b2c4fcba6_01096367-35a8-4c6d-9ea6-a51b4772d7f2",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 52
        {
          fields: [
            {
              _uid: "822a977d-71b4-413b-b05f-69f5c5ae1cb7",
              component: "col",
              label: "",
              simplifiedLabel: ["4.2 PAN is protected with strong cryptography during transmission."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e21846f8-094a-47d1-941f-0b15befa3550",
              component: "col",
              label: "",
              simplifiedLabel: ["4.2.1"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "",
              width: "5%",
            },
            {
              _uid: "9a47e5d3-5a84-4113-8b3a-e5a1e4f0bb80",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Strong cryptography and security protocols are implemented as follows to safeguard PAN during transmission over open, public networks:",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 4,
              width: "95%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0fc56d9e-03e6-4feb-8220-2c060e323657",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0f105191-19a1-4575-918e-db137e25dd3b",
              component: "col",
              label: [],
              simplifiedLabel: ["Only trusted keys and certificates are accepted."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "74f310ab-324c-4eb8-9462-31a33930c472",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Interview personnel.",
                "Examine system configurations.",
                "Examine cardholder data transmissions.",
                "Examine keys and certificates.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6977ca94-a321-42b6-a181-754e9842c3e9",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d5ae7c57-42fa-4b01-b6ef-bea804fd24a1"],
              },
            },
            {
              _uid: "d5ae7c57-42fa-4b01-b6ef-bea804fd24a1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2b89241a-739a-4206-8cbb-52b5ab88b912_6977ca94-a321-42b6-a181-754e9842c3e9",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6d50df8a-deb9-485c-8a53-dd0ff37be045",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3ad431ac-9855-4fb0-9f40-99f3b89a20e2",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Certificates used to safeguard PAN during transmission over open, public networks are confirmed as valid and are not expired or revoked. This bullet is a best practice until its effective date; refer to Applicability Notes below for details.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c2dba022-17bc-41ad-8746-7e4f1e82692e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Interview personnel.",
                "Examine system configurations.",
                "Examine cardholder data transmissions.",
                "Examine keys and certificates.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ac1fc75d-dccf-4988-9529-1f9836a0c53d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["13d03319-63ef-4f28-9df0-32b69c45e28d"],
              },
            },
            {
              _uid: "13d03319-63ef-4f28-9df0-32b69c45e28d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "dbfb0191-b807-4a1e-bcfe-326a3fce83df_ac1fc75d-dccf-4988-9529-1f9836a0c53d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "16ea6227-f3be-48a0-a99d-e84a3dc1a8f9",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1c2adfca-51da-4c84-aae8-4ce7bf76a381",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The protocol in use supports only secure versions or configurations and does not support fallback to, or use of insecure versions, algorithms, key sizes, or implementations.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "04594f91-0334-4f28-ac6f-e19b90345443",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Interview personnel.",
                "Examine system configurations.",
                "Examine cardholder data transmissions.",
                "Examine keys and certificates.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e413cf69-a333-454e-abea-53e7de37dd1d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7e1d14a1-0b51-418b-b028-a1191aaaea97"],
              },
            },
            {
              _uid: "7e1d14a1-0b51-418b-b028-a1191aaaea97",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "7cbb742e-8bff-47e0-ae64-1a2f84179972_e413cf69-a333-454e-abea-53e7de37dd1d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f6912b62-cb33-4564-b3f3-ce18269d7873",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "4b2c96af-bfde-4861-a65c-1bf048fe7f09",
              component: "col",
              label: [],
              simplifiedLabel: ["The encryption strength is appropriate for the encryption methodology in use."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "66f2c9f1-b49d-41b1-b9bc-3f754b2d9632",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Interview personnel.",
                "Examine system configurations.",
                "Examine cardholder data transmissions.",
                "Examine keys and certificates.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a319d784-603b-458d-8425-4acf63bf8561"],
              },
            },
            {
              _uid: "a319d784-603b-458d-8425-4acf63bf8561",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8ee0fae9-7401-41fe-bbd4-880ce0bb10a5_6c6f9fff-7f23-4f0e-a3e7-4645436eff8d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "63a23a79-ce4b-4a06-aad9-4a5107f56a92",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes ",
                "There could be occurrences where an entity receives cardholder data unsolicited via an insecure communication channel that was not intended for the purpose of receiving sensitive data. In this situation, the entity can choose to either include the channel in the scope of their CDE and secure it according to PCI DSS or implement measures to prevent the channel from being used for cardholder data.",
                "A self-signed certificate may also be acceptable if the certificate is issued by an internal CA within the organization, the certificate’s author is confirmed, and the certificate is verified—for example, via hash or signature—and has not expired. Note that self-signed certificates where the Distinguished Name (DN) field in the “issued by” and “issued to” field is the same are not acceptable.",
                "The bullet above (for confirming that certificates used to safeguard PAN during transmission over open, public networks are valid and are not expired or revoked) is a best practice until 31 March 2025, after which it will be required as part of Requirement 4.2.1 and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 53
        {
          fields: [
            {
              _uid: "b711c227-a7e1-42c0-95f6-fa1ed925a656",
              component: "col",
              label: "",
              simplifiedLabel: "4.2.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "9d37e117-6a31-4abc-9995-c40842088b56",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An inventory of the entity’s trusted keys and certificates used to protect PAN during transmission is maintained.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7946e7c8-3fc4-4b24-9248-0e43b5102950",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Examine the inventory of trusted keys and certificates.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d12a8b31-4b5f-4407-b08b-4e4891f1c624",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5e4b0820-88ef-45a8-ac47-964787a07a4d"],
              },
            },
            {
              _uid: "5e4b0820-88ef-45a8-ac47-964787a07a4d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "0d5f7896-0518-425e-92ac-4136ecdb5265_d12a8b31-4b5f-4407-b08b-4e4891f1c624",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a876ca55-6b0b-44f9-ac4c-1b9399ddcd24",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes ",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "488a3a4e-c289-4052-a9c1-6a2381dd496e",
              component: "col",
              label: "",
              simplifiedLabel: "4.2.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ee0f2938-288f-4d61-b1c5-2bf98352f6ae",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Wireless networks transmitting PAN or connected to the CDE use industry best practices to implement strong cryptography for authentication and transmission.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "04387491-1aa4-4e6f-8f93-417223e4b157",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a6415f4a-9381-437f-a828-73bd56184d39",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["275e6aed-def3-401a-9f42-ce8e55d05881"],
              },
            },
            {
              _uid: "275e6aed-def3-401a-9f42-ce8e55d05881",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "22c5855d-bdca-415b-8d4f-da14f5788919_a6415f4a-9381-437f-a828-73bd56184d39",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d172474e-171c-4252-99a1-bc1925f530fa",
              component: "col",
              label: "",
              simplifiedLabel: "4.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f7fd413c-2754-4ead-9d3e-294342940503",
              component: "col",
              label: [],
              simplifiedLabel: [
                "PAN is secured with strong cryptography whenever it is sent via end-user messaging technologies.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "816d0e52-a831-4081-9a58-12e0235aa616",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Examine system configurations and vendor documentation.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d28e1f71-f3e4-491f-ad1d-2df0501cf631",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8be14e16-fe42-4db7-85a5-7a13257587c2"],
              },
            },
            {
              _uid: "8be14e16-fe42-4db7-85a5-7a13257587c2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "5694efa2-384c-453d-8c39-077fb65682d1_d28e1f71-f3e4-491f-ad1d-2df0501cf631",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3c419148-e36f-4a6e-bbc6-8724e5e53067",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes ",
                "This requirement also applies if a customer, or other third-party, requests that PAN is sent to them via end-user messaging technologies.",
                "There could be occurrences where an entity receives unsolicited cardholder data via an insecure communication channel that was not intended for transmissions of sensitive data. In this situation, the entity can choose to either include the channel in the scope of their CDE and secure it according to PCI DSS or delete the cardholder data and implement measures to prevent the channel from being used for cardholder data.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 54
        {
          fields: [
            {
              _uid: "3509f7f3-c61c-4639-aa1c-4310a3dce318",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: [
                "Maintain a Vulnerability Management Program",
                "Requirement 5: Protect All Systems and Networks from Malicious Software",
                "5.1 Processes and mechanisms for protecting all systems and networks from malicious software are defined and understood",
              ],
              subBoldLabel: [],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "40a7d97d-fa7c-4606-ab0e-f32a48c917e2",
              component: "col",
              label: "",
              simplifiedLabel: "5.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "381e8ce7-f3df-4ee8-95b5-a26964705f85",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel:
                  "All security policies and operational procedures that are identified in Requirement 5 are:",
                ul: ["Documented.", "Kept up to date.", "In use.", "Known to all affected parties."],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4316f314-a635-4c01-aceb-c67614285def",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["1a6854f8-7f58-4697-8076-5de5f6aff15f"],
              },
            },
            {
              _uid: "1a6854f8-7f58-4697-8076-5de5f6aff15f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ef29af90-a942-46e5-958a-e59893e0e747_634bb0b1-4ea5-4fb0-9c4f-bac730b5d22a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9b37a327-2372-4ae8-bca2-ce5304c7ed63",
              component: "col",
              label: "",
              simplifiedLabel: "5.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "46ca8928-0a91-44ed-bc0a-272ce6c58150",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 5 are documented, assigned, and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "13d0b356-e3ba-42ca-aadc-43c355a6ff97",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "143743ac-a356-44fc-8a5d-eab58a753860",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a1bde51b-24a3-4c87-a645-fea41f853da9"],
              },
            },
            {
              _uid: "a1bde51b-24a3-4c87-a645-fea41f853da9",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "948ff944-99ad-4702-bc58-235e3327a383_143743ac-a356-44fc-8a5d-eab58a753860",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "062cee0b-5e22-4325-8428-95e6397ffc8b",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: ["5.2 Malicious software (malware) is prevented, or detected and addressed."],
              subBoldLabel: [],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "27797ae8-ed91-4244-ad3b-2b7dedd0003a",
              component: "col",
              label: "",
              simplifiedLabel: "5.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f81397b2-6cca-48c6-8fab-62710cc5d121",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An anti-malware solution(s) is deployed on all system components, except for those system components identified in periodic evaluations per Requirement 5.2.3 that concludes the system components are not at risk from malware.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cbc4fed8-b417-419a-876f-3e7ba2a30683",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system components", "• Examine the periodic evaluations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "edc64438-0429-4499-abeb-6e19b94d1630",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["4573adf6-6e39-471f-9bf9-498e01608ae0"],
              },
            },
            {
              _uid: "4573adf6-6e39-471f-9bf9-498e01608ae0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "1082383d-76d0-420e-be89-198309af7a59_edc64438-0429-4499-abeb-6e19b94d1630",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2d474c04-4f89-4194-91c8-a87f423cce44",
              component: "col",
              label: "",
              simplifiedLabel: "5.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0dbe2ec7-041e-403d-af41-c7af466f7e52",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel: "The deployed anti-malware solution(s):",
                ul: [
                  "Detects all known types of malware.",
                  "Removes, blocks, or contains all known types of malware.",
                ],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b08694c7-e570-49e3-9201-ed4d97ca632a",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine vendor documentation.", "Examine system configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f4d6e6de-8740-49b6-8890-1030b0d83094",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["bf43c4c3-373a-457a-b609-dd21da6e9828"],
              },
            },
            {
              _uid: "bf43c4c3-373a-457a-b609-dd21da6e9828",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "cdf9c5ef-bbb1-436e-90c9-4137fa267c24_f4d6e6de-8740-49b6-8890-1030b0d83094",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 55
        {
          fields: [
            {
              _uid: "5c63b065-253a-4e09-9db8-a8f664e0a3cd",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 5.2.3",
              subBoldLabel: [
                "System components covered by this requirement are those for which there is no anti-malware solution deployed per Requirement 5.2.1.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "461dc80d-587b-469d-ab26-e3adab0d160f",
              component: "col",
              label: "",
              simplifiedLabel: "5.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "984762d0-0a96-4153-ada5-742fbecdcc43",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel:
                  "Any system components that are not at risk for malware are evaluated periodically to include the following:",
                ul: [
                  "A documented list of all system components not at risk for malware.",
                  "Identification and evaluation of evolving malware threats for those system components",
                  "Confirmation whether such system components continue to not require anti-malware protection.",
                ],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7780c861-5b75-4d77-bbe0-9a0391b41021",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Interview personnel.",
                "Examine the list of system components not at risk for malware and compare against the system components without an anti-malware solution deployed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a049b982-8a08-4513-94b3-e02050ece2a8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["4e2d7a42-65d9-4108-91f2-fb4d627e66a7"],
              },
            },
            {
              _uid: "4e2d7a42-65d9-4108-91f2-fb4d627e66a7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "e8681aec-07b0-4c25-be80-e6b68f96d01e_a049b982-8a08-4513-94b3-e02050ece2a8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5c63b065-253a-4e09-9db8-a8f664e0a3cd",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 5.2.3.1",
              subBoldLabel: [
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be  fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "fa06c710-9a39-4b24-8365-02cf3897f24d",
              component: "col",
              label: "",
              simplifiedLabel: "5.2.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c9c623a0-6376-4c7e-9e93-5bd1f3851eb5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The frequency of periodic evaluations of system components identified as not at risk for malware is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "26b2e8bd-999b-4355-8642-d17dbe164952",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the targeted risk analysis.",
                "Examine documented results of periodic evaluations.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3114324c-32b1-444a-9e9f-a9cb2f644eb4",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8c32252b-f52c-4d2a-affc-816c644aefff"],
              },
            },
            {
              _uid: "8c32252b-f52c-4d2a-affc-816c644aefff",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "9ab2d478-727f-4aef-9150-ef0218e31a3a_3114324c-32b1-444a-9e9f-a9cb2f644eb4",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a14047f4-c0a5-47c5-bc20-bfb622edaa25",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "",
              subBoldLabel: ["5.3 Anti-malware mechanisms and processes are active, maintained, and monitored."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f000ab4d-9b6b-4bae-a9c8-47cc911c0aa2",
              component: "col",
              label: "",
              simplifiedLabel: "5.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a9bbf6d9-1a7c-4ef6-9477-2d7f45fa0eae",
              component: "col",
              label: [],
              simplifiedLabel: ["The anti-malware solution(s) is kept current via automatic updates."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "445db6f0-cd47-4dd2-bb0c-16760988d4ce",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine anti-malware solution(s) configurations, including any master installation",
                "Examine system components and logs.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8a2e8b27-ef43-460f-b9a0-e05e36109f82",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f6e682df-7be2-4232-89c5-5ad1ddb3f42a"],
              },
            },
            {
              _uid: "f6e682df-7be2-4232-89c5-5ad1ddb3f42a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "cbe82dea-853d-4814-81cc-6e16face7cc5_8a2e8b27-ef43-460f-b9a0-e05e36109f82",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 56
        {
          fields: [
            {
              _uid: "8af46790-bea6-4379-b1b4-ccfbf3f8a4a7",
              component: "col",
              label: "",
              simplifiedLabel: "5.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5f050469-d72e-48ca-ad45-be81ded70ed5",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel: "The anti-malware solution(s):",
                ul: [
                  "Performs periodic scans and active or real-time scans",
                  "OR",
                  "Performs continuous behavioral analysis of systems or processes.",
                ],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6e104e35-c4cb-491b-a83c-cf4bbe9490ae",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine anti-malware solution(s) configurations, including any master installation.",
                "Examine system components.",
                "Examine logs and scan results.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a8f8af09-efc3-4c31-a1fe-a258e03ba596",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6c904e40-1f83-400b-b4f5-8b662616f27c"],
              },
            },
            {
              _uid: "6c904e40-1f83-400b-b4f5-8b662616f27c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4c95357e-d577-43fd-8430-f0ed2afd86cb_a8f8af09-efc3-4c31-a1fe-a258e03ba596",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "75e1b102-ca81-401a-8660-06ff89b51e4a",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 5.3.2.1",
              subBoldLabel: [
                "This requirement applies to entities conducting periodic malware scans to meet Requirement 5.3.2.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "38543db3-c385-471a-9c43-74f86c607931",
              component: "col",
              label: "",
              simplifiedLabel: "5.3.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "d831d656-4b49-4d6e-957c-5877f648cc4f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If periodic malware scans are performed to meet Requirement 5.3.2, the frequency of scans is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1. ",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "5586ed57-6fe7-48f3-8047-49af3d293122",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the targeted risk analysis.",
                "Examine documented results of periodic malware scans.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["24484943-947e-4c55-8315-0991f1b26607"],
              },
            },
            {
              _uid: "24484943-947e-4c55-8315-0991f1b26607",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c60886d5-d448-46ae-9cfe-f082a09d6337_b54150bc-ff5c-4a4e-89ed-e464738c8fe1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f8ab2c33-3b94-4e59-b084-5bf9218c7ecf",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 5.3.3",
              subBoldLabel: [
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "84ba0ca1-48ee-49b7-973c-7b89818edec1",
              component: "col",
              label: "",
              simplifiedLabel: "5.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "4d52522b-bfc2-4364-b6fc-3e3bdfe96a88",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel: "For removable electronic media, the anti-malware solution(s): ",
                ul: [
                  "Performs automatic scans of when the media is inserted, connected, or logically mounted,",
                  "OR",
                  "Performs continuous behavioral analysis of systems or processes when the media is inserted, connected, or logically mounted.",
                ],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2f93396d-66a0-4a0c-b316-02330229c134",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine anti-malware solution(s) configurations.",
                "Examine system components with removable electronic media.",
                "Examine logs and scan results.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["bb9d776a-b64d-4a71-bab6-af06ee2715f1"],
              },
            },
            {
              _uid: "bb9d776a-b64d-4a71-bab6-af06ee2715f1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6bbfc3a7-0808-485c-a5d2-ebae2a2b2b44_ed428593-9b0d-4bfb-a0a3-bfdb1f07b867",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a13390ec-e29a-4beb-a032-99aad057aaaa",
              component: "col",
              label: "",
              simplifiedLabel: "5.3.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2de7417f-bd51-4829-988f-b20520222950",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Audit logs for the anti-malware solution(s) are enabled and retained in accordance with Requirement 10.5.1.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "457949f1-b1d8-46e0-bb42-3f15889495b2",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine anti-malware solution(s) configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1078d1eb-8b26-43e6-8a7c-f50baace4493",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ec9098c2-381c-42f9-a845-f9d0137caf6e"],
              },
            },
            {
              _uid: "ec9098c2-381c-42f9-a845-f9d0137caf6e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "1007e69c-0aff-4cc5-b4cd-a16058811aa7_1078d1eb-8b26-43e6-8a7c-f50baace4493",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 57
        {
          fields: [
            {
              _uid: "f411ba15-1356-438a-88d7-24f352427b12",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 5.3.5",
              subBoldLabel: [
                "Anti-malware solutions may be temporarily disabled only if there is a legitimate technical need, as authorized by management on a case-by-case basis. If anti-malware protection needs to be disabled for a specific purpose, it must be formally authorized. Additional security measures may also need to be implemented for the period during which anti-malware protection is not active.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9d19b2b7-1792-4640-b10c-6e0089aa37b1",
              component: "col",
              label: "",
              simplifiedLabel: "5.3.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "4d49a480-047e-4c31-a9e9-cbb4f0164d37",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Anti-malware mechanisms cannot be disabled or altered by users, unless specifically documented, and authorized by management on a case-by-case basis for a limited time period.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "82526f72-23ad-48e5-b909-d2c1c0f05487",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine anti-malware configurations.",
                "Observe processes.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "52b8d052-eb27-45ef-937b-4d805624e1d8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["cfed242a-d796-4005-b91d-38a5c725e07d"],
              },
            },
            {
              _uid: "cfed242a-d796-4005-b91d-38a5c725e07d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ebca1527-6a62-4731-99cc-f58bd54956b4_52b8d052-eb27-45ef-937b-4d805624e1d8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3f7f4d88-c07b-4f42-be14-fc659dd3c749",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: ["5.4 Anti-phishing mechanisms protect users against phishing attacks."],
              subBoldLabel: [],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5851539c-ced6-4fda-82eb-808e1142e13c",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 5.4.1",
              subBoldLabel: [
                "This requirement applies to the automated mechanism. It is not intended that the systems and services providing such automated mechanisms (such as e-mail servers) are brought into scope for PCI DSS.",
                "The focus of this requirement is on protecting personnel with access to system components inscope for PCI DSS.",
                "Meeting this requirement for technical and automated controls to detect and protect personnel against phishing is not the same as Requirement 12.6.3.1 for security awareness training. Meeting this requirement does not also meet the requirement for providing personnel with security awareness training, and vice versa.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e810b824-5418-433b-97a2-9feb8e772a72",
              component: "col",
              label: "",
              simplifiedLabel: "5.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "bf14c310-93a7-4b53-a319-2df5c34d6429",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Processes and automated mechanisms are in place to detect and protect personnel against phishing attacks.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "5f32152c-591d-4fbb-8a32-dc821df68731",
              component: "col",
              label: [],
              simplifiedLabel: ["Observe implemented processes", "Examine mechanisms."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3db0e72f-ebe7-4c0b-aa40-41c1000db6fd"],
              },
            },
            {
              _uid: "3db0e72f-ebe7-4c0b-aa40-41c1000db6fd",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d301ef8c-2640-4407-8070-f148f0521a49_7ba3c36e-fe1d-4a1c-b128-4ef28914e3b1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 58
        {
          fields: [
            {
              _uid: "12da06ab-9d37-48cf-846f-89f68728e271",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Requirement 6: Develop and Maintain Secure Systems and Software",
                "6.1 Processes and mechanisms for developing and maintaining secure systems and software are defined and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7a553f38-167f-40c9-851d-4c95e0589ab1",
              component: "col",
              label: "",
              simplifiedLabel: "6.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c1117aa8-39b4-4e8d-813f-5aed71cd19ae",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 6 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7dcbb581-e368-43ff-ae19-c1daff542348",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ec674070-83a0-4b78-bba5-81e3181a98db",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["103af842-ef1f-4917-9d13-a9faf8feca12"],
              },
            },
            {
              _uid: "103af842-ef1f-4917-9d13-a9faf8feca12",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "54fe3bca-5e7f-4eff-a678-2f0a1f2a4292_ec674070-83a0-4b78-bba5-81e3181a98db",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "93198981-109b-4e80-a5bb-a763073f1d95",
              component: "col",
              label: "",
              simplifiedLabel: "6.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6d4d28bb-d631-49e9-b041-16cf67f278b9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 6 are documented, assigned, and understood.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7413b3a0-39e8-4342-ae40-8d597d25a867",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "737b5356-777d-43fc-a56a-932b9728eb72",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ceca27e1-3462-4781-a851-1f1c9b357754"],
              },
            },
            {
              _uid: "ceca27e1-3462-4781-a851-1f1c9b357754",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "bc6b0b1b-7df3-46fd-a643-d7c96349b16d_737b5356-777d-43fc-a56a-932b9728eb72",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5b46f265-94eb-42d0-9a3f-73de398908a8",
              component: "col",
              label: "",
              simplifiedLabel: ["6.2 Bespoke and custom software are developed securely"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c566c8c2-0632-4932-987f-fa2ff386b983",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes For 6.2.1",
                "This applies to all software developed for or by the entity for the entity’s own use. This includes both bespoke and custom software. This does not apply to third-party software.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0db047e4-ed06-4b51-bf52-90600d69bd19",
              component: "col",
              label: "",
              simplifiedLabel: "6.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0a559e6a-8768-4151-a7d9-e5e2831b037e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Bespoke and custom software are developed securely, as follows:",
                "Based on industry standards and/or best practices for secure development.",
                "In accordance with PCI DSS (for example, secure authentication and logging).",
                "Incorporating consideration of information security issues during each stage of the software development lifecycle.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "96364df6-f29a-411a-8c3f-0bfb015bf28e",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented software development procedures."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c3c54abc-76a9-4ce2-a4a1-d8e0faeea075"],
              },
            },
            {
              _uid: "c3c54abc-76a9-4ce2-a4a1-d8e0faeea075",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "244004a9-17d5-44af-a76a-cfab4366f31a_18fb448b-e1e3-4609-b2c8-4ddb03ffbaec",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 59
        {
          fields: [
            {
              _uid: "c8d82987-67cd-4dc5-9c13-a71d6d9c7170",
              component: "col",
              label: "",
              simplifiedLabel: "6.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "90ce6015-61bb-4186-bc81-eaae623690a6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Software development personnel working on bespoke and custom software are trained at least once every 12 months as follows:",
                "On software security relevant to their job function and development languages.",
                "Including secure software design and secure coding techniques.",
                "Including, if security testing tools are used, how to use the tools for detecting vulnerabilities in software.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "fd2c5174-ffe6-47a3-8bd3-d0c7f93b877f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented software development procedures.",
                "Examine training records.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f39d5178-9751-45cc-9be8-5d29747ad464"],
              },
            },
            {
              _uid: "f39d5178-9751-45cc-9be8-5d29747ad464",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "641b7e87-c062-4abf-84bd-d6be5b5714f0_f88b4e60-1b70-41e2-a093-ad6b56b0b2c7",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "aec83bef-99cf-4c03-8d10-0b7996ac7b87",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Software development personnel remain knowledgeable about secure development practices; software security; and attacks against the languages, frameworks, or applications they develop. Personnel are able to access assistance and guidance when required.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bab0267f-ee91-4e55-983c-16200eee4bc5",
              component: "col",
              label: "",
              simplifiedLabel: "6.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "187f070b-d7a6-469f-bc5e-af7ee4b11679",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Bespoke and custom software is reviewed prior to being released into production or to customers, to identify and correct potential coding vulnerabilities, as follows:",
                "Code reviews ensure code is developed according to secure coding guidelines.",
                "Code reviews look for both existing and emerging software vulnerabilities.",
                "Appropriate corrections are implemented prior to release.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b3c032b9-3c47-4d4e-9f2a-56735c2cfd9b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented software development procedures.",
                "Interview responsible personnel.",
                "Examine evidence of changes to bespoke and custom software.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fd40467e-04cf-4de0-93b3-48769c0979b3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6eb3e381-47c6-4095-b546-55750ac04ec9"],
              },
            },
            {
              _uid: "6eb3e381-47c6-4095-b546-55750ac04ec9",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "96b6e2da-d881-483d-afe6-9df484b65b5f_fd40467e-04cf-4de0-93b3-48769c0979b3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "185a5674-b96e-4f23-9908-880c2a3d0502",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement for code reviews applies to all bespoke and custom software (both internal and public-facing), as part of the system development lifecycle.",
                "Public-facing web applications are also subject to additional controls, to address ongoing threats and vulnerabilities after implementation, as defined at PCI DSS Requirement 6.4.",
                "Code reviews may be performed using either manual or automated processes, or a combination of both.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 60
        {
          fields: [
            {
              _uid: "f4b17f78-392c-4473-bd8f-c03d0b0730d5",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes For 6.2.3.1",
                "Manual code reviews can be conducted by knowledgeable internal personnel or knowledgeable third-party personnel.",
                "An individual that has been formally granted accountability for release control and who is neither the original code author nor the code reviewer fulfills the criteria of being management.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e53de14b-58a5-4421-8e39-d89298a1d7d9",
              component: "col",
              label: "",
              simplifiedLabel: "6.2.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "122423ed-5bca-40ea-8104-82689f822519",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If manual code reviews are performed for bespoke and custom software prior to release to production, code changes are:",
                "Reviewed by individuals other than the originating code author, and who are knowledgeable about codereview techniques and secure coding practices.",
                "Reviewed and approved by management prior to release.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c56afd4f-b1e8-4351-8a26-78f75064e70e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented software development procedures.",
                "Interview responsible personnel.",
                "Examine evidence of changes to bespoke and custom software.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7ba9c223-de24-4a6d-b3f9-565e1356adcf",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["547119cf-5c02-441d-8e18-80e00f1af294"],
              },
            },
            {
              _uid: "547119cf-5c02-441d-8e18-80e00f1af294",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "7033aefa-b54f-4f23-a169-ad9842e39edb_7ba9c223-de24-4a6d-b3f9-565e1356adcf",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "589c0d59-caf1-4802-97a5-4888cd07c7bf",
              component: "col",
              label: "",
              simplifiedLabel: ["6.2.4"],
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7e197bf1-92fd-44a1-be9c-afef33374eec",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Software engineering techniques or other methods are defined and in use by software development personnel to prevent or mitigate common software attacks and related vulnerabilities in bespoke and custom software, including but not limited to the following:",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 4,
              width: "95%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b589682c-9781-49bf-be09-73c77554bbfb",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f0975326-e8b7-43dc-bcf6-bcc2cabe8816",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Injection attacks, including SQL, LDAP, XPath, or other command, parameter, object, fault, or injection-type flaws.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "236abe9b-5f47-4926-b609-c2e1de3d8293",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures.",
                "Interview responsible software development personnel.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e4bd43f0-523e-4aca-b763-abd0d4452765",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["0bc633ba-cb44-44c8-a9f4-6d9852136694"],
              },
            },
            {
              _uid: "0bc633ba-cb44-44c8-a9f4-6d9852136694",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4d1513f5-ca72-4ccf-83d4-121566ba1038_e4bd43f0-523e-4aca-b763-abd0d4452765",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f3dee26d-3aba-4374-9385-b9ea7c5732ee",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e529a785-7327-41e4-8b33-e30fe0aaec54",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Attacks on data and data structures, including attempts to manipulate buffers, pointers, input data, or shared data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "51190034-7659-462d-9192-76f662bcc9a2",
              component: "col",
              label: [],
              simplifiedLabel: [""],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["1bf6e5fd-6472-466a-bf7f-9d24e423271d"],
              },
            },
            {
              _uid: "1bf6e5fd-6472-466a-bf7f-9d24e423271d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "eb03bd3c-9669-4605-b1dd-713fc783022f_f742e5ee-866c-4ecc-853b-5bb7a3aa8e0e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c3973a39-e9a8-475d-8fa6-7d067e71eddd",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "34d7bd1a-89f3-4bde-886e-47ca7a660f69",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Attacks on cryptography usage, including attempts to exploit weak, insecure, or inappropriate cryptographic implementations, algorithms, cipher suites, or modes of operation.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d19dfdbb-6f79-468f-b69c-0c0a8a68e8f1",
              component: "col",
              label: [],
              simplifiedLabel: [""],
              hasLi: "no",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["cbd362f3-cf69-4d0a-b6bd-5c269639a185"],
              },
            },
            {
              _uid: "cbd362f3-cf69-4d0a-b6bd-5c269639a185",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8febe301-abf5-4671-99cb-28e7d973e8a2_e1d90790-67b0-4cf8-a1b0-adc93af5dd11",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 61
        {
          fields: [
            {
              _uid: "25f5d398-9139-4db6-9c0d-4ddfd84a4ff7",
              component: "col",
              label: "",
              simplifiedLabel: "6.2.4 (cont.)",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
              colSpan: "5",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b3319a7e-0704-4f91-a17c-a1d5b6ead5c1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "da9a2fba-f8d1-4ac6-86ea-8398cf11eaef",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Attacks on business logic, including attempts to abuse or bypass application features and functionalities through the manipulation of APIs, communication protocols and channels, client-side functionality, or other system/application functions and resources. This includes cross-site scripting (XSS) and cross-site request forgery (CSRF).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "53a126e8-eec9-4cfe-8635-bf7702f90a4b",
              component: "col",
              label: [],
              simplifiedLabel: [""],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "5734f093-fe98-433c-8f55-381d77d2e914",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e0f8b880-b475-44ab-b297-19f87340798d"],
              },
            },
            {
              _uid: "e0f8b880-b475-44ab-b297-19f87340798d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "bca48008-6ef4-4f5a-a7a8-dfa5311ebc29_5734f093-fe98-433c-8f55-381d77d2e914",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "25f5d398-9139-4db6-9c0d-4ddfd84a4ff7",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "93f7d8a6-a515-43ca-b7b4-3f0265cd7876",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Attacks on access control mechanisms, including attempts to bypass or abuse identification, authentication, or authorization mechanisms, or attempts to exploit weaknesses in the implementation of such mechanisms.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7dcbb581-e368-43ff-ae19-c1daff542348",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b1376447-ec2c-467f-bdf3-213ff8d87e88",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["d2457aa2-78b5-4251-9258-266edf7168c0"],
              },
            },
            {
              _uid: "d2457aa2-78b5-4251-9258-266edf7168c0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "19f1a181-7222-4cb7-9226-6e3980fbd900_b1376447-ec2c-467f-bdf3-213ff8d87e88",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f7437cea-852e-4473-972f-185e4afb7087",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "75e197a8-e1a7-4f65-9886-7d245fc5d4be",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Attacks via any “high-risk” vulnerabilities identified in the vulnerability identification process, as defined in Requirement 6.3.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "244d4b03-8b23-4ea4-8492-d39c1e862f73",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "81293d49-5af5-4f63-9986-3f05286030a4",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["259cdf9b-be5f-419a-af05-3e212cf5d60e"],
              },
            },
            {
              _uid: "259cdf9b-be5f-419a-af05-3e212cf5d60e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2e1a6c2f-faa4-4c6d-96c4-9287eb3bec20_81293d49-5af5-4f63-9986-3f05286030a4",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bd59c599-2f05-49eb-894c-f144ba69a175",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This applies to all software developed for or by the entity for the entity’s own use. This includes both bespoke and custom software. This does not apply to third-party software.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 62
        {
          fields: [
            {
              _uid: "12da06ab-9d37-48cf-846f-89f68728e271",
              component: "col",
              label: "",
              simplifiedLabel: ["6.3 Security vulnerabilities are identified and addressed."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7a553f38-167f-40c9-851d-4c95e0589ab1",
              component: "col",
              label: "",
              simplifiedLabel: "6.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c1117aa8-39b4-4e8d-813f-5aed71cd19ae",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Security vulnerabilities are identified and managed as follows:",
                "New security vulnerabilities are identified using industry-recognized sources for security vulnerability information, including alerts from international and national computer emergency response teams (CERTs)",
                "Vulnerabilities are assigned a risk ranking based on industry best practices and consideration of potential impact.",
                "Risk rankings identify, at a minimum, all vulnerabilities considered to be a high-risk or critical to the environment.",
                "Bullet intentionally left blank for this SAQ.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7dcbb581-e368-43ff-ae19-c1daff542348",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures",
                "Interview responsible personnel.",
                "Examine documentation.",
                "Observe processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0d0c3531-eb15-43b7-950b-4d638136c650",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b6c4dcc2-eca7-4d71-9140-30fd51c51437"],
              },
            },
            {
              _uid: "b6c4dcc2-eca7-4d71-9140-30fd51c51437",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "54fe3bca-5e7f-4eff-a678-2f0a1f2a4292_0d0c3531-eb15-43b7-950b-4d638136c650",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e74bf7b4-87a6-4784-a3a4-f534905c4623",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not achieved by, nor is it the same as, vulnerability scans performed for Requirements 11.3.1 and 11.3.2. This requirement is for a process to actively monitor industry sources for vulnerability information and for the entity to determine the risk ranking to be associated with each vulnerability.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5a46e817-1f1d-45a2-874f-4b5b3ff33acc",
              component: "col",
              label: "",
              simplifiedLabel: "6.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ee7366c6-db6c-441c-8ff9-4342f9b98081",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An inventory of bespoke and custom software, and third-party software components incorporated into bespoke and custom software is maintained to facilitate vulnerability and patch management.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b7c27b7d-5d0c-404d-95c5-983d28a14be2",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "58ab2b79-62cf-45ca-993c-51a301a1696f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["df3fdd17-a9e5-48fe-81af-9c5fe8023be2"],
              },
            },
            {
              _uid: "df3fdd17-a9e5-48fe-81af-9c5fe8023be2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f70cff70-ed2c-442d-957a-da283e0da99a_58ab2b79-62cf-45ca-993c-51a301a1696f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "abfa6281-8003-4c2b-b5df-b3eba2a7e6ad",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 63
        {
          fields: [
            {
              _uid: "e869cd09-3289-4ece-8f2c-50a91babb8f7",
              component: "col",
              label: "",
              simplifiedLabel: "6.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a918fb51-9dc6-4f7e-94a6-b205be8771fc",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All system components are protected from known vulnerabilities by installing applicable security patches/updates as follows:",
                "Critical or high-security patches/updates are installed within one month of release.",
                "Bullet intentionally left blank for this SAQ.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "047f88e2-a726-4ab4-8025-37ee9788c4c2",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine system components and related software.",
                "Compare list of security patches installed to recent vendor patch lists.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "4d7772bb-b114-4f5d-8a59-7a10522f9edb",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["1d980035-33ce-4dba-a148-760180419abd"],
              },
            },
            {
              _uid: "1d980035-33ce-4dba-a148-760180419abd",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "085d8b7f-ade1-4389-8d44-c528a96965ba_4d7772bb-b114-4f5d-8a59-7a10522f9edb",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ecb56b59-1ecb-4f95-9c30-8495a51c241e",
              component: "col",
              label: "",
              simplifiedLabel: ["6.4 Public-facing web applications are protected against attacks."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7a553f38-167f-40c9-851d-4c95e0589ab1",
              component: "col",
              label: "",
              simplifiedLabel: "6.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "324059ab-cf94-4918-ac50-bffec26721cc",
              component: "col",
              label: [],
              simplifiedLabel: [
                "For public-facing web applications, new threats and vulnerabilities are addressed on an ongoing basis and these applications are protected against known attacks as follows:",
                "Reviewing public-facing web applications via manual or automated application vulnerability security assessment tools or methods as follows:",
                "At least once every 12 months and after significant changes.",
                "By an entity that specializes in application security.",
                "Including, at a minimum, all common software attacks in Requirement 6.2.4.",
                "All vulnerabilities are ranked in accordance with Requirement 6.3.1.",
                "All vulnerabilities are corrected.",
                "The application is re-evaluated after the corrections.",
                "OR",
                "Installing an automated technical solution(s) that continually detects and prevents web-based attacks as follows:",
                "Installed in front of public-facing web applications to detect and prevent web-based attacks.",
                "Actively running and up to date as applicable.",
                "Generating audit logs.",
                "Configured to either block web-based attacks or generate an alert that is immediately investigated.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "38f78bd4-3551-4eb5-b33b-1ebb6154d9b6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented processes.",
                "Interview personnel.",
                "Examine records of application security assessments.",
                "Examine the system configuration settings and audit logs.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "66217eb7-4aec-4fed-b0b8-b7f204a4cdbf",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3cbfb06f-fe80-4b7d-9c37-8ee299f48fb9"],
              },
            },
            {
              _uid: "3cbfb06f-fe80-4b7d-9c37-8ee299f48fb9",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "558ca27d-288d-4904-8547-0051884e6457_66217eb7-4aec-4fed-b0b8-b7f204a4cdbf",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "85af2afb-c941-41d5-b5ed-c09122967b0d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This assessment is not the same as the vulnerability scans performed for Requirement 11.3.1 and 11.3.2.",
                "This requirement will be superseded by Requirement 6.4.2 after 31 March 2025 when Requirement 6.4.2 becomes effective.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 64
        {
          fields: [
            {
              _uid: "3761f395-602a-4768-9392-2ca53405a79b",
              component: "col",
              label: "",
              simplifiedLabel: "6.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a80462d4-2d8b-4063-9786-714b16074458",
              component: "col",
              label: [],
              simplifiedLabel: [
                "For public-facing web applications, an automated technical solution is deployed that continually detects and prevents web-based attacks, with at least the following:",
                "Is installed in front of public-facing web applications and is configured to detect and prevent web-based attacks.",
                "Actively running and up to date as applicable. ",
                "Generating audit logs.",
                "Configured to either block web-based attacks or generate an alert that is immediately investigated.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c45f1b0a-6fc7-4bcb-bbeb-a5ab610deb02",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the system configuration settings.",
                "Examine audit logs.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f9af4847-2f17-4b20-8e36-6a38e0e8858f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["20168ce8-1f6e-4b1a-a592-2ef60cd53051"],
              },
            },
            {
              _uid: "20168ce8-1f6e-4b1a-a592-2ef60cd53051",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "97739828-6928-483e-8f66-b33d7e8a9a7c_f9af4847-2f17-4b20-8e36-6a38e0e8858f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "840afa4d-8383-4a50-b8b9-ed808856d421",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This new requirement will replace Requirement 6.4.1 once its effective date is reached.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 65
        {
          fields: [
            {
              _uid: "10220719-8581-4652-b0e1-153eaffc8154",
              component: "col",
              label: "",
              simplifiedLabel: ["6.4.3"],
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "16892fdf-04cd-448e-a84b-8d383e5e0bff",
              component: "col",
              label: "",
              simplifiedLabel: [
                "All payment page scripts that are loaded and executed in the consumer’s browser are managed as follows:",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 4,
              width: "95%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "dcbd443b-f2a8-4253-86f6-1524ae1e6767",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1fcc2fea-ba6b-4623-ae51-10b8d4745316",
              component: "col",
              label: [],
              simplifiedLabel: ["A method is implemented to confirm that each script is authorized."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d71bc8c2-6c41-4cd4-93d1-0d69c7e56fe2",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the data retention and disposal policies, procedures, and processes.",
                "Interview personnel.",
                "Examine files and system records on system components where account data is stored.",
                "Observe the mechanisms used to render account data unrecoverable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f924b88d-68af-4408-bcb3-c172f281d11b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b4b7987d-20a2-4990-b3df-4fb2325a9748"],
              },
            },
            {
              _uid: "b4b7987d-20a2-4990-b3df-4fb2325a9748",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3601bae6-2439-4c3e-a180-358dc68973b1_f924b88d-68af-4408-bcb3-c172f281d11b",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b4e1bf8f-adb1-481d-8fe0-af3b34fbb7de",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "43ab50e6-06ab-4df5-91b2-872e12a68acf",
              component: "col",
              label: [],
              simplifiedLabel: ["A method is implemented to assure the integrity of each script."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "bf5b5574-271f-4979-861e-ccfd25bd1a92",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the data retention and disposal policies, procedures, and processes.",
                "Interview personnel.",
                "Examine files and system records on system components where account data is stored.",
                "Observe the mechanisms used to render account data unrecoverable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0bd82c76-f93d-46ba-9387-7b82a21783fc",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8bc63c9c-a8b4-4994-b26f-80da694a7270"],
              },
            },
            {
              _uid: "8bc63c9c-a8b4-4994-b26f-80da694a7270",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "24892712-fc5a-41c1-bd57-0e7dd9945bf3_0bd82c76-f93d-46ba-9387-7b82a21783fc",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5c4a0575-581c-481d-9716-7d33f4190eb2",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f67729dc-f624-4377-ac71-fd3d99607849",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An inventory of all scripts is maintained with written justification as to why each is necessary.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "fc427a4d-4f0d-484d-b64f-c387c743acc1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the data retention and disposal policies, procedures, and processes.",
                "Interview personnel.",
                "Examine files and system records on system components where account data is stored.",
                "Observe the mechanisms used to render account data unrecoverable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b90af7dd-93f0-408e-9a94-e75aaf7973fd"],
              },
            },
            {
              _uid: "b90af7dd-93f0-408e-9a94-e75aaf7973fd",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "50d32aae-1a79-404a-984d-ad5873c3c2a2_f2c103a1-a8a9-49e4-933e-e0c770ac4b38",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4442f0e5-1236-4178-babf-9864b35e705e",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies to all scripts loaded from the entity’s environment and scripts loaded from third and fourth parties.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 66
        {
          fields: [
            {
              _uid: "8881e26a-63b9-40bb-8903-d44c006f9045",
              component: "col",
              label: "",
              simplifiedLabel: ["6.5 Changes to all system components are managed securely."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "42912d77-8072-42fc-80d9-211a8e6edf82",
              component: "col",
              label: "",
              simplifiedLabel: "6.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "befb54b6-be2c-4ca0-ab00-e648d7ec3cab",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Changes to all system components in the production environment are made according to established procedures that include:",
                "Reason for, and description of, the change.",
                "Documentation of security impact.",
                "Documented change approval by authorized parties.",
                "Testing to verify that the change does not adversely impact system security.",
                "For bespoke and custom software changes, all updates are tested for compliance with Requirement 6.2.4 before being deployed into production.",
                "Procedures to address failures and return to a secure state.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6b5a0621-3706-49f6-b1ee-31c9f90bbd69",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented change control procedures.",
                "Examine recent changes to system components and trace changes to change control documentation.",
                "Examine change control documentation.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "32eb36ba-7fc1-498a-89bd-9a57e089ea28",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["62f5f29a-d14b-4051-aee3-40609f8ae084"],
              },
            },
            {
              _uid: "62f5f29a-d14b-4051-aee3-40609f8ae084",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "0f26db00-8db3-4446-8f26-6f29009d1775_32eb36ba-7fc1-498a-89bd-9a57e089ea28",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "631a8a52-482f-4ded-b868-84c82e365e1d",
              component: "col",
              label: "",
              simplifiedLabel: "6.5.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f53c2337-f214-42ea-9779-ed105522d691",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Upon completion of a significant change, all applicable PCI DSS requirements are confirmed to be in place on all new or changed systems and networks, and documentation is updated as applicable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0c918024-0c0f-49d9-8e54-6dc649437548",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documentation for significant changes.",
                "Interview personnel.",
                "Observe the affected systems/networks.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0404379c-9953-4bd2-a753-104cb6956a91",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3e00e80b-35d7-4782-9fc1-405f0047f132"],
              },
            },
            {
              _uid: "3e00e80b-35d7-4782-9fc1-405f0047f132",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d6236280-a41a-48f3-850d-bc160b7dafb5_0404379c-9953-4bd2-a753-104cb6956a91",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "95303a97-d216-4425-9099-cc4a726a9f05",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This Applicability Note was intentionally removed as it does not apply to this SAQ.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6657a8db-d0b0-44e8-861f-ca5f3f8dbd05",
              component: "col",
              label: "",
              simplifiedLabel: "6.5.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "9db0e3b2-7d5b-40ed-bf35-ab6bb899cb21",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Pre-production environments are separated from production environments and the separation is enforced with access controls.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "27d34d0d-63a4-4460-b761-64fdd4ebf8e4",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine network documentation and configurations of network security controls.",
                "Examine access control settings.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1b4e9ca3-0273-4581-a9d9-51bf0f9ffe59",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8bbf536e-c3e0-4597-9cb9-18ce15075cb7"],
              },
            },
            {
              _uid: "8bbf536e-c3e0-4597-9cb9-18ce15075cb7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "87266868-8d86-470b-9d4b-9471a8fdb17f_1b4e9ca3-0273-4581-a9d9-51bf0f9ffe59",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        // 67
        {
          fields: [
            {
              _uid: "80b1b079-fb15-44cc-b996-73292dac77ef",
              component: "col",
              label: "",
              simplifiedLabel: "6.5.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0189cf28-f024-4db7-ae4e-f28197f4f8f1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and functions are separated between production and pre-production environments to provide accountability such that only reviewed and approved changes are deployed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d8c2a5de-706b-4af3-b98b-fb70bfc8cb7c",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine policies and procedures.", "Observe processes.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c05858f3-aa24-4b20-837c-f5d513fbece1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["82d84544-b7ce-404c-b762-739e9b5cd323"],
              },
            },
            {
              _uid: "82d84544-b7ce-404c-b762-739e9b5cd323",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4d370ead-2bac-4aa8-9d1c-b09ea6ac428a_c05858f3-aa24-4b20-837c-f5d513fbece1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "37fd4048-7332-479e-b42c-20c763ae6d50",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "In environments with limited personnel where individuals perform multiple roles or functions, this same goal can be achieved with additional procedural controls that provide accountability. For example, a developer may also be an administrator that uses an administrator-level account with elevated privileges in the development environment and, for their developer role, they use a separate account with user-level access to the production environment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b5cd9208-d70e-4447-a639-beecfdacb24b",
              component: "col",
              label: "",
              simplifiedLabel: "6.5.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3b1f1659-3df4-4021-aac4-6f205d848a09",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Live PANs are not used in pre-production environments, except where those environments are included in the CDE and protected in accordance with all applicable PCI DSS requirements.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "369c5d7c-e72c-4eb7-8749-260e0d280285",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Observe testing processes.",
                "Interview personnel.",
                "Examine pre-production test data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "883622d0-8e81-4c71-aeb5-6c04e300cc3e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9ff0b379-bfc6-44b7-bb0d-65107fe65a19"],
              },
            },
            {
              _uid: "9ff0b379-bfc6-44b7-bb0d-65107fe65a19",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6b43a375-1cb9-4ae7-81a4-0970cdbbdacd_883622d0-8e81-4c71-aeb5-6c04e300cc3e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "dddb3c35-1138-45ff-8a5c-60e3d00949aa",
              component: "col",
              label: "",
              simplifiedLabel: "6.5.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "66e3ff15-0b09-4db6-8f5e-112993a68b43",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Test data and test accounts are removed from system components before the system goes into production.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9e421ba5-ecef-4f54-85ce-6fac6070a8a9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Observe testing processes for both off-the-shelf software and in-house applications.",
                "Interview personnel.",
                "Examine data and accounts for recently installed or updated off-the-shelf software and in-house applications.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "48d2b90c-b6c9-402d-a3ef-65b806dea62e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2d24c9d0-8156-4671-8c8e-6efd5a98697e"],
              },
            },
            {
              _uid: "2d24c9d0-8156-4671-8c8e-6efd5a98697e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6e4bd586-a58b-45db-9208-4c0f84e9e1c4_48d2b90c-b6c9-402d-a3ef-65b806dea62e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 68
        {
          fields: [
            {
              _uid: "41d467ef-94b4-406b-8cd7-1b56894e4fa8",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Implement Strong Access Control Measures",
                "Requirement 7: Restrict Access to System Components and Cardholder Data by Business Need to Know",
                "7.1 Processes and mechanisms for restricting access to system components and cardholder data by business need to know are defined and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0ae63149-e99a-4d8c-a67d-7d6a27fba502",
              component: "col",
              label: "",
              simplifiedLabel: "7.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "41dc6d03-9dc0-479c-92a9-9590082413d0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 7 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "dfc7a5d1-1a8d-4d48-bf33-e2ecaa1b647f",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2da8fbbc-2dcf-4cd7-b96b-74720247bf3b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["89a9ba31-9d62-4633-b9c2-546c427e7368"],
              },
            },
            {
              _uid: "89a9ba31-9d62-4633-b9c2-546c427e7368",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2bc86c04-828b-495a-ab79-1043d9f8c4a3_2da8fbbc-2dcf-4cd7-b96b-74720247bf3b",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2f163504-7b4f-4b02-99db-7d4c4ed628ff",
              component: "col",
              label: "",
              simplifiedLabel: "7.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c439a0fc-12ca-4ed6-8466-a79be56d0637",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 7 are documented, assigned, and understood.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "336677cc-b2ae-4f66-ae90-9a07b10cc993",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "08d6d01f-6a6e-4ca9-bcaf-0b88343676c0",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["076aabb2-de6d-4315-9d02-a4e7150d6939"],
              },
            },
            {
              _uid: "076aabb2-de6d-4315-9d02-a4e7150d6939",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "85f015a1-a956-4cec-a3b2-f4bd0d44f9f6_08d6d01f-6a6e-4ca9-bcaf-0b88343676c0",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6a25b139-e90a-445a-8810-7f5f7c21c5e8",
              component: "col",
              label: "",
              simplifiedLabel: ["7.2 Access to system components and data is appropriately defined and assigned."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ae6c260b-93dc-441d-bd52-1dc8086fab4c",
              component: "col",
              label: "",
              simplifiedLabel: "7.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ba184c40-01bb-4f58-82f7-71ec02dc9983",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An access control model is defined and includes granting access as follows:",
                "Appropriate access depending on the entity’s business and access needs.",
                "Access to system components and data resources that is based on users’ job classification and functions.",
                "The least privileges required (for example, user, administrator) to perform a job function.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d32d6ae0-12c5-4a6c-8cf4-2ba9a379ba0e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Interview personnel.",
                "Examine access control model settings.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0384136e-2c52-4e0f-81a0-68a51c623ba4",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b42e246c-f8b1-424d-a668-74fc7c91f6f0"],
              },
            },
            {
              _uid: "b42e246c-f8b1-424d-a668-74fc7c91f6f0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3456f16f-be1e-4a98-bc03-8fec9de6a3b9_0384136e-2c52-4e0f-81a0-68a51c623ba4",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        // 69
        {
          fields: [
            {
              _uid: "4d4cfddb-540a-41d8-8293-97a0daa4e363",
              component: "col",
              label: "",
              simplifiedLabel: "7.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "befc4c5f-8509-492d-9479-b77166d5588e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Access is assigned to users, including privileged users, based on:",
                "Job classification and function.",
                "Least privileges necessary to perform job responsibilities.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "fb9c675f-b5ed-4b72-b609-f6e50d396804",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine user access settings, including for privileged users.",
                "Interview responsible management personnel.",
                "Interview personnel responsible for assigning access.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["19155fad-c31d-4958-8e6e-3a100134b1b6"],
              },
            },
            {
              _uid: "19155fad-c31d-4958-8e6e-3a100134b1b6",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a7b770fc-ec17-40e4-90f0-8769f2b099cc_ff63fbeb-db1c-4325-baca-3a8432dbe7b7",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d332a58f-91df-4dc2-9d5d-45353f15552b",
              component: "col",
              label: "",
              simplifiedLabel: "7.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5a7f3fae-93e6-4ed0-b8ca-689681753fa6",
              component: "col",
              label: [],
              simplifiedLabel: ["Required privileges are approved by authorized personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7fc6ae4f-8b48-4c17-ab8d-07b8088e8182",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine user IDs and assigned privileges.",
                "Examine documented approvals.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "37b133a1-e6ba-4808-987a-9a709354e4a3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["0e17c8b7-f94f-4f2a-b0cb-5ba6fdb9993b"],
              },
            },
            {
              _uid: "0e17c8b7-f94f-4f2a-b0cb-5ba6fdb9993b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "9ccfad93-5bca-4701-9825-9788518e3be6_37b133a1-e6ba-4808-987a-9a709354e4a3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "066382ec-e66c-4143-8546-2fbef1004380",
              component: "col",
              label: "",
              simplifiedLabel: "7.2.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f8313104-9772-4508-b5af-d1132dccdce8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All user accounts and related access privileges, including third-party/vendor accounts, are reviewed as follows:",
                "At least once every six months.",
                "To ensure user accounts and access remain appropriate based on job function.",
                "Any inappropriate access is addressed.",
                "Management acknowledges that access remains appropriate.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0be44d02-bacb-44d6-a7ee-1c68f620ebc5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Interview responsible personnel.",
                "Examine documented results of periodic reviews of user accounts.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d9784db8-2699-4408-9d11-94dd8f4950e0",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5c5c727e-5255-4b20-8cd4-3942e2bb6cd1"],
              },
            },
            {
              _uid: "5c5c727e-5255-4b20-8cd4-3942e2bb6cd1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "349c3cb8-0550-4eee-9543-62071866d383_d9784db8-2699-4408-9d11-94dd8f4950e0",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e84867e2-79de-4a49-826b-3ddf8c358d0a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies to all user accounts and related access privileges, including those used by personnel and third parties/vendors, and accounts used to access third-party cloud services.",
                "See Requirements 7.2.5 and 7.2.5.1 and 8.6.1 through 8.6.3 for controls for application and system accounts.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 70
        {
          fields: [
            {
              _uid: "6d569fbe-09f2-48f6-9049-0299c754ae60",
              component: "col",
              label: "",
              simplifiedLabel: "7.2.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c341f456-a2e6-4f55-bb3b-2bd50dbf9602",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All application and system accounts and related access privileges are assigned and managed as follows:",
                "Based on the least privileges necessary for the operability of the system or application.",
                "Access is limited to the systems, applications, or processes that specifically require their use.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cf62b635-e7c3-4e9d-8756-7a6277304315",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine privileges associated with system and application accounts.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "509cf493-4e2c-464d-89f5-94aa8ff7536e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["4f952d87-c6e4-47c7-9bc5-2eedf8bf4f94"],
              },
            },
            {
              _uid: "4f952d87-c6e4-47c7-9bc5-2eedf8bf4f94",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "dd35848d-cfd6-437e-9d3d-6d7c8c5ca3d8_509cf493-4e2c-464d-89f5-94aa8ff7536e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6122cd70-5b67-4e62-a855-e001bf2beb03",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3986888b-eb3f-44e8-94a1-86ffd51a06f8",
              component: "col",
              label: "",
              simplifiedLabel: "7.2.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c4b2756a-6073-4d8e-a056-726d55b41fe4",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All access by application and system accounts and related access privileges are reviewed as follows:",
                "Periodically (at the frequency defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1).",
                "The application/system access remains appropriate for the function being performed.",
                "Any inappropriate access is addressed.",
                "Management acknowledges that access remains appropriate.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "045052e1-50af-4768-86bc-1e7f5a91d9c6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine the targeted risk analysis.",
                "Interview responsible personnel.",
                "Examine documented results of periodic reviews of system and application accounts and related privileges.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1a2eef2f-29ea-4cb0-8c01-a0dccdc44ef3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f4208337-fccf-4d86-8afd-45729fa13fe6"],
              },
            },
            {
              _uid: "f4208337-fccf-4d86-8afd-45729fa13fe6",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "36f5e589-7a57-469c-8b7c-c4aa86d6db7a_1a2eef2f-29ea-4cb0-8c01-a0dccdc44ef3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "74e3a467-bd86-4f24-8e8d-ecf7bede0f9a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 71
        {
          fields: [
            {
              _uid: "5aa931c7-4b20-4c2a-8642-373afa2f5da7",
              component: "col",
              label: "",
              simplifiedLabel: "7.2.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "366a8827-68ee-4b04-bec8-9eb8518b4244",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All user access to query repositories of stored cardholder data is restricted as follows:",
                "Via applications or other programmatic methods, with access and allowed actions based on user roles and least privileges.",
                "Only the responsible administrator(s) can directly access or query repositories of stored CHD.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "68421423-1f74-47c1-be77-188169fb534c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Interview personnel.",
                "Examine configuration settings for querying repositories of stored cardholder data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "54e70fcf-a01e-4376-b219-dad1b054b42c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3cdac555-27fc-4cc1-9494-6e1f9d724778"],
              },
            },
            {
              _uid: "3cdac555-27fc-4cc1-9494-6e1f9d724778",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6c33a72c-82b5-4f33-b419-38fa8ad6b70c_54e70fcf-a01e-4376-b219-dad1b054b42c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1ffe7176-abb9-4030-a4fa-174b3f0f2d8e",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies to controls for user access to query repositories of stored cardholder data.",
                "See Requirements 7.2.5 and 7.2.5.1 and 8.6.1 through 8.6.3 for controls for application and system accounts.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b0ab2b87-bb48-4a1a-8289-1d49b16984de",
              component: "col",
              label: "",
              simplifiedLabel: [
                "7.3 Access to system components and data is managed via an access control system(s)",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7253eae0-a29d-4d12-9db7-309856a8f709",
              component: "col",
              label: "",
              simplifiedLabel: "7.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "70372484-f60b-4bf1-8e2c-848e9fe251a7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An access control system(s) is in place that restricts access based on a user’s need to know and covers all system components.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "dd8aaeeb-c19c-4464-ad34-dad8cb747d2b",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine vendor documentation.", "Examine configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "4893ca9d-4138-439f-845a-2b50557b89f3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6237f49f-a0c5-4b91-b82a-737c27f97f0b"],
              },
            },
            {
              _uid: "6237f49f-a0c5-4b91-b82a-737c27f97f0b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8b8f0433-89ba-4df1-87d0-e3d2c65d295d_4893ca9d-4138-439f-845a-2b50557b89f3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "cf17c737-4470-41e7-9fa3-57e504b1fbb1",
              component: "col",
              label: "",
              simplifiedLabel: "7.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e174e350-c71b-46c8-89f8-03aa7d48c008",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The access control system(s) is configured to enforce permissions assigned to individuals, applications, and systems based on job classification and function.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6102188a-de32-4054-9fb3-121dafad1449",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine vendor documentation.", "Examine configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "675f37e4-97c0-4f88-912e-51ed0524ff67",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f260f139-3650-4db4-8303-1f5be69bd5a2"],
              },
            },
            {
              _uid: "f260f139-3650-4db4-8303-1f5be69bd5a2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c6cc4001-aa14-4ff5-9317-b62f94d7f6a5_675f37e4-97c0-4f88-912e-51ed0524ff67",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3ecbc7cb-2b5f-402e-926a-5508bfc8e98e",
              component: "col",
              label: "",
              simplifiedLabel: "7.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f7882436-1721-442b-977e-4b6e43a44290",
              component: "col",
              label: [],
              simplifiedLabel: ["The access control system(s) is set to “deny all” by default."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ad353400-e4b9-41d3-adad-c4b49327e554",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine vendor documentation.", "Examine configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ea8b9ccf-12ec-494e-abfa-a9f5ed522dca",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["de365122-b77d-44fd-a4da-6c95fc1bae4a"],
              },
            },
            {
              _uid: "de365122-b77d-44fd-a4da-6c95fc1bae4a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "aa17639a-e5be-487a-8889-46cfaa441d9e_ea8b9ccf-12ec-494e-abfa-a9f5ed522dca",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 72
        {
          fields: [
            {
              _uid: "cf98f849-cbcd-425d-933c-385eaee10472",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Requirement 8: Identify Users and Authenticate Access to System Components",
                "8.1 Processes and mechanisms for identifying users and authenticating access to system components are defined and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "935f4feb-6904-4e40-b350-bbe3f0ef4232",
              component: "col",
              label: "",
              simplifiedLabel: "8.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e35876f9-5ace-46bc-8593-e50a24691a6b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 8 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cf6faa36-d4f8-454e-bd4c-4844e0be95e1",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c46eba6c-442d-4889-be80-948496820222",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["22667b31-88cd-4ab7-a210-7052ac23ace3"],
              },
            },
            {
              _uid: "22667b31-88cd-4ab7-a210-7052ac23ace3",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c4798097-316d-4b59-9588-0319cd0a3b35_c46eba6c-442d-4889-be80-948496820222",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b78289d4-77e6-466c-8995-25d120f5927f",
              component: "col",
              label: "",
              simplifiedLabel: "8.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e00b9c1c-8858-41a4-bbfc-77c6baf2e04f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 8 are documented, assigned, and understood",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cbfd8704-cdd7-466c-9b23-9ed173862a90",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2c6ad52d-e1b8-46ee-8930-a1f225ec4667",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7cc5949a-d7b7-42bc-a711-5a6366a8e362"],
              },
            },
            {
              _uid: "7cc5949a-d7b7-42bc-a711-5a6366a8e362",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "cbab7601-3ed5-45e9-9de0-a8cf79ddb7fc_2c6ad52d-e1b8-46ee-8930-a1f225ec4667",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8d6498d8-2cdd-4d8c-bf5a-154fc255988b",
              component: "col",
              label: "",
              simplifiedLabel: [
                "8.2 User identification and related accounts for users and administrators are strictly managed throughout an account’s lifecycle.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "59cc92ec-d73a-4bec-ad3e-fbc7231e57ff",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f19a517e-1312-4c0d-a813-dd905d58fcde",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All users are assigned a unique ID before access to system components or cardholder data is allowed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ec116060-df10-41ce-bd38-cc7add5e057d",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview responsible personnel", "Examine audit logs and other evidence."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "697b2020-5b53-41ad-8833-10ca32041cc7",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a493012a-ddda-48d0-b0f2-c17c9b356147"],
              },
            },
            {
              _uid: "a493012a-ddda-48d0-b0f2-c17c9b356147",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4bb007ce-1574-4125-bced-4783d3f150f7_697b2020-5b53-41ad-8833-10ca32041cc7",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1ebe5fab-3375-4a80-bafb-efe25f0d350b",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 73
        {
          fields: [
            {
              _uid: "ea1f1537-ac35-4346-84ba-3b4337d9903e",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1fef28b4-fac7-4574-8e90-f384c22c77a4",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Group, shared, or generic accounts, or other shared authentication credentials are only used when necessary on an exception basis, and are managed as follows:",
                "Account use is prevented unless needed for an exceptional circumstance.",
                "Use is limited to the time needed for the exceptional circumstance.",
                "Business justification for use is documented.",
                "Use is explicitly approved by management.",
                "Individual user identity is confirmed before access to an account is granted.",
                "Every action taken is attributable to an individual user.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "edd8b309-883f-4fd5-b055-a3e2062d4432",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine user account lists on system components and applicable documentation.",
                "Examine authentication policies and procedures.",
                "Interview system administrators.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d0c21492-395c-4ebc-906a-90aa3b4751df",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["fff8c025-dc66-4447-846d-4a796d2298a6"],
              },
            },
            {
              _uid: "fff8c025-dc66-4447-846d-4a796d2298a6",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "894ab185-0398-41bd-b828-456fdf382749_d0c21492-395c-4ebc-906a-90aa3b4751df",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2cbf1a8f-1e16-4398-aa05-c9068f98ff55",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2f2f7444-62e2-4e5a-b2a9-aa97efde2956",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "969c404e-a768-4b52-b0a5-ac8ad569bcac",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "Service providers with remote access to customer premises use unique authentication factors for each customer premises",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cb21928b-e4ea-47c4-b10b-213a78219ca7",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine authentication policies and procedures.", "Interview  personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2257fd27-8db6-4339-8c97-69c29af0bcaa",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["74905ac9-9327-4dee-abf3-615a2200c919"],
              },
            },
            {
              _uid: "74905ac9-9327-4dee-abf3-615a2200c919",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "b71a1b6d-f484-44ce-8b4f-d6bbd3630e81_2257fd27-8db6-4339-8c97-69c29af0bcaa",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6c96f158-5aab-49ee-9650-fc948701771a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider. This requirement is not intended to apply to service providers accessing their own shared services environments, where multiple customer environments are hosted.",
                "If service provider employees use shared authentication factors to remotely access customer premises, these factors must be unique per customer and managed in accordance with Requirement 8.2.2.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 74
        {
          fields: [
            {
              _uid: "f30767e6-0e25-4f51-9acb-80bca7b42c9e",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "59147999-2588-407b-89f8-ef34eeb7a19b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Addition, deletion, and modification of user IDs, authentication factors, and other identifier objects are managed as follows:",
                "Authorized with the appropriate approval.",
                "Implemented with only the privileges specified on the documented approval.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "8fff5730-e05f-4502-ac76-58c9a063bdb3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented authorizations across various phases of the account lifecycle (additions, modifications, and deletions).",
                "Examine system settings.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "010f5e3b-71ed-404d-9dc7-661104068560",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["da3af7a7-3f56-4ef3-8d7d-47a757e049dc"],
              },
            },
            {
              _uid: "da3af7a7-3f56-4ef3-8d7d-47a757e049dc",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "7345b20b-bde1-4e75-9f8b-f34723ba2f1f_010f5e3b-71ed-404d-9dc7-661104068560",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1030cea0-d765-44bb-9480-eeac49c9cf31",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies to all user accounts, including employees, contractors, consultants, temporary workers, and third-party vendors.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4fe2c236-efc9-4485-901b-1ce33417ed87",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7dc341e0-d63e-4ec4-88e5-0db780347f19",
              component: "col",
              label: [],
              simplifiedLabel: ["Access for terminated users is immediately revoked."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f5c7394d-c143-4918-abcc-fc9713682e4b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine information sources for terminated users.",
                "Review current user access lists.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "9590a764-ff2d-40c2-a416-6a2b1927808e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["828dd2e4-a894-4acb-b5dc-26bd0203e154"],
              },
            },
            {
              _uid: "828dd2e4-a894-4acb-b5dc-26bd0203e154",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a76c5f10-b2ff-459b-bb5f-8fe16d4e9fdd_9590a764-ff2d-40c2-a416-6a2b1927808e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "28a548fc-ed75-467e-8aef-fecdb1378979",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c40ba643-a85b-4518-ab19-360555407d12",
              component: "col",
              label: [],
              simplifiedLabel: ["Inactive user accounts are removed or disabled within 90 days of inactivity."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ca908ffd-e4f4-4bc2-9c32-6ca6d7d6c91f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine user accounts and last logon information.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8d0e4ee8-d08e-4ffd-918b-3c34def91604"],
              },
            },
            {
              _uid: "8d0e4ee8-d08e-4ffd-918b-3c34def91604",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "904dcf74-dafc-4d1a-b02e-0a306f4b1780_c8e5bac5-df1f-45b5-ba4e-50fff1161c14",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "22714580-0729-45d2-9a8d-a0f0b6bb3b0c",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e35d93fe-c3e3-405b-a8dd-3ddb0e0b6af9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Accounts used by third parties to access, support, or maintain system components via remote access are managed as follows:",
                "Enabled only during the time period needed and disabled when not in use.",
                "Use is monitored for unexpected activity.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ca3b4115-45bb-48db-88a3-282021dd2159",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Interview responsible personnel.",
                "Examine documentation for managing accounts.",
                "Examine evidence.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e0d026f0-88af-4b64-8358-c1cb103602ea",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["fe565243-5504-4070-b1ec-488a1427fd76"],
              },
            },
            {
              _uid: "fe565243-5504-4070-b1ec-488a1427fd76",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8544417d-8efa-424e-a587-b2b51794675d_e0d026f0-88af-4b64-8358-c1cb103602ea",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 75
        {
          fields: [
            {
              _uid: "4709e9d9-fd26-4652-b147-4d1fc295d174",
              component: "col",
              label: "",
              simplifiedLabel: "8.2.8",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1130daa4-ab7f-431b-b139-4841a098f99b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If a user session has been idle for more than 15 minutes, the user is required to re-authenticate to reactivate the terminal or session.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "350d7769-0903-4084-a249-4a38ee1df94a",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3969900b-7498-45ae-a67b-a42fee1f3357",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["24e0374e-c223-452d-b4ae-43e6875d96a2"],
              },
            },
            {
              _uid: "24e0374e-c223-452d-b4ae-43e6875d96a2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ad3a47f7-8ce5-42be-93f5-2351fdd37b62_3969900b-7498-45ae-a67b-a42fee1f3357",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7648b67f-acc8-472b-8661-89efe84212e3",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                "This requirement is not meant to prevent legitimate activities from being performed while the console/PC is unattended.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0c2404bf-0348-4a02-b4eb-17751056ba12",
              component: "col",
              label: "",
              simplifiedLabel: ["8.3 Strong authentication for users and administrators is established and managed."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4d891bb2-645b-4c34-b0c5-5d56e263e8b7",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e6a6ac6a-08d3-476c-ad1b-72b7085f7300",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All user access to system components for users and administrators is authenticated via at least one of the following authentication factors:",
                "Something you know, such as a password or passphrase.",
                "Something you have, such as a token device or smart card.",
                "Something you are, such as a biometric element.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "598e6f6d-0a31-4bda-a2b5-7069dc5ec230",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documentation describing the authentication factor(s) used.",
                "For each type of authentication factor used with each type of system component, observe the authentication process.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c24e59ab-bd97-41f3-b931-8f67fd77ed20",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["966b5fe7-d69f-45a8-b75e-1ce490e1e5d3"],
              },
            },
            {
              _uid: "966b5fe7-d69f-45a8-b75e-1ce490e1e5d3",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "db67e93b-5a5b-47e5-bfe3-afad41425063_c24e59ab-bd97-41f3-b931-8f67fd77ed20",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f6f6c1d8-82db-4db2-8fce-14d252a19e6e",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                "This requirement does not supersede multi-factor authentication (MFA) requirements but applies to those in-scope systems not otherwise subject to MFA requirements.",
                "A digital certificate is a valid option for “something you have” if it is unique for a particular user.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 76
        {
          fields: [
            {
              _uid: "543419f5-e78c-4396-900f-46907d71e2a2",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "75d5cff6-680f-49a9-bb43-6c9b960f1c87",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Strong cryptography is used to render all authentication factors unreadable during transmission and storage on all system components.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "da6b0ac3-0344-4689-9ebd-c23a31dfba4a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine vendor documentation.",
                "Examine system configuration settings.",
                "Examine repositories of authentication factors.",
                "Examine data transmissions.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1e64147e-8248-4431-b987-6b43c0a87b72",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["da740389-046e-4afd-975f-a999a1dafbaa"],
              },
            },
            {
              _uid: "da740389-046e-4afd-975f-a999a1dafbaa",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "76b383d4-c683-4c09-a5e7-4fbb86d6878b_1e64147e-8248-4431-b987-6b43c0a87b72",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "766c3a5c-c1d1-4bdd-bf22-da8b9f82f559",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "279fae04-ed03-4960-b6b0-404e72bfb0d3",
              component: "col",
              label: [],
              simplifiedLabel: ["User identity is verified before modifying any authentication factor."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "510c4c3b-ab4b-4754-ba6b-05d995d58c82",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine procedures for modifying authentication factors.",
                "Observe security personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "aceb2cf5-7241-45af-925f-33e038def041",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["9461e5b5-1202-45f7-8378-8b7093e77197"],
              },
            },
            {
              _uid: "9461e5b5-1202-45f7-8378-8b7093e77197",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ab45fe2c-7147-4dd6-a8fc-8d475b5e743e_aceb2cf5-7241-45af-925f-33e038def041",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8daa3b0e-d25c-442f-bc7d-0557f6e4a1bc",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "867e2c3c-93b5-420b-ae26-21b9d20d3644",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Invalid authentication attempts are limited by:",
                "Locking out the user ID after not more than 10 attempts.",
                "Setting the lockout duration to a minimum of 30 minutes or until the user’s identity is confirmed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6a04380a-da08-4d42-93a3-07c0184c45d6",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a9c7f4f1-ef9c-416a-9976-72e028628074",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["817a616b-5cef-4497-af1c-f5b05663a7d2"],
              },
            },
            {
              _uid: "817a616b-5cef-4497-af1c-f5b05663a7d2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "69e438c0-0dc9-43cf-bd96-bfed70a2fc8f_a9c7f4f1-ef9c-416a-9976-72e028628074",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "db51907a-e243-4d79-ab61-602425ac64b3",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "216d3f23-7b61-4859-bc2e-e8e57d8daef4",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1d8fa345-59fa-4a65-af73-9202c37d399b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If passwords/passphrases are used as authentication factors to meet Requirement 8.3.1, they are set and reset for each user as follows:",
                "Set to a unique value for first-time use and upon reset.",
                "Forced to be changed immediately after the first use.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7ee884c2-e85f-4b86-8c43-1602586cbac1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine procedures for setting and resetting passwords/passphrases.",
                "Observe security personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "32b9e151-ac03-405e-b1b7-3ac1593c64cc",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["5203277d-bb88-4a4d-a747-bcae4ab04ae3"],
              },
            },
            {
              _uid: "5203277d-bb88-4a4d-a747-bcae4ab04ae3",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "53dee0b2-bf62-4b05-8f9d-e843efd62e5c_32b9e151-ac03-405e-b1b7-3ac1593c64cc",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 77
        {
          fields: [
            {
              _uid: "bd78a6dc-5a65-4a74-9662-c8eb980364cd",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7c03cf66-6a9a-46d6-8417-071256cd3f12",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If passwords/passphrases are used as authentication factors to meet Requirement 8.3.1, they meet the following minimum level of complexity:",
                "A minimum length of 12 characters (or IF the system does not support 12 characters, a minimum length of eight characters).",
                "Contain both numeric and alphabetic characters.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c44255b1-3760-4dc0-b00a-03c555048c72",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "69868741-8916-44b5-987d-ff409346bbc6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["3e9d1ad8-5d11-4647-b9d0-7ec663c55802"],
              },
            },
            {
              _uid: "3e9d1ad8-5d11-4647-b9d0-7ec663c55802",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c310118e-25a8-41c7-b38d-3c440b3151f8_69868741-8916-44b5-987d-ff409346bbc6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ac039ae5-6c62-4641-84f2-f9b0724cec4e",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to:",
                "User accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals)",
                "Application or system accounts, which are governed by requirements in section 8.6.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                "Until 31 March 2025, passwords must be a minimum length of seven characters in accordance with PCI DSS v3.2.1 Requirement 8.2.3.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b01174cf-cdee-49d1-9502-b695c0c0f804",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2f34005a-f311-4ddf-9420-780c17a567d0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Individuals are not allowed to submit a new password/passphrase that is the same as any of the last four passwords/passphrases used.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c5b7fdc0-2d8b-480f-bcfd-723862f27c81",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configuration settings"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b3247b69-da29-4cfe-82f9-af09212d724f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["f1d906fe-3cb1-48ef-b8fb-2cbdb11b9ceb"],
              },
            },
            {
              _uid: "f1d906fe-3cb1-48ef-b8fb-2cbdb11b9ceb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8b0ef447-e9b0-4445-89bc-a807e78abd31_b3247b69-da29-4cfe-82f9-af09212d724f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a5bf8266-4b6f-47c7-b60b-fe8540c91c90",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is not intended to apply to user accounts within point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 78
        {
          fields: [
            {
              _uid: "e5725162-c53f-47d0-882e-fb29814d123f",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.8",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ffb4fd30-de9f-482c-8b27-586b65ccaf8c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Authentication policies and procedures are documented and communicated to all users including:",
                "Guidance on selecting strong authentication factors.",
                "Guidance for how users should protect their authentication factors.",
                "Instructions not to reuse previously used passwords/passphrases.",
                "Instructions to change passwords/passphrases if there is any suspicion or knowledge that the password/passphrases have been compromised and how to report the incident.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "43c4a6fc-d894-4ed8-aabd-0c8790d6c078",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine procedures.",
                "Interview personnel.",
                "Review authentication policies and procedures that are distributed to users.",
                "Interview users.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["bff226a7-24ac-433f-a67c-bb36971da9f2"],
              },
            },
            {
              _uid: "bff226a7-24ac-433f-a67c-bb36971da9f2",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "543f8cc4-16c9-4f82-bae9-cc1bcf22df1c_f381e3ab-d51d-4cd5-88e2-2fb251a767ea",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "66cab423-4b8e-4dbc-92ab-f6df88a22a7b",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.9",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "d74788a1-32c6-4e57-9488-d6fb5318f2c4",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If passwords/passphrases are used as the only authentication factor for user access (i.e., in any singlefactor authentication implementation) then either:",
                "Passwords/passphrases are changed at least once every 90 days,",
                "OR",
                "The security posture of accounts is dynamically analyzed, and real-time access to resources is automatically determined accordingly.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "95fd771c-9321-45ed-ae12-cf92b6a27295",
              component: "col",
              label: [],
              simplifiedLabel: ["Inspect system configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c04e9d48-f2e3-4667-b836-d76b09697fb1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["678c3c00-a2b8-48cb-bbc0-427d82b8f135"],
              },
            },
            {
              _uid: "678c3c00-a2b8-48cb-bbc0-427d82b8f135",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "7eee08b0-4539-40b5-851b-3dce6d7e6ce5_c04e9d48-f2e3-4667-b836-d76b09697fb1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "cd62d353-b5b8-4305-95bd-b8111d5193f6",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies to in-scope system components that are not in the CDE because these components are not subject to MFA requirements.",
                "This requirement is not intended to apply to user accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                "This requirement does not apply to service providers’ customer accounts but does apply to accounts for service provider personnel.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 79
        {
          fields: [
            {
              _uid: "2b6c262d-c987-4fc8-b765-8354f675c336",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.10",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "9041b8d7-56c3-4f6e-8fcd-ab5885ff37c7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "If passwords/passphrases are used as the only authentication factor for customer user access to cardholder data (i.e., in any single-factor authentication implementation), then guidance is provided to customer users including:",
                "Guidance for customers to change their user passwords/passphrases periodically.",
                "Guidance as to when, and under what circumstances, passwords/passphrases are to be changed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f61175d7-f11c-4055-963f-308e46722355",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine guidance provided to customer users."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1b4e7fc9-5e5f-4b2a-a134-c483220fcb06",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place"],
                _uids: ["49083736-6ac4-48d4-8e36-8d62276dccba"],
              },
            },
            {
              _uid: "49083736-6ac4-48d4-8e36-8d62276dccba",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "025349a8-24c0-4228-8490-6bada12f41ad_1b4e7fc9-5e5f-4b2a-a134-c483220fcb06",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1b2dafb3-5111-4911-9f48-9837f67bd3b8",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
                "This requirement does not apply to accounts of consumer users accessing their own payment card information.",
                "This requirement for service providers will be superseded by Requirement 8.3.10.1 once 8.3.10.1 becomes effective.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        // 80
        {
          fields: [
            {
              _uid: "d10b262e-9450-4c5d-957e-2b6e256aec94",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.10.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "76a792ea-eb5a-4630-8a24-4bf7d0ef0745",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "If passwords/passphrases are used as the only authentication factor for customer user access (i.e., in any single-factor authentication implementation) then either:",
                "Passwords/passphrases are changed at least once every 90 days,",
                "OR",
                "The security posture of accounts is dynamically analyzed, and real-time access to resources is automatically determined accordingly.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "33d41bdd-8934-469c-87f5-1bc8935356d4",
              component: "col",
              label: [],
              simplifiedLabel: ["Inspect system configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "529f0f67-f13d-4682-b1ec-e13f7959f7a8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["67c526b0-4030-4feb-ab9e-267ec40ccc37"],
              },
            },
            {
              _uid: "67c526b0-4030-4feb-ab9e-267ec40ccc37",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a710cc65-77cc-48c3-8475-67446df50ced_529f0f67-f13d-4682-b1ec-e13f7959f7a8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "57e91784-cb57-4075-96ed-eb6bb2f21469",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
                "This requirement does not apply to accounts of consumer users accessing their own payment card information.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
                "Until this requirement is effective on 31 March 2025, service providers may meet either Requirement 8.3.10 or 8.3.10.1.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9194bae9-9491-46e3-8f61-52ce322688eb",
              component: "col",
              label: "",
              simplifiedLabel: "8.3.11",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "726ee043-ae89-4a18-95ce-6233156c403b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Where authentication factors such as physical or logical security tokens, smart cards, or certificates are used:",
                "Factors are assigned to an individual user and not shared among multiple users.",
                "Physical and/or logical controls ensure only the intended user can use that factor to gain access.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "de628cfe-37c5-4cd2-9f0e-54af80ad20ff",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine authentication policies and procedures.",
                "Interview security personnel.",
                "Examine system configuration settings and/or observe physical controls, as applicable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f87c6061-240b-4f33-afa5-730d71805c3d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },

                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5a50b406-1ef4-429d-b43c-85cead898f30"],
              },
            },
            {
              _uid: "5a50b406-1ef4-429d-b43c-85cead898f30",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f769d89f-c56e-4591-974a-1f5f8eb247cc_f87c6061-240b-4f33-afa5-730d71805c3d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 81
        {
          fields: [
            {
              _uid: "a3b32a17-c61f-43bf-9d6a-4b99841212cc",
              component: "col",
              label: "",
              simplifiedLabel: [
                "8.4 Multi-factor authentication (MFA) is implemented to secure access into the CDE.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c1c1ab3e-c846-4250-b130-de74e13d98c8",
              component: "col",
              label: "",
              simplifiedLabel: "8.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c63d52d1-fa62-4f41-aa6b-1f856a923a60",
              component: "col",
              label: [],
              simplifiedLabel: [
                "MFA is implemented for all non-console access into the CDE for personnel with administrative access.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e1023dc6-fdc0-4718-ba08-5a2e80a542d9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine network and/or system configurations.",
                "Observe administrator personnel logging into the CDE.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "9d22302f-75d3-48e1-aad6-1449c30c6ba8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["108de7fb-40f0-44b9-b059-6bd1b45905e5"],
              },
            },
            {
              _uid: "108de7fb-40f0-44b9-b059-6bd1b45905e5",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f5f0b6c5-1934-43d0-ad99-006ec6b8714e_9d22302f-75d3-48e1-aad6-1449c30c6ba8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6b276bf9-a51f-4a1f-bfc7-416f9317aeda",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The requirement for MFA for non-console administrative access applies to all personnel with elevated or increased privileges accessing the CDE via a non-console connection—that is, via logical access occurring over a network interface rather than via a direct, physical connection.",
                "MFA is considered a best practice for non-console administrative access to in-scope system components that are not part of the CDE.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 82
        {
          fields: [
            {
              _uid: "58d6134f-5fe9-487f-94c3-5b368a33ced1",
              component: "col",
              label: "",
              simplifiedLabel: "8.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "58249164-6524-4dec-96e1-8b6c7febc8e5",
              component: "col",
              label: [],
              simplifiedLabel: ["MFA is implemented for all access into the CDE."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "01de56a2-ca6b-4d9c-befd-e6a101e41ace",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine network and/or system configurations.",
                "Observe personnel logging in to the CDE.Examine evidence.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c444739f-b439-42b8-8d1a-cec6de08badc",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e64b2fdf-f14a-4c03-a8ca-b0dea000baff"],
              },
            },
            {
              _uid: "e64b2fdf-f14a-4c03-a8ca-b0dea000baff",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "54dc12a4-372b-4e89-837f-de0d965ca0a6_c444739f-b439-42b8-8d1a-cec6de08badc",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "84120890-22be-41f0-9fa1-cc9bb699735d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement does not apply to:",
                "MFA is considered a best practice for non-console administrative access to in-scope system components that are not part of the CDE.",
                "User accounts on point-of-sale terminals that have access to only one card number at a time to facilitate a single transaction (such as IDs used by cashiers on point-of-sale terminals).",
                "MFA is required for both types of access specified in Requirements 8.4.2 and 8.4.3. Therefore, applying MFA to one type of access does not replace the need to apply another instance of MFA to the other type of access. If an individual first connects to the entity’s network via remote access, and then later initiates a connection into the CDE from within the network, per this requirement the individual would authenticate using MFA twice, once when connecting via remote access to the entity’s network and once when connecting via non-console administrative access from the entity’s network into the CDE.",
                "The MFA requirements apply for all types of system components, including cloud, hosted systems, and on-premises applications, network security devices, workstations, servers, and endpoints, and includes access directly to an entity’s networks or systems as well as web-based access to an application or function.",
                "MFA for remote access into the CDE can be implemented at the network or system/application level; it does not have to be applied at both levels. For example, if MFA is used when a user connects to the CDE network, it does not have to be used when the user logs into each system or application within the CDE.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 83
        {
          fields: [
            {
              _uid: "0c26c53c-23aa-4ecb-b0e2-ae34228e4ac6",
              component: "col",
              label: "",
              simplifiedLabel: "8.4.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "41615fae-f822-4218-831a-b5c19beea915",
              component: "col",
              label: [],
              simplifiedLabel: [
                "MFA is implemented for all remote network access originating from outside the entity’s network that could access or impact the CDE as follows:",
                "All remote access by all personnel, both users and administrators, originating from outside the entity’s network.",
                "All remote access by third parties and vendors.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4e976d20-9c1e-4f6d-b9e9-212d21b6a549",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine network and/or system configurations for remote access servers and systems.",
                "Observe personnel (for example, users and administrators) connecting remotely to the network.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2dbbaf98-0f34-479c-a150-be4f75a95a35",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["4b385bb5-79e7-4639-85a1-a2974366070a"],
              },
            },
            {
              _uid: "4b385bb5-79e7-4639-85a1-a2974366070a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "235aff7a-2a09-467a-9a16-f2b225eadcd5_2dbbaf98-0f34-479c-a150-be4f75a95a35",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4d5150af-e5a4-4386-b3a0-11e26b99326a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The requirement for MFA for remote access originating from outside the entity’s network applies to all user accounts that can access the network remotely, where that remote access leads to or could lead to access into the CDE.",
                "If remote access is to a part of the entity’s network that is properly segmented from the CDE, such that remote users cannot access or impact the CDE, MFA for remote access to that part of the network is not required. However, MFA is required for any remote access to networks with access to the CDE and is recommended for all remote access to the entity’s networks.",
                "The MFA requirements apply for all types of system components, including cloud, hosted systems, and on-premises applications, network security devices, workstations, servers, and endpoints, and includes access directly to an entity’s networks or systems as well as web-based access to an application or function.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 84
        {
          fields: [
            {
              _uid: "c362c8ad-8c01-4d58-890c-3acfebe21bda",
              component: "col",
              label: "",
              simplifiedLabel: ["8.5 Multi-factor authentication (MFA) systems are configured to prevent misuse."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a731ac80-5726-4c72-854f-9ae4b751e647",
              component: "col",
              label: "",
              simplifiedLabel: "8.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5d2fab98-5084-4a2d-b964-9799c69d77aa",
              component: "col",
              label: [],
              simplifiedLabel: [
                "MFA systems are implemented as follows:",
                "The MFA system is not susceptible to replay attacks.",
                "MFA systems cannot be bypassed by any users, including administrative users unless specifically documented, and authorized by management on an exception basis, for a limited time period.",
                "At least two different types of authentication factors are used.",
                "Success of all authentication factors is required before access is granted.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "1f44d720-8c20-4f6d-bf85-e3083372f8b3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine vendor system documentation.",
                "Examine system configurations for the MFA implementation.",
                "Interview responsible personnel and observe processes.",
                "Observe personnel logging into system components in the CDE.",
                "Observe personnel connecting remotely from outside the entity’s network.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e7908971-3a76-4188-93ef-fc2b10b17ab8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["da6ef752-f600-45b8-8fa0-83b0a126a326"],
              },
            },
            {
              _uid: "da6ef752-f600-45b8-8fa0-83b0a126a326",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "10c7b9e2-d95d-4957-99b4-179a6cbe29fe_e7908971-3a76-4188-93ef-fc2b10b17ab8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "855ad24d-56a8-4a11-a5be-1a04b0344dac",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 85
        {
          fields: [
            {
              _uid: "b6a89697-f0ed-41b3-bdf9-5cf44173dbf1",
              component: "col",
              label: "",
              simplifiedLabel: [
                "8.6 Use of application and system accounts and associated authentication factors is strictly managed.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ada64ca0-279e-485e-bca3-9995fd258a67",
              component: "col",
              label: "",
              simplifiedLabel: "8.6.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "79ce9938-757f-4138-bc48-8269b8f32d21",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If accounts used by systems or applications can be used for interactive login, they are managed as follows:",
                "Interactive use is prevented unless needed for an exceptional circumstance.",
                "Interactive use is limited to the time needed for the exceptional circumstance.",
                "Business justification for interactive use is documented.",
                "Interactive use is explicitly approved by management. ",
                "Individual user identity is confirmed before access to account is granted.",
                "Every action taken is attributable to an individual user.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f8db322a-b1de-44a5-9b7b-e6bd99d13b0a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine application and system accounts that can be used interactively.",
                "Interview administrative personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6f15115f-c352-4f9f-a1e7-30be29367fec",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["11cfcc62-38b6-4506-a2c2-a9e04c8e91c0"],
              },
            },
            {
              _uid: "11cfcc62-38b6-4506-a2c2-a9e04c8e91c0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2b5b44c7-9fcf-4edb-bab1-dc6d8a4cd02b_6f15115f-c352-4f9f-a1e7-30be29367fec",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "35af2ce3-1c1d-4a86-8019-d63903b3802b",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 86
        {
          fields: [
            {
              _uid: "9c4dcf3a-cd24-485f-bcaf-49be7351b4e2",
              component: "col",
              label: "",
              simplifiedLabel: "8.6.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "eaccbb82-d3c3-4882-80bf-05d785499db6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Passwords/passphrases for any application and system accounts that can be used for interactive login are not hard coded in scripts, configuration/property files, or bespoke and custom source code.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "98acfac1-0206-4511-bb12-7b5700aef943",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Interview personnel.",
                "Examine system development procedures.",
                "Examine scripts, configuration/property files, and bespoke and custom source code for application and system accounts that can be used for interactive login.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1268a0cf-cef2-43db-9ee7-61059ae1b579",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8cd77e1e-7271-4e7b-a24e-be1c4e8e3a6a"],
              },
            },
            {
              _uid: "8cd77e1e-7271-4e7b-a24e-be1c4e8e3a6a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "fde1da7b-44a2-46a9-aea8-87aebefd3fa3_1268a0cf-cef2-43db-9ee7-61059ae1b579",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f7114d40-969d-4a18-b40e-9706342cba24",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Stored passwords/passphrases are required to be encrypted in accordance with PCI DSS Requirement 8.3.2.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "290e646c-4729-436e-8f9d-267b83213cdb",
              component: "col",
              label: "",
              simplifiedLabel: "8.6.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0ded9dd7-766e-4f9e-961d-b6a021bf3973",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Passwords/passphrases for any application and system accounts are protected against misuse as follows:",
                "Passwords/passphrases are changed periodically (at the frequency defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1) and upon suspicion or confirmation of compromise.",
                "Passwords/passphrases are constructed with sufficient complexity appropriate for how frequently the entity changes the passwords/passphrases.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "fe1dee4d-fe07-488c-8e63-6f11817eaf66",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine the targeted risk analysis.",
                "Interview responsible personnel.",
                "Examine system configuration settings.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "56867429-4f9c-4ac3-9612-d8e4690441a6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["06fe46d3-6c1f-465a-80ce-a0fe63a43997"],
              },
            },
            {
              _uid: "06fe46d3-6c1f-465a-80ce-a0fe63a43997",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "69d7cd6f-38b3-468d-83eb-a0fe5a677f42_56867429-4f9c-4ac3-9612-d8e4690441a6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2abc9f49-8587-42ce-aa08-aaa854bd4dd7",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 87
        {
          fields: [
            {
              _uid: "d6977f2f-0280-4968-bc20-2f6d0d7651b5",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Requirement 9: Restrict Physical Access to Cardholder Data",
                "9.1 Processes and mechanisms for restricting physical access to cardholder data are defined and understood.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "be0f8a63-ff18-47dd-a72c-3d306bda50e5",
              component: "col",
              label: "",
              simplifiedLabel: "9.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "16773399-765d-4ee6-a670-88fe36ff31dd",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 9 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "02e77f34-fcb3-4be2-99e4-43b4248f8b26",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "de89a9c1-8153-4d3a-af6d-e7bd7005d3ec",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3c6ce1a7-e937-4867-b1c9-9ead42b78794"],
              },
            },
            {
              _uid: "3c6ce1a7-e937-4867-b1c9-9ead42b78794",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2436bce8-7093-4345-b439-fc42c6524f89_de89a9c1-8153-4d3a-af6d-e7bd7005d3ec",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f72ebe32-cdde-4a4d-adc4-0e6a71f6c05f",
              component: "col",
              label: "",
              simplifiedLabel: "9.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3ddc78ba-851b-4b3f-88ed-09965a7a07ba",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 9 are documented, assigned, and understood",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "054ea887-3e16-4b82-966e-a8a64fc50061",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "97a5be43-3467-4b19-8d92-25017702a5bf",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["0f9de1e8-3a96-495f-b06d-7a0bdaf6088a"],
              },
            },
            {
              _uid: "0f9de1e8-3a96-495f-b06d-7a0bdaf6088a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ffec5fe2-bc29-4a0c-b366-c2165d930817_97a5be43-3467-4b19-8d92-25017702a5bf",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "24bcc4dd-0301-4b10-b4cb-0478c2c4030e",
              component: "col",
              label: "",
              simplifiedLabel: [
                "9.2 Physical access controls manage entry into facilities and systems containing cardholder data.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "94745004-b9f8-40e0-bbdc-2ca7bf397498",
              component: "col",
              label: "",
              simplifiedLabel: "9.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "8d42f66c-eee4-4591-92d0-0d5310d67008",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Appropriate facility entry controls are in place to restrict physical access to systems in the CDE.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9c257aa1-22d9-43c2-bae4-90a3fd9c6094",
              component: "col",
              label: [],
              simplifiedLabel: ["Observe physical entry controls.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3d9893fc-fa09-4ac4-b178-e1099bce48f1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["aebffedf-6179-48c3-90f1-481bc13fa6f6"],
              },
            },
            {
              _uid: "aebffedf-6179-48c3-90f1-481bc13fa6f6",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "598a46fc-38b0-4f87-8c46-d7fdf23da0d7_3d9893fc-fa09-4ac4-b178-e1099bce48f1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 88
        {
          fields: [
            {
              _uid: "d02160ea-74b4-44c0-a2a7-e49e255cb2fb",
              component: "col",
              label: "",
              simplifiedLabel: "9.2.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5a9f3472-0fbf-43d1-a9bd-acb08d158cfa",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Individual physical access to sensitive areas within the CDE is monitored with either video cameras or physical access control mechanisms (or both) as follows:",
                "Entry and exit points to/from sensitive areas within the CDE are monitored.",
                "Monitoring devices or mechanisms are protected from tampering or disabling.",
                "Collected data is reviewed and correlated with other entries.",
                "Collected data is stored for at least three months, unless otherwise restricted by law.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0fca3374-1201-428a-bace-f7e07a78f197",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Observe locations where individual physical access to sensitive areas within the CDE occurs.",
                "Observe the physical access control mechanisms and/or examine video cameras",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e98ceedd-20ca-473b-b815-a2f448e79c99",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6ffea6fd-a801-413c-9b3b-b6d33cd85834"],
              },
            },
            {
              _uid: "6ffea6fd-a801-413c-9b3b-b6d33cd85834",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "67e3c291-f699-41c1-8f7e-cede9dbb2b9a_e98ceedd-20ca-473b-b815-a2f448e79c99",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4fed6408-ec90-4137-8f84-68fba9b83845",
              component: "col",
              label: "",
              simplifiedLabel: "9.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "4d4fbfa2-16f0-49e0-977f-ced87eb61ef8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Physical and/or logical controls are implemented to restrict use of publicly accessible network jacks within the facility.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4697d81a-2c1a-40f4-9d7c-c427a2fd601c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Interview responsible personnel.",
                "Observe locations of publicly accessible network jacks.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d73b8a97-5d86-4d97-950d-8f2ade1e6fdb",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["3b27480b-4b80-42dd-801a-6dd7b97eaee0"],
              },
            },
            {
              _uid: "3b27480b-4b80-42dd-801a-6dd7b97eaee0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "9b59a447-5287-466d-acb2-a0f450477d32_d73b8a97-5d86-4d97-950d-8f2ade1e6fdb",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b60b6a50-7be4-4df6-8488-8aca819b9ad1",
              component: "col",
              label: "",
              simplifiedLabel: "9.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "517b0cd2-0544-4b54-be94-fe48baa8c654",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Physical access to wireless access points, gateways, networking/communications hardware, and telecommunication lines within the facility is restricted.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "41a9a9a0-f6e3-40c2-a9ab-1d3ea0d460e9",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview responsible personnel.", "Observe locations of hardware and lines."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "46957af4-6d29-41a4-9bf7-47374aae4c29",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["23fdf148-9b11-490b-890b-1c5a947867c6"],
              },
            },
            {
              _uid: "23fdf148-9b11-490b-890b-1c5a947867c6",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "5b47f1ed-bb88-43c4-af61-e7746ea5af69_46957af4-6d29-41a4-9bf7-47374aae4c29",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "87-d82f279c3f7a-47ee-4818-aee3fd9e18",
              component: "col",
              label: "",
              simplifiedLabel: "9.2.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f567e5b0-de88-426c-9b8c-60ae37693128",
              component: "col",
              label: [],
              simplifiedLabel: ["Access to consoles in sensitive areas is restricted via locking when not in use."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "965aa1f9-f14b-495e-aacc-2b5bd179be97",
              component: "col",
              label: [],
              simplifiedLabel: ["Observe a system administrator’s attempt to log into consoles in sensitive areas."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "9991a41c-cbd5-4742-8c73-0646766555d6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["860d4d91-9207-4ade-a879-cc3f2b739b03"],
              },
            },
            {
              _uid: "860d4d91-9207-4ade-a879-cc3f2b739b03",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3223facc-473e-409c-bf38-c1c1c96bebcf_9991a41c-cbd5-4742-8c73-0646766555d6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 89
        {
          fields: [
            {
              _uid: "2ce289b6-5bd9-4066-8030-ee5640d28d7c",
              component: "col",
              label: "",
              simplifiedLabel: ["9.3 Physical access for personnel and visitors is authorized and managed."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f2913ba8-bf22-4277-981a-256bdb57cc22",
              component: "col",
              label: "",
              simplifiedLabel: "9.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "d680fd86-2909-4b92-9aeb-a2b8fa843f05",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Procedures are implemented for authorizing and managing physical access of personnel to the CDE, including:",
                "Identifying personnel.",
                "Managing changes to an individual’s physical access requirements.",
                "Revoking or terminating personnel identification",
                "Limiting access to the identification process or system to authorized personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2a441677-9bf2-4f61-bf77-84997a339ba2",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures.",
                "Observe identification methods, such as ID badges.",
                "Observe processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "4a5b342b-1b69-4317-a74c-3623fe5a584a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d938c2c3-9c45-4942-b6e9-8452f5a6afe5"],
              },
            },
            {
              _uid: "d938c2c3-9c45-4942-b6e9-8452f5a6afe5",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "18169325-0098-4323-bc53-f4007914a126_4a5b342b-1b69-4317-a74c-3623fe5a584a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d6d062d8-2b72-4b13-98ae-ab305270bb28",
              component: "col",
              label: "",
              simplifiedLabel: "9.3.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "71ca7e25-182f-44b1-ba7e-14559181e475",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Physical access to sensitive areas within the CDE for personnel is controlled as follows:",
                "Access is authorized and based on individual job function.",
                "Access is revoked immediately upon termination.",
                "All physical access mechanisms, such as keys, access cards, etc., are returned or disabled upon termination.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "a1bef397-b397-42fb-92c8-8da73fca2558",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Observe personnel in sensitive areas within the CDE.",
                "Interview responsible personnel.",
                "Examine physical access control lists.",
                "Observe processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7e9a2d52-5749-4939-a045-079bba59f45c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["28cb94e9-a309-441a-bc99-2066e6e122db"],
              },
            },
            {
              _uid: "28cb94e9-a309-441a-bc99-2066e6e122db",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3bcab63d-08b2-45cf-8bfd-3ea91fca1d92_7e9a2d52-5749-4939-a045-079bba59f45c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3f71824a-f838-4552-b813-566a7a93f24a",
              component: "col",
              label: "",
              simplifiedLabel: "9.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "63464556-76dc-407b-aab8-0a7da81f05d7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Procedures are implemented for authorizing and managing visitor access to the CDE, including:",
                "Visitors are authorized before entering.",
                "Visitors are escorted at all times.",
                "Visitors are clearly identified and given a badge or other identification that expires",
                "Visitor badges or other identification visibly distinguishes visitors from personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "367d4647-7958-4eb8-bbf5-ee03f3c0f653",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures.",
                "Observe processes when visitors are present in the CDE.",
                "Interview personnel.",
                "Observe the use of visitor badges or other identification.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d8a51309-65db-458f-8819-cc912552a373",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a2043ab1-181f-433c-9521-3056e1ac9cb8"],
              },
            },
            {
              _uid: "a2043ab1-181f-433c-9521-3056e1ac9cb8",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ac2fa3a7-8c0e-41b7-8f2b-1ad6b5a647ec_d8a51309-65db-458f-8819-cc912552a373",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f705c622-f323-4252-949c-fcf318e418cb",
              component: "col",
              label: "",
              simplifiedLabel: "9.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "81298033-0032-4490-83a2-5364226f00b2",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Visitor badges or identification are surrendered or deactivated before visitors leave the facility or at the date of expiration.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "dbccf3ac-7433-4c60-a100-3ebc556ccec5",
              component: "col",
              label: [],
              simplifiedLabel: ["Observe visitors leaving the facility", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "60387821-4dd3-4fa6-875a-41a4aa702f0c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["14bfe196-e298-4678-9145-13c062f13921"],
              },
            },
            {
              _uid: "14bfe196-e298-4678-9145-13c062f13921",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "57ebf4cd-de16-490c-9b4b-643ad3a57681_60387821-4dd3-4fa6-875a-41a4aa702f0c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 90
        {
          fields: [
            {
              _uid: "5d14d197-1999-49a0-84f9-d55bf0a3e517",
              component: "col",
              label: "",
              simplifiedLabel: "9.3.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "d8ad4125-85b1-45d7-9630-889def619cc9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "A visitor log is used to maintain a physical record of visitor activity within the facility and within sensitive areas, including:",
                "The visitor’s name and the organization represented.",
                "The date and time of the visit.",
                "The name of the personnel authorizing physical access.",
                "Retaining the log for at least three months, unless otherwise restricted by law.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cb230b7f-da24-430a-800f-9e55fbebeac8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the visitor log.",
                "Interview responsible personnel.",
                "Examine visitor log storage locations.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "4d2c1e51-381b-46cf-b4bb-3ffe3aec6360",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["993e5939-ed8d-46df-91e8-f892f1785086"],
              },
            },
            {
              _uid: "993e5939-ed8d-46df-91e8-f892f1785086",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "91ec9b1a-c045-4481-97b6-8c9529ed8012_4d2c1e51-381b-46cf-b4bb-3ffe3aec6360",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f11d6700-9682-4b75-8738-d7f365fbea84",
              component: "col",
              label: "",
              simplifiedLabel: [
                "9.4 Media with cardholder data is securely stored, accessed, distributed, and destroyed",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4c3f557d-062f-46f0-b03b-071e4ec85580",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "b4275cb6-d1a0-4aad-962a-81eca6797a3d",
              component: "col",
              label: [],
              simplifiedLabel: ["All media with cardholder data is physically secured."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "bf86bc8a-7749-4e06-b3e1-aafea66e3776",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "99cc17e4-17d7-4109-becc-9064d032bd9b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6cbb57e7-95b1-4fd2-877d-295a8bef66b4"],
              },
            },
            {
              _uid: "6cbb57e7-95b1-4fd2-877d-295a8bef66b4",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "84acaaf1-a5a5-4c3b-a749-f1d0c4c750df_99cc17e4-17d7-4109-becc-9064d032bd9b",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "23ffa6e0-e476-4657-8e49-f2cb57ad3160",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "15bea25a-dee9-49a4-a13a-43d4e8d15833",
              component: "col",
              label: [],
              simplifiedLabel: ["Offline media backups with cardholder data are stored in a secure location."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9787c557-3cb0-4c01-81d2-1815e4a4245a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures",
                "Examine logs or other documentation.",
                "Interview responsible personnel at the storge location(s).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ccb7da28-a7dc-4d17-afca-538b5a2623d6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9d7c8138-1b5e-436d-b107-b32e3246e33f"],
              },
            },
            {
              _uid: "9d7c8138-1b5e-436d-b107-b32e3246e33f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f58249c1-95b2-4dfd-92e4-bd8190dbc2d7_ccb7da28-a7dc-4d17-afca-538b5a2623d6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d03a17c3-380e-4bdc-8c69-412ff0d1ebec",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "b29559fb-2975-471d-a238-1355e19e372f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The security of the offline media backup location(s) with cardholder data is reviewed at least once every 12 months.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6f38a146-f9b7-4fa7-85b8-49a675f98351",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures, logs, or other documentation.",
                "Interview responsible personnel at the storage location(s).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "628e6fe9-4f67-4866-898f-e56e256b28d6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["da2ffd1c-c97b-4fc8-b672-8fda483528ab"],
              },
            },
            {
              _uid: "da2ffd1c-c97b-4fc8-b672-8fda483528ab",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a8d37edc-22ba-4178-a3ff-cb0fc23a2b7f_628e6fe9-4f67-4866-898f-e56e256b28d6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0f840cb7-20c4-425e-8d84-28d7cf3b05c2",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7566d8bd-dc01-4126-abf7-d1c65c394911",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All media with cardholder data is classified in accordance with the sensitivity of the data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c8763cdf-8c1f-44ea-9947-326b82f4c5bf",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures",
                "Examine media logs or other documentation.",
                "Examine files and system records on system components where account data is stored.",
                "Observe the mechanisms used to render account data unrecoverable.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2d4d4c83-1815-47a0-9e97-16d70558c192"],
              },
            },
            {
              _uid: "2d4d4c83-1815-47a0-9e97-16d70558c192",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a4cc0dfa-947a-425b-b79b-329e6ce3ddce_e719cb38-b7e2-4ba4-9fcf-d6fe507d6ce4",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 91
        {
          fields: [
            {
              _uid: "be442b22-f06d-405e-8dec-431533521ca2",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7f9c3bb5-a30d-4d00-95c5-ebdfea7dddc8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Media with cardholder data sent outside the facility is secured as follows:",
                "Bullet intentionally left blank for this SAQ",
                "Media is sent by secured courier or other delivery method that can be accurately tracked.",
                "Bullet intentionally left blank for this SAQ.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b34e6135-e337-450c-ae2c-ea043cb8ae9d",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures",
                "Interview personnel.",
                "Examine records.",
                "Examine offsite tracking logs for all media.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "dd7593a7-d618-429a-b464-025e2535c248",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["bfa73c2f-7001-4c55-982d-f29f494d0969"],
              },
            },
            {
              _uid: "bfa73c2f-7001-4c55-982d-f29f494d0969",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "87e5202e-67ab-49b9-9f35-c3057fd67214_dd7593a7-d618-429a-b464-025e2535c248",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "81a4691f-6a9f-4633-a177-94fe569d4b93",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "363845f6-6128-48e8-87ef-782991eacedd",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Management approves all media with cardholder data that is moved outside the facility (including when media is distributed to individuals)",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "94bbd7bf-cbe3-47a7-9894-8a3d47750e93",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures",
                "Examine offsite media tracking logs.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["45a9876d-77c4-4520-9ca1-9acbbc1101cb"],
              },
            },
            {
              _uid: "45a9876d-77c4-4520-9ca1-9acbbc1101cb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "186b4b62-0497-4eab-bbc7-6958249fc430_948511ec-2a1e-45c1-b976-a3cce9f2c9f3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "cddc0d95-b2b5-4e47-b4ea-88b36ea362bb",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Individuals approving media movements should have the appropriate level of management authority to grant this approval. However, it is not specifically required that such individuals have “manager” as part of their title.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7983d569-c5e4-4a29-8174-71d846e59af4",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5cf1bb87-ec0e-4d52-a3f3-cadadf20c531",
              component: "col",
              label: [],
              simplifiedLabel: ["Inventory logs of all electronic media with cardholder data are maintained."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "875c8d23-e957-4af3-af08-8af7f65edc96",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures",
                "Examine electronic media inventory logs.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f25435e8-e6d0-456b-b53b-9237583d123f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["21c0acf2-ed7a-48e1-8194-125e513725ec"],
              },
            },
            {
              _uid: "21c0acf2-ed7a-48e1-8194-125e513725ec",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "dbcfaf89-90fa-4445-b9dc-423e2272d97d_f25435e8-e6d0-456b-b53b-9237583d123f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d3f5b211-03ba-42a2-8ba5-6c7dbeb6bec2",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7a7aaa23-1546-4cb6-b3ec-6964d63c191e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Inventories of electronic media with cardholder data are conducted at least once every 12 months.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0d5d27dd-2898-41a3-b10c-81605b0d0844",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures",
                "Examine electronic media inventory logs.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f654f7e4-50b9-4edb-8818-484b0c79b4d8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["cc172e01-dad6-46dd-8448-2dd605c1a377"],
              },
            },
            {
              _uid: "cc172e01-dad6-46dd-8448-2dd605c1a377",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "dadb62e8-135d-4ef4-9a32-85dfdb077508_f654f7e4-50b9-4edb-8818-484b0c79b4d8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 92
        {
          fields: [
            {
              _uid: "649db51c-4b88-4c99-9a3c-874bedd87a52",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2b90d8e7-6f69-4347-91bc-eede1b1de2ea",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Hard-copy materials with cardholder data are destroyed when no longer needed for business or legal reasons, as follows:",
                "Materials are cross-cut shredded, incinerated, or pulped so that cardholder data cannot be reconstructed.",
                "Materials are stored in secure storage containers prior to destruction.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "378422e9-6e23-4d6b-b78a-74f871487bbd",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the periodic media destruction policy",
                "Observe processes.",
                "Interview personnel.",
                "Observe storage containers.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b23f3713-d931-41dc-a567-d0138d9850f7",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ded23702-84be-405b-9b6c-dcb71b207a98"],
              },
            },
            {
              _uid: "ded23702-84be-405b-9b6c-dcb71b207a98",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "facda98e-e5aa-4a6e-9a61-181fdd172c2f_b23f3713-d931-41dc-a567-d0138d9850f7",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9c669dfe-a5e0-417f-aafd-f7d568ffec31",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "These requirements for media destruction when that media is no longer needed for business or legal reasons are separate and distinct from PCI DSS Requirement 3.2.1, which is for securely deleting cardholder data when no longer needed per the entity’s cardholder data retention policies.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "93ee4f0c-cbb9-4db2-bd1a-48b404426e86",
              component: "col",
              label: "",
              simplifiedLabel: "9.4.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f2330371-0e55-4759-904a-06913a4a45e2",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Electronic media with cardholder data is destroyed when no longer needed for business or legal reasons via one of the following:",
                "The electronic media is destroyed.",
                "The cardholder data is rendered unrecoverable so that it cannot be reconstructed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "05db1a26-8177-490b-87ec-dfcf5ef03289",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the periodic media destruction policy",
                "Observe the media destruction process.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "5e912eef-110c-4111-9c4e-c21969990c38",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c8737917-9da5-493e-9987-c9a77297d28f"],
              },
            },
            {
              _uid: "c8737917-9da5-493e-9987-c9a77297d28f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a6f4445f-44d1-4544-8de4-b5e6a6235e95_5e912eef-110c-4111-9c4e-c21969990c38",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c165464b-bf24-44a0-821e-b5a7301cfe3f",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "These requirements for media destruction when that media is no longer needed for business or legal reasons are separate and distinct from PCI DSS Requirement 3.2.1, which is for securely deleting cardholder data when no longer needed per the entity’s cardholder data retention policies.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        // 93
        {
          fields: [
            {
              _uid: "e0e759d9-3d8b-436a-93eb-6c74916e8f8b",
              component: "col",
              label: "",
              simplifiedLabel: [
                "9.5 Point-of-interaction (POI) devices are protected from tampering and unauthorized substitution.",
              ],
              boldLabel: [],
              subBoldLabel: [],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "dea69986-a622-40b8-8b35-a781720ceeba",
              component: "col",
              label: "",
              simplifiedLabel: "9.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ffa2a0d2-e6e4-4580-bbde-3f1b893408d0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "POI devices that capture payment card data via direct physical interaction with the payment card form factor are protected from tampering and unauthorized substitution, including the following:",
                "Maintaining a list of POI devices.",
                "Periodically inspecting POI devices to look for tampering or unauthorized substitution.",
                "Training personnel to be aware of suspicious behavior and to report tampering or unauthorized substitution of devices.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "86cfd16b-1869-404f-a8cd-636057c5cba3",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented policies and procedures."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d5e7330b-fb7f-4d9b-be6b-c70b7bfe6bbc",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["bfd49a1d-6bbc-4ff0-ba5d-efc3e8d1a048"],
              },
            },
            {
              _uid: "bfd49a1d-6bbc-4ff0-ba5d-efc3e8d1a048",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "fb40e3a5-1885-4719-988e-aa6a8516b04a_d5e7330b-fb7f-4d9b-be6b-c70b7bfe6bbc",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e85f0013-2ede-4880-9c9e-95cfa6efc0bc",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "These requirements apply to deployed POI devices used in card-present transactions (that is, a payment card form factor such as a card that is swiped, tapped, or dipped). This requirement is not intended to apply to manual PAN key-entry components such as computer keyboards.",
                "This requirement is recommended, but not required, for manual PAN key-entry components such as computer keyboards.",
                "This requirement does not apply to commercial off-the-shelf (COTS) devices (for example, smartphones or tablets), which are mobile merchant-owned devices designed for mass-market distribution",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "86997379-5184-405f-a31f-8a41e00c71e3",
              component: "col",
              label: "",
              simplifiedLabel: "9.5.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c6ab089a-39c0-4106-9b42-b7219de56b20",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An up-to-date list of POI devices is maintained, including:",
                "Make and model of the device",
                "Location of device.",
                "Device serial number or other methods of unique identification.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "76093a72-a7a8-48ba-a4a1-2de4c31d1962",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the list of POI devices.",
                "Observe POI devices and device locations.",
                "Interview personnel",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6f7579e9-3e43-46c7-a6be-49777d14cb35",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7c4cf36a-abd3-4111-94f9-6d4cb044d07d"],
              },
            },
            {
              _uid: "7c4cf36a-abd3-4111-94f9-6d4cb044d07d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d4384f13-386b-4bf3-a607-5e6dba8366f0_6f7579e9-3e43-46c7-a6be-49777d14cb35",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        // 94
        {
          fields: [
            {
              _uid: "1d1ab296-f061-471d-a607-708fcb4c37ef",
              component: "col",
              label: "",
              simplifiedLabel: "9.5.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1187d170-8282-49fb-81f8-d3cb039a9ea0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "POI device surfaces are periodically inspected to detect tampering and unauthorized substitution",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9aaddb7e-a9a4-44da-b7f3-3f130472a1a7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented procedures.",
                "Interview responsible personnel.",
                "Observe inspection processes",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f6196dcd-0cf7-419a-ad70-7dc192a05e8a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c8803159-31bb-4366-9916-67e762b9b535"],
              },
            },
            {
              _uid: "c8803159-31bb-4366-9916-67e762b9b535",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "240fcc06-2c9a-469d-ab65-1d96f79888ed_f6196dcd-0cf7-419a-ad70-7dc192a05e8a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6dfd2aad-c17a-458c-8a5d-3d81309ead7d",
              component: "col",
              label: "",
              simplifiedLabel: "9.5.1.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "814eb712-6094-493d-82a8-d1ffee6e462c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The frequency of periodic POI device inspections and the type of inspections performed is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0dce52e0-3d1c-4e2c-a316-5a27c0d11717",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the targeted risk analysis.",
                "Examine documented results of periodic device inspections.",
                "Interview personnel",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "02e2f4b6-525f-47eb-b91c-503070dc508c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d7c1e02b-80e6-401b-93df-c6499f6f460e"],
              },
            },
            {
              _uid: "d7c1e02b-80e6-401b-93df-c6499f6f460e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "16671e6e-c81e-4c56-9e2c-f45f2b4b2471_02e2f4b6-525f-47eb-b91c-503070dc508c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bdcf5187-160f-4d78-b826-aaafb1a1ef13",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "12125edb-1156-4e90-83a9-23f67ba1b108",
              component: "col",
              label: "",
              simplifiedLabel: "9.5.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "082717c9-a0bc-4949-b47f-f7268f9d580b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Training is provided for personnel in POI environments to be aware of attempted tampering or replacement of POI devices, and includes:",
                "Verifying the identity of any third-party persons claiming to be repair or maintenance personnel, before granting them access to modify or troubleshoot devices.",
                "Procedures to ensure devices are not installed, replaced, or returned without verification",
                "Being aware of suspicious behavior around devices.",
                "Reporting suspicious behavior and indications of device tampering or substitution to appropriate personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e9688e53-8839-4461-9e71-ee5f707376b8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Review training materials for personnel in POI environments.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1d98c191-08c6-4443-bc75-1c11bc6dbb62",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["53b15358-66a6-430f-b141-845e6c7400bf"],
              },
            },
            {
              _uid: "53b15358-66a6-430f-b141-845e6c7400bf",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "1c234b19-d669-4ead-b174-2b7496fa0da0_1d98c191-08c6-4443-bc75-1c11bc6dbb62",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        // 95
        {
          fields: [
            {
              _uid: "e0e759d9-3d8b-436a-93eb-6c74916e8f8b",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: [
                "Regularly Monitor and Test Networks",
                "Requirement 10: Log and Monitor All Access to System Components and Cardholder Data",
                "10.1 Processes and mechanisms for logging and monitoring all access to system components and cardholder data are defined and documented.",
              ],
              subBoldLabel: [],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ac1803ea-a9b2-4229-adc4-52b84fd44c6c",
              component: "col",
              label: "",
              simplifiedLabel: "10.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3c68aa11-f394-4b19-a89d-b77d2a60a056",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 10 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "bd11ec57-7263-48d8-9858-e4801fa7322c",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fabbf97f-2343-4fa8-bb95-8575e1419068",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["11b68356-03f5-4e45-b410-145ffa451209"],
              },
            },
            {
              _uid: "11b68356-03f5-4e45-b410-145ffa451209",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a0dfc187-124a-4cab-978b-d035132e2818_fabbf97f-2343-4fa8-bb95-8575e1419068",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "efee4ad4-93bd-49c6-8c5e-5e59aad935bb",
              component: "col",
              label: "",
              simplifiedLabel: "10.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "d9aefd5d-8733-4727-a373-4a14ef64a0b3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 10 are documented, assigned, and understood",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "59e05cfb-1f88-4246-ae6f-6e8edb3d1c33",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "00576fde-8cf6-435d-b650-7aaff37a1806",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["63c6e4e5-7cdb-428b-a879-79937a5d2c71"],
              },
            },
            {
              _uid: "63c6e4e5-7cdb-428b-a879-79937a5d2c71",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "648b766a-0b9d-4a0d-99fa-ba612f680364_00576fde-8cf6-435d-b650-7aaff37a1806",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "121324d0-1f1e-451a-b698-bdf026b8fe10",
              component: "col",
              label: "",
              boldLabel: [
                "10.2 Audit logs are implemented to support the detection of anomalies and suspicious activity, and the forensic analysis of events",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d7980d5c-52ef-4e88-b4fa-60c5e519c1bb",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "18f96243-6a7f-45ef-a1a6-1d1c785e0f20",
              component: "col",
              label: [],
              simplifiedLabel: ["Audit logs are enabled and active for all system components and cardholder data."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f1c06d79-774f-4578-8ac7-72f33759f2ae",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview the system administrator", "Examine system configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["30182585-5055-4209-9e5b-e54795fd955a"],
              },
            },
            {
              _uid: "30182585-5055-4209-9e5b-e54795fd955a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ca5920c5-2bb8-4ead-9fad-8a6d3af1cc45_6f49fdbb-ad9f-4d7a-ae40-2f1a61c2c947",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a0051a6b-4dc3-44e8-a3bf-e35187efb088",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c43cfbd1-3cb8-4ce1-b31c-65dfb52abe4f",
              component: "col",
              label: [],
              simplifiedLabel: ["Audit logs are enabled and active for all system components and cardholder data."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7329e4a2-a8e3-4d13-8671-b04f7e99f6a1",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine audit log configurations.", "Examine audit log data."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ef2ef2c5-8c56-4c57-a84e-3b173231456f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["aefcf861-7ed8-4702-a63f-0447bdd76419"],
              },
            },
            {
              _uid: "aefcf861-7ed8-4702-a63f-0447bdd76419",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "381f144a-80b6-4d01-b560-f1442eac9018_ef2ef2c5-8c56-4c57-a84e-3b173231456f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 96
        {
          fields: [
            {
              _uid: "431e00e8-9f35-4d97-9d18-a0185d6c02a5",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3979f38a-0ec7-4a1c-97a3-d02f6ecd2e0d",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Audit logs capture all actions taken by any individual with administrative access, including any interactive use of application or system accounts.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2a092b0f-52f5-4ad3-9e17-689836c3b539",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine audit log configurations.", "Examine audit log data."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0924deaa-c9e0-43d1-9629-284bcabb556d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d1b52425-d0d5-42f0-b007-e1d8f47e9f3d"],
              },
            },
            {
              _uid: "d1b52425-d0d5-42f0-b007-e1d8f47e9f3d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d0bfd09c-b744-4c11-b3bb-51ef97482257_0924deaa-c9e0-43d1-9629-284bcabb556d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "490c3803-6c2e-46ad-b2dd-6874e637e2bd",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "54daf29f-a024-486e-bf60-d21ad784adf9",
              component: "col",
              label: [],
              simplifiedLabel: ["Audit logs capture all access to audit logs. "],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0474b368-cc73-4ea0-92a0-e1d1124f66b4",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine audit log configurations.", "Examine audit log data."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1009d3b1-ab5c-419e-8ed7-427c6d66e08a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["60750524-ca23-4495-aee6-bc826e984c63"],
              },
            },
            {
              _uid: "60750524-ca23-4495-aee6-bc826e984c63",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6aa07093-ad18-495e-a255-09c52cac0e79_1009d3b1-ab5c-419e-8ed7-427c6d66e08a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1d21a70c-38f3-4ea0-92c2-01d16a04667b",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "eadf3587-f82b-4d05-99ef-bf1082264d6b",
              component: "col",
              label: [],
              simplifiedLabel: ["Audit logs capture all invalid logical access attempts."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d3f10a6d-beb2-4d51-8319-07e14b492f2d",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine audit log configurations.", "Examine audit log data."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "af2dc40d-9bff-4941-b487-21efcd512176",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["587d5e6b-83ca-4979-8808-a7bff802da8a"],
              },
            },
            {
              _uid: "587d5e6b-83ca-4979-8808-a7bff802da8a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d370e915-1b01-4395-aad2-ecf73ce9a208_af2dc40d-9bff-4941-b487-21efcd512176",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "fa9ab642-5cef-4d4c-8e9b-80fd5300ccc5",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "fb388928-d662-4ccf-9e67-cdba513c6851",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel:
                  "Audit logs capture all changes to identification and authentication credentials including, but not limited to:",
                ul: [
                  "Creation of new accounts.",
                  "• Elevation of privileges",
                  "All changes, additions, or deletions to accounts with administrative access.",
                ],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "3713db85-7a7a-4f59-82ca-4c07906bcbf8",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine audit log configurations.", "Examine audit log data."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e25036e0-9f23-407e-aacd-b3cb14a13b90",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2d8d9108-c5b4-43b4-b815-51179a27eb2d"],
              },
            },
            {
              _uid: "2d8d9108-c5b4-43b4-b815-51179a27eb2d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ad4a06b3-3364-49f8-8a3d-6d54d1675cd0_e25036e0-9f23-407e-aacd-b3cb14a13b90",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2c882401-9940-494a-9483-662a88748758",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "330e4040-56eb-4692-8646-fabd5ba333e2",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel: "Audit logs capture the following:",
                ul: [
                  "All initialization of new audit logs, and",
                  "All starting, stopping, or pausing of the existing audit logs.",
                ],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b2bab722-27ed-45a5-8907-81047d8bebd3",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine audit log configurations.", "Examine audit log data."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b550c9dd-ea05-4b09-8c88-47f071239f59",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f512d329-99a4-4c75-a910-29bc29074d7d"],
              },
            },
            {
              _uid: "f512d329-99a4-4c75-a910-29bc29074d7d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "0e88ec32-7920-4023-9fa6-ef029d7da66c_b550c9dd-ea05-4b09-8c88-47f071239f59",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "71db21ad-1a93-4f57-a253-100809f64419",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.1.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "aa4d201d-70a4-45e2-95e5-d6388717e487",
              component: "col",
              label: [],
              simplifiedLabel: ["Audit logs capture all creation and deletion of systemlevel objects."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "bda94843-f5d3-4829-8f53-8019fe9076de",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine audit log configurations.", "Examine audit log data."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8d750507-de52-41f2-b88a-b001c12cf008",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["529b00ec-5c6e-413c-9d8c-39aaa05d16fa"],
              },
            },
            {
              _uid: "529b00ec-5c6e-413c-9d8c-39aaa05d16fa",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f3ecb91d-3214-4e98-9f94-b203e02e921e_8d750507-de52-41f2-b88a-b001c12cf008",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 97
        {
          fields: [
            {
              _uid: "2eba8df1-efa1-410b-982d-ca6af9547121",
              component: "col",
              label: "",
              simplifiedLabel: "10.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "b0f9ff05-84ca-4dca-9590-5a82173401ae",
              component: "col",
              label: [],
              simplifiedLabel: [""],
              labelWithUl: {
                label: "",
                simplifiedLabel: "Audit logs record the following details for each auditable event:",
                ul: [
                  "User identification.",
                  "Type of event",
                  "Date and time.",
                  "Success and failure indication",
                  "Origination of event.",
                  "• Identity or name of affected data, system component, resource, or service (for example, name and protocol).",
                ],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "793b0905-9e7f-47f3-8545-53da7b4a373b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Interview responsible personnel",
                "Examine audit log configurations.",
                "Examine audit log data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0989a337-8e20-4704-b727-a45c44c2a9f3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7a819644-5368-41c5-aefc-a708a5e300b0"],
              },
            },
            {
              _uid: "7a819644-5368-41c5-aefc-a708a5e300b0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f0f3de91-e63e-4de9-9ece-534fbb7e305e_0989a337-8e20-4704-b727-a45c44c2a9f3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "38c6b643-8e88-4fc9-b780-6c239ef904b5",
              component: "col",
              label: "",
              boldLabel: ["10.3 Audit logs are protected from destruction and unauthorized modifications"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b6faad0b-ba25-47f7-91e6-d824452c15da",
              component: "col",
              label: "",
              simplifiedLabel: "10.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6441ecf7-e30a-4cfc-a988-c78152e7c024",
              component: "col",
              label: [],
              simplifiedLabel: ["Read access to audit logs files is limited to those with a job-related need."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "86033a0f-6704-4397-98d1-b18f154941eb",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview system administrators.", "Examine system configurations and privileges"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2b114170-0532-4a0a-90e6-ae6a8f652b0d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e74472ef-85eb-4e4f-b801-215988e79dbf"],
              },
            },
            {
              _uid: "e74472ef-85eb-4e4f-b801-215988e79dbf",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "646dcd19-cf74-48f6-86b4-110c8f63af24_2b114170-0532-4a0a-90e6-ae6a8f652b0d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e55bbfac-1de5-4894-8fe1-acf529120f1d",
              component: "col",
              label: "",
              simplifiedLabel: "10.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a829c51e-37d2-4386-8b49-30a57ed1f5c7",
              component: "col",
              label: [],
              simplifiedLabel: ["Audit log files are protected to prevent modifications by individuals."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cd974290-7777-47a0-8271-43c9590a0755",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configurations and privileges", "Interview system administrators."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e90db5e6-004f-44c9-a10c-f1f8546f78c1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d1ff014c-1fb9-40a8-9d3d-9bae2e5c29d0"],
              },
            },
            {
              _uid: "d1ff014c-1fb9-40a8-9d3d-9bae2e5c29d0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "646dcd19-cf74-48f6-86b4-110c8f63af24_e90db5e6-004f-44c9-a10c-f1f8546f78c1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5e9c8d01-5cbd-4355-9c46-ee2f650e12f2",
              component: "col",
              label: "",
              simplifiedLabel: "10.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a829c51e-37d2-4386-8b49-30a57ed1f5c7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Audit log files, including those for external-facing technologies, are promptly backed up to a secure, central, internal log server(s) or other media that is difficult to modify.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "cd974290-7777-47a0-8271-43c9590a0755",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine backup configurations or log files"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_nested"],
                _uids: ["574743cb-8875-49e5-b7f8-05bd17c3da6a"],
              },
            },
            {
              _uid: "574743cb-8875-49e5-b7f8-05bd17c3da6a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "19a49034-c268-49fc-ab30-203317e9fbae_5ac8d604-b11c-4106-b3df-f2bcc32f8c1a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b990bfd4-1a23-4113-9340-8ea45ebf723a",
              component: "col",
              label: "",
              simplifiedLabel: "10.3.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "81379e17-8eac-493f-95de-3fa3d789e8ed",
              component: "col",
              label: [],
              simplifiedLabel: [
                "File integrity monitoring or change-detection mechanisms is used on audit logs to ensure that existing log data cannot be changed without generating alerts.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "25ef34c0-854e-4b61-8640-753728d8ea63",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system settings.",
                "Examine monitored files. • Examine results from monit",
                "Examine results from monitoring activities",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "577eb8b3-4785-4de3-8873-458c81bedea6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["582d6b28-6d27-4762-be39-e563195f1b1f"],
              },
            },
            {
              _uid: "582d6b28-6d27-4762-be39-e563195f1b1f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "7a39040f-4a4f-4cb7-be8c-64f7d3740b62_577eb8b3-4785-4de3-8873-458c81bedea6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 98
        {
          fields: [
            {
              _uid: "2e9cd614-5acb-40fc-b835-b2a30f5acd29",
              component: "col",
              label: "",
              boldLabel: ["10.4 Audit logs are reviewed to identify anomalies or suspicious activity."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5e71be1e-eac7-446e-8f46-fb69fa14c4ff",
              component: "col",
              label: "",
              simplifiedLabel: "10.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0ab1775b-9c48-4f3a-a230-54132e60b7d4",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel: "The following audit logs are reviewed at least once daily:",
                ul: [
                  "All security events. ",
                  "Logs of all system components that store, process, or transmit CHD and/or SAD.",
                  "Logs of all critical system components.",
                  "Logs of all servers and system components that perform security functions (for example, network security controls, intrusion-detection systems/intrusion-prevention systems (IDS/IPS), authentication servers).",
                ],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "213f5993-6dde-40f7-acd3-05510b933f27",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine security policies and procedures.",
                "Observe processes.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ec91bd42-ad86-4727-a136-ef40a4cae306"],
              },
            },
            {
              _uid: "ec91bd42-ad86-4727-a136-ef40a4cae306",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c0e319c2-ef13-412f-9a58-c2c2130287d1_95efcd76-f7d7-45b2-b2cd-fc26b6a370a7",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "04a44cf4-8b98-439d-964e-ef9476f966e1",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 10.4.1.1",
              subBoldLabel: [
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9ec91589-5d30-489e-8cb5-83ae0f62014d",
              component: "col",
              label: "",
              simplifiedLabel: "10.4.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1e7dd178-197c-4c23-9800-27f2d8105569",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel: "Automated mechanisms are used to perform audit log reviews.",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "af53b33a-d07d-4d1c-a60c-c86e4e441daf",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine log review mechanisms", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9430d525-a165-45a3-9753-35f0c0498c69"],
              },
            },
            {
              _uid: "9430d525-a165-45a3-9753-35f0c0498c69",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "680c3789-f76d-4604-b5da-6d1e4c4ed0bd_a8121f0b-fcce-4b32-98f1-83b7cca5f5d5",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d0b3ee1e-2392-4d98-9d66-9868490f4a6d",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 10.4.2",
              subBoldLabel: [
                "This requirement is applicable to all other in-scope system components not included in Requirement 10.4.1.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7f1bee72-ef13-492b-beca-9f39222e2e87",
              component: "col",
              label: "",
              simplifiedLabel: "10.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "8f0a0a98-dc50-4011-8771-88f0a7004ddb",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel:
                  "Logs of all other system components (those not specified in Requirement 10.4.1) are reviewed periodically.",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "815866f0-28b8-4784-a328-3f8a0e93d342",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine security policies and procedures.",
                "Examine documented results of log reviews",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["05922ca2-7b75-41b9-9a08-6783a3272a0b"],
              },
            },
            {
              _uid: "05922ca2-7b75-41b9-9a08-6783a3272a0b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "84695b43-2799-4d2b-9563-669a60a72c48_1b1cd8ef-34cc-4abd-8bfc-bc00150c7424",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 99
        {
          fields: [
            {
              _uid: "df5ac485-8381-427e-b27a-5968e2441988",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 10.4.2.1",
              subBoldLabel: [
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "abe4603b-66ae-4b17-b2d9-e5a29280e6c3",
              component: "col",
              label: "",
              simplifiedLabel: "10.4.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "843fd7ee-4350-4cd1-9b96-860389afc7c8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The frequency of periodic log reviews for all other system components (not defined in Requirement 10.4.1) is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "323ce01f-5fdc-42fd-96f1-7cbe6188886e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the targeted risk analysis",
                "• Examine documented results of periodic log reviews.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "abc72c86-8f45-43ed-9391-2b139ade85a8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e29544b8-f280-4cf6-b8fb-3506ac69135f"],
              },
            },
            {
              _uid: "e29544b8-f280-4cf6-b8fb-3506ac69135f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "636a0ce3-a8a8-479a-aa81-d2878fc51ab2_abc72c86-8f45-43ed-9391-2b139ade85a8",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ffdcac76-644f-4bd1-9780-09f4aabd9abb",
              component: "col",
              label: "",
              simplifiedLabel: "10.4.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "60f4e930-7474-40b7-9494-1f2f9962c973",
              component: "col",
              label: [],
              simplifiedLabel: ["Exceptions and anomalies identified during the review process are addressed."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "43e7107e-74c7-414f-96ea-1bf2be25e6cf",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine security policies and procedures.",
                "Observe processes",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7b897dd5-d3fa-494e-bfb0-81552145d9a5"],
              },
            },
            {
              _uid: "7b897dd5-d3fa-494e-bfb0-81552145d9a5",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "772038da-c4c4-4180-a822-a105ed0306eb_af84ab2d-5d17-4aee-9026-0ec1cf7d7d2b",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5d411ea8-9667-4767-8a79-b7d0a967a2ca",
              component: "col",
              label: "",
              boldLabel: ["10.5 Audit log history is retained and available for analysis."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4d323a5e-ae84-4383-b991-0ca8d5e87e4d",
              component: "col",
              label: "",
              simplifiedLabel: "10.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "46d41bdd-ac0c-45c7-b22d-5a977a381c2a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Retain audit log history for at least 12 months, with at least the most recent three months immediately available for analysis.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c13aa19d-7c3d-45e2-8f1f-7e8f4d7aa06e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented audit log retention policies and procedures",
                "Examine configurations of audit log history.",
                "Examine audit logs.",
                "Interview personnel.",
                "Observe processes",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1d1b4acd-fd8e-4851-8646-6f7b6f123973",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["aa232693-e542-444f-bfdc-8bf3679f4ebb"],
              },
            },
            {
              _uid: "aa232693-e542-444f-bfdc-8bf3679f4ebb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "b8eb3093-b3ba-4eb5-b9f9-fa39527fb457_1d1b4acd-fd8e-4851-8646-6f7b6f123973",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "eb509213-34c1-4308-b721-fc8be6794bac",
              component: "col",
              label: "",
              boldLabel: [
                "10.6 Time-synchronization mechanisms support consistent time settings across all systems.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c8a04713-99e1-4899-82e8-92cad9ced0c9",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 10.6.1",
              subBoldLabel: [
                "Keeping time-synchronization technology current includes managing vulnerabilities and patching the technology according to PCI DSS Requirements 6.3.1 and 6.3.3.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "99baf295-a6a6-43e0-8a83-484901cde2b2",
              component: "col",
              label: "",
              simplifiedLabel: "10.6.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "aca14e6f-e21b-4123-8d96-1529d59ca472",
              component: "col",
              label: [],
              simplifiedLabel: ["System clocks and time are synchronized using timesynchronization technology."],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "a7fb4ce1-3924-4250-9f74-10db50064aad",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configuration settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "23f6546f-4be5-47bd-b8df-694da76df679",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c41db651-ede3-4a3b-9f40-2bb5406f93f7"],
              },
            },
            {
              _uid: "c41db651-ede3-4a3b-9f40-2bb5406f93f7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "dd67c98b-4adb-4981-a116-f0d87c8877f7_23f6546f-4be5-47bd-b8df-694da76df679",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 100
        {
          fields: [
            {
              _uid: "c1476d29-5eda-4c9c-a576-80245f5d6ee7",
              component: "col",
              label: "",
              simplifiedLabel: "10.6.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "064fd482-4c94-4419-8cd3-03f4f3d1ee70",
              component: "col",
              label: [],
              simplifiedLabel: [],
              labelWithUl: {
                label: "",
                simplifiedLabel: "Systems are configured to the correct and consistent time as follows:",
                ul: [
                  "One or more designated time servers are in use.",
                  "Only the designated central time server(s) receives time from external sources.",
                  "Time received from external sources is based on International Atomic Time or Coordinated Universal Time (UTC).",
                  "The designated time server(s) accept time updates only from specific industry-accepted external sources.",
                  "Where there is more than one designated time server, the time servers peer with one another to keep accurate time.",
                  "Internal systems receive time information only from designated central time server(s).",
                ],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6eeb51ec-c24d-4880-a38c-d397c6acd802",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configuration settings for acquiring, distributing, and storing the correct time",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2c0a4a78-54fd-4720-b9b4-463b13219f9c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["fa716d9f-924a-4e5f-96a3-2aadbe958da7"],
              },
            },
            {
              _uid: "fa716d9f-924a-4e5f-96a3-2aadbe958da7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "e6c25841-f1d0-41e2-964d-4951e6a36f05_2c0a4a78-54fd-4720-b9b4-463b13219f9c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e534e06b-d4c1-4da3-8fc2-f5581b7c50c4",
              component: "col",
              label: "",
              simplifiedLabel: "10.6.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2586bd19-65f7-476e-8e44-36d2d455add8",
              component: "col",
              label: [],
              simplifiedLabel: ["Time synchronization settings and data are protected as follows:"],
              labelWithUl: {
                label: "",
                simplifiedLabel: "Systems are configured to the correct and consistent time as follows:",
                ul: [
                  "Access to time data is restricted to only personnel with a business need.",
                  "Any changes to time settings on critical systems are logged, monitored, and reviewed.",
                ],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "45f6797e-c8b0-4b70-b1b4-f652ddb24500",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configurations and time-synchronization settings and logs",
                "Observe processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "41bc93a6-1d29-4ccb-b19a-9999803dc362",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["1f3af8ea-0a72-4005-bce0-9aed267f1f60"],
              },
            },
            {
              _uid: "1f3af8ea-0a72-4005-bce0-9aed267f1f60",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "cbe63c83-c790-491c-a7da-60b736e70263_41bc93a6-1d29-4ccb-b19a-9999803dc362",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 101
        {
          fields: [
            {
              _uid: "4716f645-35c6-4c1d-a6af-ea17009380cc",
              component: "col",
              label: "",
              boldLabel: [
                "10.7 Failures of critical security control systems are detected, reported, and responded to promptly.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "cf8190c9-798a-4e12-8b02-a07f7db45f27",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 10.7.1",
              subBoldLabel: [
                "TThis requirement applies only when the entity being assessed is a service provider.",
                "This requirement will be superseded by Requirement 10.7.2 once as of 31 March 2025.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "252b5723-14ee-40ab-a0f7-dff63b8edaab",
              component: "col",
              label: "",
              simplifiedLabel: "10.7.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a95be813-c50d-4f5c-8fca-32f0872403bd",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Failures of critical security control systems are detected, alerted, and addressed promptly, including but not limited to failure of the following critical security control systems:",
                "Network security controls.",
                "IDS/IPS.",
                "FIM.",
                "Anti-malware solutions.",
                "Physical access controls.",
                "Logical access controls.",
                "Audit logging mechanisms.",
                "Segmentation controls (if used).",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "685bd879-935e-45fa-90ec-37c2a1939516",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented processes.",
                "Observe detection and alerting processes.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "29edb869-9748-4a0c-a0e8-572074255196",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["87d4294c-1ae8-4474-89a0-07b7c97d9940"],
              },
            },
            {
              _uid: "87d4294c-1ae8-4474-89a0-07b7c97d9940",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8ded21e9-1421-4b1e-ad18-cf239c7c5192_29edb869-9748-4a0c-a0e8-572074255196",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 102
        {
          fields: [
            {
              _uid: "82d4ffc3-bbf7-4170-813c-90010f9873fd",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: "Applicability Notes for 10.7.2",
              subBoldLabel: [
                "This requirement applies to all entities, including service providers, and will supersede Requirement 10.7.1 as of 31 March 2025. It includes two additional critical security control systems not in Requirement 10.7.1.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "66dab5e5-fc6d-4a37-9151-5dd7dee14309",
              component: "col",
              label: "",
              simplifiedLabel: "10.7.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0aea5bc6-2fb5-43e0-b200-1a9bd90bc34c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Failures of critical security control systems are detected, alerted, and addressed promptly, including but not limited to failure of the following critical security control systems:",
                "Network security controls.",
                "IDS/IPS.",
                "Change-detection mechanisms.",
                "Anti-malware solutions.",
                "Physical access controls.",
                "Logical access controls.",
                "Audit logging mechanisms.",
                "Segmentation controls (if used).",
                "Audit log review mechanisms.",
                "Automated security testing tools (if used).",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "8eaf5c87-2de0-4b57-af26-606b8d898897",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented processes.",
                "Observe detection and alerting processes.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "557bcfed-813f-4a17-8a03-211b1b70b54c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["6484fe87-1f0d-402b-bad2-e5b937adec2b"],
              },
            },
            {
              _uid: "6484fe87-1f0d-402b-bad2-e5b937adec2b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "74664e26-c2af-4f0c-8e4e-2266a17e958d_557bcfed-813f-4a17-8a03-211b1b70b54c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 103
        {
          fields: [
            {
              _uid: "f01391c0-120d-42a0-9969-13388b5e4cb7",
              component: "col",
              label: "",
              simplifiedLabel: "10.7.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7f1522aa-618b-4d14-8ad5-c63daa7be23b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Failures of any critical security controls systems are responded to promptly, including but not limited to:",
                "Restoring security functions.",
                "Identifying and documenting the duration (date and time from start to end) of the security failure.",
                "Identifying and documenting the cause(s) of failure and documenting required remediation.",
                "Identifying and addressing any security issues that arose during the failure.",
                "Determining whether further actions are required as a result of the security failure.",
                "Implementing controls to prevent the cause of failure from reoccurring.",
                "Resuming monitoring of security controls.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f0478426-cc76-409d-b3b4-0d27beafe4ff",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented processes.",
                "Interview personnel.",
                "Examine records related to critical security control systems failures.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8005f64c-caea-49a4-a364-fca20bf1accc",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9c68dc5e-f381-4f46-9262-ceb4723f6cd9"],
              },
            },
            {
              _uid: "9c68dc5e-f381-4f46-9262-ceb4723f6cd9",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4da7434b-845e-432c-8c55-5449b002f531_8005f64c-caea-49a4-a364-fca20bf1accc",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 104
        {
          fields: [
            {
              _uid: "ab23c6ef-32b7-4d04-9f05-90753a7f386f",
              component: "col",
              label: "",
              simplifiedLabel: [],
              boldLabel: [
                "Requirement 11: Test Security of Systems and Networks Regularly",
                "11.1 Processes and mechanisms for regularly testing security of systems and networks are defined and understood.",
              ],
              subBoldLabel: [],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e26fae15-e217-400b-a838-8c3c6249cfb7",
              component: "col",
              label: "",
              simplifiedLabel: "11.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ec24cfa5-9537-46b4-ab8b-7ebe98922a96",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All security policies and operational procedures that are identified in Requirement 11 are:",
                "Documented.",
                "Kept up to date.",
                "In use.",
                "Known to all affected parties.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "fed45f43-322c-4fc0-b53d-9c8dac008dfa",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "dced02da-69f6-4d32-acb5-2eee7ef49cea",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["01280747-1f7a-4f69-aca0-7d26dc248003"],
              },
            },
            {
              _uid: "01280747-1f7a-4f69-aca0-7d26dc248003",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2a6e3531-2c70-49f3-8c89-aa740affae46_dced02da-69f6-4d32-acb5-2eee7ef49cea",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "117bfccc-3750-4edc-a353-17f4f6bc69fa",
              component: "col",
              label: "",
              simplifiedLabel: "11.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "87af75d6-ee73-4907-a161-674d27de946f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Roles and responsibilities for performing activities in Requirement 11 are documented, assigned, and understood",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "66f5beff-6856-4c1e-b4a2-fdd866c8f937",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview responsible personnel"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "89b36584-9baa-4914-aa87-6f31234b12f4",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["fddf4b2b-a520-414d-8179-d0f4fd578df7"],
              },
            },
            {
              _uid: "fddf4b2b-a520-414d-8179-d0f4fd578df7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "554acec3-4058-4a55-a83b-250f409b1f4a_89b36584-9baa-4914-aa87-6f31234b12f4",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 105
        {
          fields: [
            {
              _uid: "852008fa-1543-41cf-9efb-e8a6c7451a6b",
              component: "col",
              label: "",
              boldLabel: [
                "11.2 Wireless access points are identified and monitored, and unauthorized wireless access points are addressed.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "83fec3d0-7599-4330-b9d2-c48beef9eb14",
              component: "col",
              label: "",
              simplifiedLabel: "11.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c97097dd-6280-4b8a-a459-70b5ae2ef8f6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Authorized and unauthorized wireless access points are managed as follows:",
                "The presence of wireless (Wi-Fi) access points is tested for.",
                "All authorized and unauthorized wireless access points are detected and identified.",
                "Testing, detection, and identification occurs at least once every three months.",
                "If automated monitoring is used, personnel are notified via generated alerts.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "772c2d93-8682-4ae5-ba60-d20531e12a1a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine the methodology(ies) in use and the resulting documentation.",
                "Interview personnel.",
                "Examine wireless assessment results.",
                "Examine configuration settings.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "674c6625-4d24-4fe1-bf83-fdd629ac6d21",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["85950188-e09f-470a-8023-6f5a062c3e7e"],
              },
            },
            {
              _uid: "85950188-e09f-470a-8023-6f5a062c3e7e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6f0a4e3e-6853-432f-83fc-e21289b7a3ff_674c6625-4d24-4fe1-bf83-fdd629ac6d21",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "79a05f5b-6a91-4ae4-9738-dad7b9204b56",
              component: "col",
              label: "",
              boldLabel: [
                "Applicability Notes",
                "The requirement applies even when a policy exists that prohibits the use of wireless technology since attackers do not read and follow company policy. Methods used to meet this requirement must be sufficient to detect and identify both authorized and unauthorized devices, including unauthorized devices attached to devices that themselves are authorized.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b941a3e3-2f89-4f46-aa0a-7bcdb108f78f",
              component: "col",
              label: "",
              simplifiedLabel: "11.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "8063e69a-c872-4903-a7fc-226f7363212a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An inventory of authorized wireless access points is maintained, including a documented business justification.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "3652fea3-0a8e-45b0-bf03-a72288696071",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c6f162c4-eb1f-4a48-a679-6ba9ae87c39c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5c9f0ebb-bb5e-49eb-ba1e-e74fde3921bc"],
              },
            },
            {
              _uid: "5c9f0ebb-bb5e-49eb-ba1e-e74fde3921bc",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "aa42c08c-e222-4ab0-a2fa-30a62f2ccaa8_c6f162c4-eb1f-4a48-a679-6ba9ae87c39c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 106
        {
          fields: [
            {
              _uid: "c28e4b81-6637-40ec-b6e6-b1176596aa28",
              component: "col",
              label: "",
              simplifiedLabel: [
                ,
                "11.3 External and internal vulnerabilities are regularly identified, prioritized, and addressed.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8fb1de1e-66ae-4001-ba60-edbff627bd14",
              component: "col",
              label: "",
              simplifiedLabel: "11.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7cb1d7b7-eb5f-4166-97df-d1a7da28fd9f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Internal vulnerability scans are performed as follows:",
                "At least once every three months",
                "High-risk and critical vulnerabilities (per the entity’s vulnerability risk rankings defined at Requirement 6.3.1) are resolved.",
                "Rescans are performed that confirm all highrisk and critical vulnerabilities (as noted above) have been resolved.",
                "Scan tool is kept up to date with latest vulnerability information.",
                "Scans are performed by qualified personnel and organizational independence of the tester exists.",
              ],
              labelWithUl: {
                label: "",
                simplifiedLabel: "",
                ul: [],
              },
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9d4407ae-589b-48cc-b910-d53a134639c7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine internal scan report results.",
                "Examine scan tool configurations.",
                "Interview  responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e98c5484-9e29-4415-b26b-94735b38e475",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["be0c4b18-9e20-42b5-ac7a-6f12f4a4cf0a"],
              },
            },
            {
              _uid: "be0c4b18-9e20-42b5-ac7a-6f12f4a4cf0a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "9d6be609-c86a-494b-80b7-4bd563eb4737_e98c5484-9e29-4415-b26b-94735b38e475",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9660adf7-755d-4129-ae05-15a8a7b653dc",
              component: "col",
              label: "",
              boldLabel: [
                "Applicability Notes",
                "It is not required to use a QSA or ASV to conduct internal vulnerability scans.",
                "Internal vulnerability scans can be performed by qualified, internal staff that are reasonably independent of the system component(s) being scanned (for example, a network administrator should not be responsible for scanning the network), or an entity may choose to have internal vulnerability scans performed by a firm specializing in vulnerability scanning.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        // 107
        {
          fields: [
            {
              _uid: "c0478ad4-befb-42d0-af14-3d3a1da66b0f",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6177ccb0-72a0-488c-94cf-9808ade51a4d",
              component: "col",
              label: [],
              simplifiedLabel: [
                "A penetration testing methodology is defined, documented, and implemented by the entity, and includes:",
                "Industry-accepted penetration testing approaches.",
                "Coverage for the entire CDE perimeter and critical systems.",
                "Testing from both inside and outside the network.",
                "Testing to validate any segmentation and scope-reduction controls.",
                "Application-layer penetration testing to identify, at a minimum, the vulnerabilities listed in Requirement 6.2.4.",
                "Network-layer penetration tests that encompass all components that support network functions as well as operating systems.",
                "Review and consideration of threats and vulnerabilities experienced in the last 12 months.",
                "Documented approach to assessing and addressing the risk posed by exploitable vulnerabilities and security weaknesses found during penetration testing.",
                "Retention of penetration testing results and remediation activities results for at least 12 months.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "96ee54a5-28ec-4f60-8501-cd517d27613d",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "73eabfac-f319-4c98-9057-1468a0f631fe",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d2aeb573-376b-4bc4-abc3-33519b3d384f"],
              },
            },
            {
              _uid: "d2aeb573-376b-4bc4-abc3-33519b3d384f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "80fbb278-5758-4f7e-9eb4-f81f3fa16aca_73eabfac-f319-4c98-9057-1468a0f631fe",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3889f28e-318e-46b3-9ce0-387bdeb4c6a5",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The timeframe for addressing lower-risk vulnerabilities is subject to the results of a risk analysis per Requirement 12.3.1 that includes (minimally) identification of assets being protected, threats, and likelihood and/or impact of a threat being realized.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        // 108
        {
          fields: [
            {
              _uid: "963fdfa5-7ec5-4989-857c-6f4c7ccbfa47",
              component: "col",
              label: "",
              simplifiedLabel: "11.3.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "83a2e703-63cd-4836-9b0b-fe5bdfdfb5d6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All other applicable vulnerabilities (those not ranked as high-risk or critical (per the entity’s vulnerability risk rankings defined at Requirement 6.3.1) are managed as follows:",
                "Addressed based on the risk defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
                "Rescans are conducted as needed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4dce2628-27b1-4997-b862-3e48b52232d5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the targeted risk analysis.",
                "Interview responsible personnel.",
                "Examine internal scan report results or other documentation",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2dab926f-e888-4b88-9c0e-b9772ba0805c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["563cf967-5105-4040-bc0d-c09928e0158a"],
              },
            },
            {
              _uid: "563cf967-5105-4040-bc0d-c09928e0158a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "49d1daee-c9b8-4695-9466-016a8f1353c9_2dab926f-e888-4b88-9c0e-b9772ba0805c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "dad2b523-cec9-4e9b-887b-7af424f9c16b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7389b706-8f11-41c4-acc5-4e619fe1ced9",
              component: "col",
              label: [],
              simplifiedLabel: [""],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b0cbbbd1-a1cd-4459-aaec-89b8c76e00d7",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d08e1aeb-247f-4d92-a499-165faef228e6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2036fd54-f3a3-4e96-bfc3-dbf7e2b670ac"],
              },
            },
            {
              _uid: "2036fd54-f3a3-4e96-bfc3-dbf7e2b670ac",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "b790f12f-6c8e-4f30-bf07-25c2d4b2f694_d08e1aeb-247f-4d92-a499-165faef228e6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "963fdfa5-7ec5-4989-857c-6f4c7ccbfa47",
              component: "col",
              label: "",
              simplifiedLabel: "11.3.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "83a2e703-63cd-4836-9b0b-fe5bdfdfb5d6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "All other applicable vulnerabilities (those not ranked as high-risk or critical (per the entity’s vulnerability risk rankings defined at Requirement 6.3.1) are managed as follows:",
                "Addressed based on the risk defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
                "Rescans are conducted as needed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4dce2628-27b1-4997-b862-3e48b52232d5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the targeted risk analysis.",
                "Interview responsible personnel.",
                "Examine internal scan report results or other documentation",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8d32be7e-7b9c-4ac5-962e-80eb81ae3b6f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ccef754f-e7f6-42ef-a7a6-bb275caaf7c3"],
              },
            },
            {
              _uid: "ccef754f-e7f6-42ef-a7a6-bb275caaf7c3",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d043b6aa-c476-452b-9863-1214b624d700_8d32be7e-7b9c-4ac5-962e-80eb81ae3b6f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f8c85c68-c014-4f8e-bf86-fcf53f4e5f4f",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The authenticated scanning tools can be either host-based or network-based.",
                "“Sufficient” privileges are those needed to access system resources such that a thorough scan can be conducted that detects known vulnerabilities",
                "This requirement does not apply to system components that cannot accept credentials for scanning. Examples of systems that may not accept credentials for scanning include some network and security appliances, mainframes, and containers.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "03c33d32-bb0d-4a72-b31e-96767204e7e7",
              component: "col",
              label: "",
              simplifiedLabel: "11.3.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "b2a69394-8e70-4dfa-b7bb-97e4b6f99c48",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Internal vulnerability scans are performed after any significant change as follows:",
                "High-risk and critical vulnerabilities (per the entity’s vulnerability risk rankings defined at Requirement 6.3.1) are resolved",
                "Rescans are conducted as needed.",
                "Scans are performed by qualified personnel and organizational independence of the tester exists (not required to be a QSA or ASV).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d211d38f-205e-43b6-b3f2-c7dd3c4ae182",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine change control documentation.",
                "Interview personnel.",
                "Examine internal scan and rescan report as applicable",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "5e025536-e18f-4ec7-b57e-89d61c6610f0",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8381a231-28c1-4bc8-bd4b-4a5077496203"],
              },
            },
            {
              _uid: "8381a231-28c1-4bc8-bd4b-4a5077496203",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ba448fb1-f311-4735-b704-6eba77c4b355_5e025536-e18f-4ec7-b57e-89d61c6610f0",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d219eb68-f29f-448d-8568-cda3d6b83da9",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Authenticated internal vulnerability scanning per Requirement 11.3.1.2 is not required for scans performed after significant changes.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        // 109
        {
          fields: [
            {
              _uid: "7288bbf0-60d8-4a36-897b-735c94a66596",
              component: "col",
              label: "",
              simplifiedLabel: "11.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6e30624a-a7bb-4139-874d-8deb80b90c90",
              component: "col",
              label: [],
              simplifiedLabel: [
                "External vulnerability scans are performed as follows:",
                "At least once every three months.",
                "By PCI SSC Approved Scanning Vendor (ASV).",
                "Vulnerabilities are resolved and ASV Program Guide requirements for a passing scan are met.",
                "Rescans are performed as needed to confirm that vulnerabilities are resolved per the ASV Program Guide requirements for a passing scan.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "66875b2e-3fc8-4364-9498-8fb3bdff349a",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine ASV scan reports."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d13ee76d-f01a-401d-9a22-b353542b8119"],
              },
            },
            {
              _uid: "d13ee76d-f01a-401d-9a22-b353542b8119",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "79b24d5b-165d-49e2-b5d5-2843dc948c35_e2d203c9-1b3b-4f9c-9b94-0e0fefb53642",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7288bbf0-60d8-4a36-897b-735c94a66596",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "For initial PCI DSS compliance, it is not required that four passing scans be completed within 12 months if the assessor verifies: 1) the most recent scan result was a passing scan, 2) the entity has documented policies and procedures requiring scanning at least once every three months, and 3) vulnerabilities noted in the scan results have been corrected as shown in a re-scan(s).",
                "However, for subsequent years after the initial PCI DSS assessment, passing scans at least every three months must have occurred.",
                "ASV scanning tools can scan a vast array of network types and topologies. Any specifics about the target environment (for example, load balancers, third-party providers, ISPs, specific configurations, protocols in use, scan interference) should be worked out between the ASV and scan customer.",
                "Refer to the ASV Program Guide published on the PCI SSC website for scan customer responsibilities, scan preparation, etc.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0db7d5b7-8537-43e3-9746-1329ed95ff77",
              component: "col",
              label: "",
              simplifiedLabel: "11.3.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "deaa3d47-31a8-42b6-bd2a-70a8e248b539",
              component: "col",
              label: [],
              simplifiedLabel: [
                "External vulnerability scans are performed after any significant change as follows:",
                "Vulnerabilities that are scored 4.0 or higher by the CVSS are resolved.",
                "Rescans are conducted as needed.",
                "Scans are performed by qualified personnel and organizational independence of the tester exists (not required to be a QSA or ASV).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0eca287e-74a1-46bd-80f7-4758b7a87737",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine change control documentation.",
                "Interview personnel.",
                "Examine external scan, and as applicable rescan reports.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["871dc2d0-3b04-422e-aaf6-25cb249636cb"],
              },
            },
            {
              _uid: "871dc2d0-3b04-422e-aaf6-25cb249636cb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "46c6eaf5-1768-453a-86db-64c76ef47dd7_36b4ac54-08d6-4c41-8a8d-02ef8e554c8e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 110
        {
          fields: [
            {
              _uid: "c59990af-d4f1-4783-bdd8-a3bbd8a0cc35",
              component: "col",
              label: "",
              simplifiedLabel:
                "11.4 External and internal penetration testing is regularly performed, and exploitable vulnerabilities and security weaknesses are corrected.",
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "5",
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c0478ad4-befb-42d0-af14-3d3a1da66b0f",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6177ccb0-72a0-488c-94cf-9808ade51a4d",
              component: "col",
              label: [],
              simplifiedLabel: [
                "A penetration testing methodology is defined, documented, and implemented by the entity, and includes:",
                "Industry-accepted penetration testing approaches.",
                "Coverage for the entire CDE perimeter and critical systems.",
                "Testing from both inside and outside the network.",
                "Testing to validate any segmentation and scope-reduction controls.",
                "Application-layer penetration testing to identify, at a minimum, the vulnerabilities listed in Requirement 6.2.4.",
                "Network-layer penetration tests that encompass all components that support network functions as well as operating systems.",
                "Review and consideration of threats and vulnerabilities experienced in the last 12 months.",
                "Documented approach to assessing and addressing the risk posed by exploitable vulnerabilities and security weaknesses found during penetration testing.",
                "Retention of penetration testing results and remediation activities results for at least 12 months.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "96ee54a5-28ec-4f60-8501-cd517d27613d",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1dd8a169-83d4-401b-966f-1912160d7760",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["4a29a900-1bca-48ea-a89f-77ad58d5bb22"],
              },
            },
            {
              _uid: "4a29a900-1bca-48ea-a89f-77ad58d5bb22",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "80fbb278-5758-4f7e-9eb4-f81f3fa16aca_1dd8a169-83d4-401b-966f-1912160d7760",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8a87f86b-9a89-4f60-9959-657f6e7e42e9",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Testing from inside the network (or “internal penetration testing”) means testing from both inside the CDE and into the CDE from trusted and untrusted internal networks.",
                "Testing from outside the network (or “external penetration testing”) means testing the exposed external perimeter of trusted networks, and critical systems connected to or accessible to public network infrastructures.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 111
        {
          fields: [
            {
              _uid: "bec99ef4-32c6-4014-ac3a-b6e01fa39c6b",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "de69e730-6482-4863-91d7-2617175585b8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Internal penetration testing is performed:",
                "Per the entity’s defined methodology.",
                "At least once every 12 months.",
                "After any significant infrastructure or application upgrade or change.",
                "By a qualified internal resource or qualified external third-party.",
                "Organizational independence of the tester exists (not required to be a QSA or ASV).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "52fce623-b720-4dc3-b682-91003a0d5f26",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine scope of work.",
                "Examine results from the most recent external penetration test.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6739355f-a991-4631-b03d-54051513cb1f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["aee7af68-eb6f-431f-b455-f3b6d5e3d208"],
              },
            },
            {
              _uid: "aee7af68-eb6f-431f-b455-f3b6d5e3d208",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "bf189bba-486f-4606-b6e6-a596e230ca62_6739355f-a991-4631-b03d-54051513cb1f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e8475955-6605-41df-89f1-7b0d7efd7ce4",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "357c9284-f475-4a26-943f-068f5b1a26a1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "External penetration testing is performed:",
                "Per the entity’s defined methodology.",
                "At least once every 12 months.",
                "After any significant infrastructure or application upgrade or change.",
                "By a qualified internal resource or qualified external third-party.",
                "Organizational independence of the tester exists (not required to be a QSA or ASV).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "084a98d2-cc2a-48d8-ac5b-a77992edf540",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine scope of work.",
                "Examine results from the most recent external penetration test.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7a389de3-093c-49c5-99a4-83008ed6584e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d4cf1d5c-e6c5-4094-9b45-05c9ead95202"],
              },
            },
            {
              _uid: "d4cf1d5c-e6c5-4094-9b45-05c9ead95202",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8774fc54-0816-4c63-92a5-04bfb6b04fb1_7a389de3-093c-49c5-99a4-83008ed6584e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "fe5edf35-bcfd-498e-8097-36cad1a656e3",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "50bb2e82-3040-40d6-bf30-337e8c74d4b1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Exploitable vulnerabilities and security weaknesses found during penetration testing are corrected as follows:",
                "In accordance with the entity’s assessment of the risk posed by the security issue as defined in Requirement 6.3.1.",
                "Penetration testing is repeated to verify the corrections.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7266b8ce-994e-48f2-948b-98b4523002e6",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine penetration testing results."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fc9a0b7c-a314-462c-8215-35885a399dc4",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c1663284-1d0d-4c0f-85e7-f895302fde80"],
              },
            },
            {
              _uid: "c1663284-1d0d-4c0f-85e7-f895302fde80",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "9d5bcb4f-0806-4f03-bd2c-8446e8d2978a_fc9a0b7c-a314-462c-8215-35885a399dc4",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 112
        {
          fields: [
            {
              _uid: "40e29b01-d613-42e4-9e6c-4095e7bd59b0",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f4fd7449-8177-4c06-ae0d-94f4dc9f3ae9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If segmentation is used to isolate the CDE from other networks, penetration tests are performed on segmentation controls as follows:",
                "At least once every 12 months and after any changes to segmentation controls/methods.",
                "Covering all segmentation controls/methods in use.",
                "According to the entity’s defined penetration testing methodology.",
                "Confirming that the segmentation controls/methods are operational and effective, and isolate the CDE from all out-of-scope systems.",
                "Confirming effectiveness of any use of isolation to separate systems with differing security levels (see Requirement 2.2.3).",
                "Performed by a qualified internal resource or qualified external third party.",
                "Organizational independence of the tester exists (not required to be a QSA or ASV).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2edd3e31-9a1e-4c3e-8f05-7eb2f6411bfc",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine segmentation controls.",
                "Review penetration-testing methodology.",
                "Examine the results from the most recent penetration test.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b06a9af6-6718-49a3-8e57-9d5ce1578b59",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["57f0f713-9675-4140-988e-c2fb14ffec91"],
              },
            },
            {
              _uid: "57f0f713-9675-4140-988e-c2fb14ffec91",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "b6818945-0bb6-4a14-a90e-98aaa9acc387_b06a9af6-6718-49a3-8e57-9d5ce1578b59",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 113
        {
          fields: [
            {
              _uid: "62539c85-9831-4833-b516-55b0d731506c",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "80ad9a20-cf06-47cc-82e8-dd5d0e6308ff",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "If segmentation is used to isolate the CDE from other networks, penetration tests are performed on segmentation controls as follows:",
                "At least once every six months and after any changes to segmentation controls/methods.",
                "Covering all segmentation controls/methods in use.",
                "According to the entity’s defined penetration testing methodology.",
                "Confirming that the segmentation controls/methods are operational and effective, and isolate the CDE from all out-of-scope systems.",
                "Confirming effectiveness of any use of isolation to separate systems with differing security levels (see Requirement 2.2.3).",
                "Performed by a qualified internal resource or qualified external third party.",
                "Organizational independence of the tester exists (not required to be a QSA or ASV).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2a061b42-61aa-43a7-9953-8466219babc0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the results from the most recent penetration test.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0876203e-6ab2-43ee-8cf4-d65b3e266fc6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["44a5acff-8257-457e-bd6e-26ed2e3f6fee"],
              },
            },
            {
              _uid: "44a5acff-8257-457e-bd6e-26ed2e3f6fee",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "71013d05-0e47-483c-b41a-f7eaff7b58b4_0876203e-6ab2-43ee-8cf4-d65b3e266fc6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7cc706ff-feca-49c3-8a35-418c9e92931d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "5",
              width: "100%",
            },
          ],
        },

        // 114
        {
          fields: [
            {
              _uid: "9f8a4f1f-4992-4925-97bc-ba074b5a419e",
              component: "col",
              label: "",
              simplifiedLabel: "11.4.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6ae5ad26-0206-4d28-a870-30b714f5261c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for multi-tenant service providers only:",
                "Multi-tenant service providers support their customers for external penetration testing per Requirement 11.4.3 and 11.4.4.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "66ddfb99-1cb3-4876-a721-8ed4a7d62273",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine evidence."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a1632514-bf6a-405c-bb3b-942e3fae7206",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9280369e-ba22-4b29-8fad-c40273cb4b59"],
              },
            },
            {
              _uid: "9280369e-ba22-4b29-8fad-c40273cb4b59",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d996024a-f514-4eeb-aca5-1da917877b4a_a1632514-bf6a-405c-bb3b-942e3fae7206",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0bbd33ee-4173-4247-9488-25c9798ee6bd",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
                "To meet this requirement, multi-tenant service providers may either: ",
                "Provide evidence to its customers to show that penetration testing has been performed according to Requirements 11.4.3 and 11.4.4 on the customers’ subscribed infrastructure,",
                "OR",
                "Provide prompt access to each of its customers, so customers can perform their own penetration testing",
                "Evidence provided to customers can include redacted penetration testing results but needs to include sufficient information to prove that all elements of Requirements 11.4.3 and 11.4.4 have been met on the customer’s behalf. Refer also to Appendix A1: Additional PCI DSS Requirements for Multi-Tenant Service Providers.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "5",
              width: "100%",
            },
          ],
        },

        // 115
        {
          fields: [
            {
              _uid: "bccc14f5-48f0-4094-a06b-6cf6cec4d456",
              component: "col",
              label: "",
              simplifiedLabel: "11.5 Network intrusions and unexpected file changes are detected and responded to.",
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "5",
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "86046d10-0aa0-4736-9d93-b866b652f6ca",
              component: "col",
              label: "",
              simplifiedLabel: "11.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5eba95f1-b975-45bc-83ab-4a140a4c054a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Intrusion-detection and/or intrusion-prevention techniques are used to detect and/or prevent intrusions into the network as follows:",
                "All traffic is monitored at the perimeter of the CDE.",
                "All traffic is monitored at critical points in the CDE.",
                "Personnel are alerted to suspected compromises.",
                "All intrusion-detection and prevention engines. baselines, and signatures are kept up to date.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "bce2e269-f30c-4985-80a9-640b7d70912e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system configurations and network diagrams.",
                "Examine system configurations.",
                "Interview responsible personnel.",
                "Examine vendor documentation.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "1a3c2eda-e41d-4ceb-8f56-cc50da8c117e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b85db539-63a8-4e13-8b03-0c1a67c98f12"],
              },
            },
            {
              _uid: "b85db539-63a8-4e13-8b03-0c1a67c98f12",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "1ccaa67b-dbf0-47df-95a2-1c6f5134faf0_1a3c2eda-e41d-4ceb-8f56-cc50da8c117e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "09a1ab63-4d76-4066-9612-9460983f802a",
              component: "col",
              label: "",
              simplifiedLabel: "11.5.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "50881108-e934-4a8f-8be7-1ca491761262",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "Intrusion-detection and/or intrusion-prevention techniques detect, alert on/prevent, and address covert malware communication channels.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d76e07e7-347f-4aff-8bad-33d5cffe4a4b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documentation.",
                "Examine configuration settings.",
                "Examine the incident-response plan.",
                "Interview responsible personnel.",
                "Observe processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "49b4434c-61fd-403a-ad1b-23935e8d0981",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d0e84070-b4c6-4512-bddb-89ce8ba20346"],
              },
            },
            {
              _uid: "d0e84070-b4c6-4512-bddb-89ce8ba20346",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c6341399-77d0-444a-bbb3-3a24404dfd0a_49b4434c-61fd-403a-ad1b-23935e8d0981",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2e7580af-cf33-4d6b-a4ed-973ffe196a32",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "5",
              width: "100%",
            },
          ],
        },

        // 116
        {
          fields: [
            {
              _uid: "2d4d7216-6f13-4cb4-a389-3d507fd85538",
              component: "col",
              label: "",
              simplifiedLabel: "11.5.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "714ebdf6-cdbc-4f1f-a77b-f7b76840bf24",
              component: "col",
              label: [],
              simplifiedLabel: [
                "A change-detection mechanism (for example, file integrity monitoring tools) is deployed as follows:",
                "To alert personnel to unauthorized modification (including changes, additions, and deletions) of critical files.",
                "To perform critical file comparisons at least once weekly.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "579be970-6603-4a0d-bbc2-07164ed41e85",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system settings for the change-detection mechanism.",
                "Examine monitored files.",
                "Examine results from monitoring activities.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c1258e5f-ce0f-4285-8cca-15ea685ab432",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["833db74e-3c16-4d5e-b9b8-213d13e2dc90"],
              },
            },
            {
              _uid: "833db74e-3c16-4d5e-b9b8-213d13e2dc90",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "45abe556-0e72-4f2b-add8-33033661624f_c1258e5f-ce0f-4285-8cca-15ea685ab432",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c161c3db-51a4-4034-b73c-85f7a5873710",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "For change-detection purposes, critical files are usually those that do not regularly change, but the modification of which could indicate a system compromise or risk of compromise. Changedetection mechanisms such as file integrity monitoring products usually come pre-configured with critical files for the related operating system. Other critical files, such as those for custom applications, must be evaluated and defined by the entity (that is, the merchant or service provider).",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "5",
              width: "100%",
            },
          ],
        },

        // 117
        {
          fields: [
            {
              _uid: "c5edbfa7-a539-4455-a9f6-10a7e035b533",
              component: "col",
              label: "",
              simplifiedLabel: ["11.6 Unauthorized changes on payment pages are detected and responded to."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7010e03b-f91a-4a9d-bfdc-51f180d6cd2f",
              component: "col",
              label: "",
              simplifiedLabel: ["11.6.1"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "",
              width: "5%",
            },
            {
              _uid: "6576688a-cf75-4e03-833e-89fd6e44941a",
              component: "col",
              label: "",
              simplifiedLabel: ["A change- and tamper-detection mechanism is deployed as follows:"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 4,
              width: "95%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bd2e4ed6-8baf-4137-b582-8a9125a409ad",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3a6f9a81-7311-4023-a5c6-9717ea556b5f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "To alert personnel to unauthorized modification (including indicators of compromise, changes, additions, and deletions) to the HTTP headers and the contents of payment pages as received by the consumer browser.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0339f356-ac53-4799-a19e-161958c05180",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system settings and mechanism configuration settings",
                "Examine monitored payment pages.",
                "Examine results from monitoring activities.",
                "Examine the mechanism configuration settings.",
                "Examine configuration settings.",
                "Interview responsible personnel.",
                "If applicable, examine the targeted risk analysis.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2b9c301c-7eb6-4af7-a60c-b52aa088adea",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f484ffa5-a6c4-429d-a4bd-80b65c2fe78d"],
              },
            },
            {
              _uid: "f484ffa5-a6c4-429d-a4bd-80b65c2fe78d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "878658f1-8a6e-41a6-9e6e-2e410f56b279_2b9c301c-7eb6-4af7-a60c-b52aa088adea",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3e953d63-39f8-4e3c-8c32-40ba638eb84e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "88ea6dad-f844-4514-aa9e-4a5dceab8909",
              component: "col",
              label: [],
              simplifiedLabel: ["The mechanism is configured to evaluate the received HTTP header and payment page."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "dca1fc7c-ddb7-4bbc-aa63-3df5a28303cf",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system settings and mechanism configuration settings",
                "Examine monitored payment pages.",
                "Examine results from monitoring activities.",
                "Examine the mechanism configuration settings.",
                "Examine configuration settings.",
                "Interview responsible personnel.",
                "If applicable, examine the targeted risk analysis.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "5c59e570-80fb-4a90-8c43-00733f977ec6",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["85195eaa-409e-4649-bc74-ffe67418993a"],
              },
            },
            {
              _uid: "85195eaa-409e-4649-bc74-ffe67418993a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "e13caf05-7c8b-4340-83c0-ef69b512c75e_5c59e570-80fb-4a90-8c43-00733f977ec6",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6b5f5311-5974-4644-ba27-609674e6e887",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "9a0d7f0a-34e4-481e-a964-513345507c8e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The mechanism functions are performed as follows:",
                "– At least once every seven days",
                "OR",
                "Periodically (at the frequency defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "34e7c444-90f2-42ff-b59c-a3c631cb7f55",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine system settings and mechanism configuration settings",
                "Examine monitored payment pages.",
                "Examine results from monitoring activities.",
                "Examine the mechanism configuration settings.",
                "Examine configuration settings.",
                "Interview responsible personnel.",
                "If applicable, examine the targeted risk analysis.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c505a38c-31ae-4321-a550-02306a9c6192"],
              },
            },
            {
              _uid: "c505a38c-31ae-4321-a550-02306a9c6192",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c22c32ac-804d-40a7-9f5a-3cba03726252_b1d4ffa6-36c6-4e8e-a90d-220c526ee61b",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "670838b2-d194-4ab6-b14d-8487daf69d42",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The intention of this requirement is not that an entity installs software in the systems or browsers of its consumers, but rather that the entity uses techniques such as those described under Examples in the PCI DSS Guidance column to prevent and detect unexpected script activities.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 118
        {
          fields: [
            {
              _uid: "6dd7b146-10e9-4d4f-9048-e9f77d80dd61",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Maintain an Information Security Policy ",
                "Requirement 12: Support Information Security with Organizational Policies and Programs",
                "12.1 A comprehensive information security policy that governs and provides direction for protection of the entity’s information assets is known and current.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9f7bfbea-c236-4a45-bb82-bdd5992db13d",
              component: "col",
              label: "",
              simplifiedLabel: "12.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "dc8a701d-5d4e-4eab-ba5e-5e16dad06bdf",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An overall information security policy is:",
                "Established.",
                "Published.",
                "Maintained.",
                "Disseminated to all relevant personnel, as well as to relevant vendors and business partners.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b2478530-4596-4892-a82e-1fb096625a93",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the information security policy.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "55903b10-e7da-4d62-b274-02c9818868ea",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["15058b10-aa73-40c1-b228-17c921368cb7"],
              },
            },
            {
              _uid: "15058b10-aa73-40c1-b228-17c921368cb7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4db4bb06-7b67-41eb-8bad-48aee4f96e37_55903b10-e7da-4d62-b274-02c9818868ea",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "62183b4a-1273-4869-9441-c580cc766ec0",
              component: "col",
              label: "",
              simplifiedLabel: "12.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "42bbd809-fef6-447a-9cf7-60879829f17c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The information security policy is:",
                "Reviewed at least once every 12 months.",
                "Updated as needed to reflect changes to business objectives or risks to the environment.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9626341d-b28e-4a9b-a309-4272df1c3cab",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the information security policy.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8341e3bc-9f2f-4fef-910a-284f63611735",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["63869559-eebe-461b-9869-c971184b9465"],
              },
            },
            {
              _uid: "63869559-eebe-461b-9869-c971184b9465",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a5ae8af7-5372-43a2-a923-c18b311f0087_8341e3bc-9f2f-4fef-910a-284f63611735",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0b1cb061-16b0-4f7e-b322-0a4d16c8ac27",
              component: "col",
              label: "",
              simplifiedLabel: "12.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "389028ab-c7fa-407f-95ee-58130ebf02e3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The security policy clearly defines information security roles and responsibilities for all personnel, and all personnel are aware of and acknowledge their information security responsibilities.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e77fd33b-5de4-4e76-98ab-238a21eba4ff",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the information security policy.",
                "Interview responsible personnel.",
                "Examine documented evidence.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "4ea0321a-a184-4484-9210-3e3dab854b3d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["256cc24f-0f7e-4766-b03c-023897e2821b"],
              },
            },
            {
              _uid: "256cc24f-0f7e-4766-b03c-023897e2821b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "9738ca8e-87ff-4821-96f8-499549069f2b_4ea0321a-a184-4484-9210-3e3dab854b3d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "d1e592d7-090e-44cf-a292-b4e576e12be8",
              component: "col",
              label: "",
              simplifiedLabel: "12.1.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "26baf9de-cf9e-4e1d-90c3-009872b9589c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Responsibility for information security is formally assigned to a Chief Information Security Officer or other information security knowledgeable member of executive management.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4f9ab6d8-5952-437d-a9b5-bc787e7ba049",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the information security policy."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7862fd23-b272-4da6-aff4-25bccbdc43ec"],
              },
            },
            {
              _uid: "7862fd23-b272-4da6-aff4-25bccbdc43ec",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3bbc771d-0a79-455e-abc4-4cde7cef39c6_a2f3e53c-aef6-4f8e-8d1c-b9dfd514ef09",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 119
        {
          fields: [
            {
              _uid: "727b96b8-77af-4558-a7ef-2c5172e90ab6",
              component: "col",
              label: "",
              simplifiedLabel: [
                "12.2 Acceptable use policies for end-user technologies are defined and implemented.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3120c993-109e-494b-bd5c-2f39800d3c02",
              component: "col",
              label: "",
              simplifiedLabel: "12.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3497867b-10b8-4a71-99c3-6363c733dd43",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Acceptable use policies for end-user technologies are documented and implemented, including:",
                "Explicit approval by authorized parties.",
                "Acceptable uses of the technology.",
                "List of products approved by the company for employee use, including hardware and software.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "696253d2-6bcd-41ec-baf4-bcd59f6bc53b",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine acceptable use policies.", "Interview responsible personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "21ea68c9-7c02-43bf-b4b6-6cab2e1c5d06",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["08653142-f462-4cc3-ae56-babd07f467c7"],
              },
            },
            {
              _uid: "08653142-f462-4cc3-ae56-babd07f467c7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6ca068e3-4eda-4d75-be14-8ce4afb8e153_21ea68c9-7c02-43bf-b4b6-6cab2e1c5d06",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6467c3db-1958-4773-acce-52ec2bda61ce",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Examples of end-user technologies for which acceptable use policies are expected include, but are not limited to, remote access and wireless technologies, laptops, tablets, mobile phones, and removable electronic media, e-mail usage, and Internet usage.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 120
        {
          fields: [
            {
              _uid: "fcbd86db-5e4d-435b-82dd-9299ada5917c",
              component: "col",
              label: "",
              simplifiedLabel: [
                "12.3 Risks to the cardholder data environment are formally identified, evaluated, and managed.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0a97befc-98c4-497f-b069-05e69a3497cf",
              component: "col",
              label: "",
              simplifiedLabel: "12.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "29d8625f-9321-4390-a7a6-3c88f5e22c06",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Each PCI DSS requirement that provides flexibility for how frequently it is performed (for example, requirements to be performed periodically) is supported by a targeted risk analysis that is documented and includes:",
                "Identification of the assets being protected",
                "Identification of the threat(s) that the requirement is protecting against.",
                "Identification of factors that contribute to the likelihood and/or impact of a threat being realized.",
                "Resulting analysis that determines, and includes justification for, how frequently the requirement must be performed to minimize the likelihood of the threat being realized.",
                "Review of each targeted risk analysis at least once every 12 months to determine whether the results are still valid or if an updated risk analysis is needed.",
                "Review of each targeted risk analysis at least once every 12 months to determine whether the results are still valid or if an updated risk analysis is needed.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b168760e-0f29-4584-9f17-4fba1c108432",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented policies and procedures."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ffca3e33-de1d-441c-adc6-c8fa4821205f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a8919011-18af-4f5a-810c-11e82dbff64d"],
              },
            },
            {
              _uid: "a8919011-18af-4f5a-810c-11e82dbff64d",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8f76449d-080e-442b-a691-2ce5691a5811_ffca3e33-de1d-441c-adc6-c8fa4821205f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "873c40ef-f0b2-4e05-a2ee-1237c4e69c67",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 121
        {
          fields: [
            {
              _uid: "78ac477f-c5be-4e3d-8656-117e12ffc76a",
              component: "col",
              label: "",
              simplifiedLabel: "12.3.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "12afd9b6-dfbf-4455-a75f-40daaa1dd466",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Cryptographic cipher suites and protocols in use are documented and reviewed at least once every 12 months, including at least the following:",
                "An up-to-date inventory of all cryptographic cipher suites and protocols in use, including purpose and where used.",
                "Active monitoring of industry trends regarding continued viability of all cryptographic cipher suites and protocols in use.",
                "A documented strategy to respond to anticipated changes in cryptographic vulnerabilities.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "85299924-5a3f-4d51-8372-f5a62cf29c3d",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "0e95f35f-bcb2-4de0-ad57-2f78df301a0d",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["000a0901-d396-4d2c-a956-17d6e334f429"],
              },
            },
            {
              _uid: "000a0901-d396-4d2c-a956-17d6e334f429",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f7f66cc6-8443-445a-84c9-2f6b5471d45b_0e95f35f-bcb2-4de0-ad57-2f78df301a0d",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "a7bd832d-371f-403e-b4d4-ba6df677948a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The requirement applies to all cryptographic suites and protocols used to meet PCI DSS requirements.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 122
        {
          fields: [
            {
              _uid: "85f7dd10-4b2d-4dc3-90b2-78696cf7a60b",
              component: "col",
              label: "",
              simplifiedLabel: "12.3.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "109a0412-72b5-4d66-a58d-142f06b1ef9d",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Hardware and software technologies in use are reviewed at least once every 12 months, including at least the following:",
                "Analysis that the technologies continue to receive security fixes from vendors promptly.",
                "Analysis that the technologies continue to support (and do not preclude) the entity’s PCI DSS compliance.",
                "Documentation of any industry announcements or trends related to a technology, such as when a vendor has announced “end of life” plans for a technology.",
                "Documentation of a plan, approved by senior management, to remediate outdated technologies, including those for which vendors have announced “end of life” plans.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2ee3c2d2-35f0-4896-84fa-9a1b6dfea63b",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "aefb5185-9120-4db5-98cb-3cfebc27a83a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7912ce2a-433b-4516-827e-ca6cbc590cdb"],
              },
            },
            {
              _uid: "7912ce2a-433b-4516-827e-ca6cbc590cdb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d876eb5a-d694-4432-b67b-595aa0306f4a_aefb5185-9120-4db5-98cb-3cfebc27a83a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "de522809-a8e7-4d2c-a24c-1cadf910d933",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 123
        {
          fields: [
            {
              _uid: "e3b9539f-a796-495f-8be4-fcad59ce221d",
              component: "col",
              label: "",
              simplifiedLabel: ["12.4 PCI DSS compliance is managed."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "cfd2e64a-ba38-4c5b-a1fd-126a621a69a4",
              component: "col",
              label: "",
              simplifiedLabel: "12.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "54d7124e-7997-4d5b-953d-b6692c3376cb",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "Responsibility is established by executive management for the protection of cardholder data and a PCI DSS compliance program to include:",
                "Overall accountability for maintaining PCI DSS compliance.",
                "Defining a charter for a PCI DSS compliance program and communication to executive management.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "82efe81d-8fb9-4c51-a717-b6c49b2b1e57",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "2e292cad-df19-422f-9a9d-ee1e42f62e2e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["0814b571-e929-4dea-aba9-99a2654ae407"],
              },
            },
            {
              _uid: "0814b571-e929-4dea-aba9-99a2654ae407",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d7e1ce36-bdcc-4e3b-83dd-d316e27fa768_2e292cad-df19-422f-9a9d-ee1e42f62e2e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7ae6e3b5-cd1f-4474-bb6a-11ee032e66ce",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
                "Executive management may include C-level positions, board of directors, or equivalent. The specific titles will depend on the particular organizational structure.",
                "Responsibility for the PCI DSS compliance program may be assigned to individual roles and/or to business units within the organization.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 124
        {
          fields: [
            {
              _uid: "6315c624-2d2e-44c4-b73b-95d8f923fa92",
              component: "col",
              label: "",
              simplifiedLabel: "12.4.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e389a42d-49f2-40ac-a833-2f99714dbc31",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "Reviews are performed at least once every three months to confirm that personnel are performing their tasks in accordance with all security policies and operational procedures. Reviews are performed by personnel other than those responsible for performing the given task and include, but are not limited to, the following tasks.",
                "Daily log reviews.",
                "Configuration reviews for network security controls.",
                "Applying configuration standards to new systems.",
                "Responding to security alerts.",
                "Change-management processes.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0a875774-7ae6-4453-8f18-abcd28fc732b",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented policies and procedures.",
                "Interview responsible personnel.",
                "Examine records of reviews.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fd46606f-cf26-4f3c-b2c8-125bd2c3756a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["0193c366-bc8f-43a8-8e42-8bfbe699a92e"],
              },
            },
            {
              _uid: "0193c366-bc8f-43a8-8e42-8bfbe699a92e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "9194d6ac-3113-4556-95d5-98bea6239f92_fd46606f-cf26-4f3c-b2c8-125bd2c3756a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1ec71979-6110-4412-ab59-d9665d29d97d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 125
        {
          fields: [
            {
              _uid: "b0d3a257-6dec-40ff-a8ef-c083523260c0",
              component: "col",
              label: "",
              simplifiedLabel: "12.4.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "df779577-f3ba-4e64-838d-25c6a044352c",
              component: "col",
              label: [],
              boldLabel: ["Additional requirement for service providers only:"],
              simplifiedLabel: [
                "Reviews conducted in accordance with Requirement 12.4.2 are documented to include:",
                "Results of the reviews",
                "Documented remediation actions taken for any tasks that were found to not be performed at Requirement 12.4.2.",
                "Review and sign-off of results by personnel assigned responsibility for the PCI DSS compliance program",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "7b696843-b6a3-4dbb-a477-1bf76b4c78a6",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation from the reviews."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "dc44de87-ac4a-42f0-98b9-938626b30c75",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ccb1c4b9-4119-45f0-9d26-79bc38a9e498"],
              },
            },
            {
              _uid: "ccb1c4b9-4119-45f0-9d26-79bc38a9e498",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "5a29506b-5bca-4769-b8bb-1ddbb541df5a_dc44de87-ac4a-42f0-98b9-938626b30c75",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bf402583-370c-4130-a4b1-70eb31b439ea",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "117e9206-d1b2-4ee8-86ce-9b034769a47a",
              component: "col",
              label: "",
              simplifiedLabel: ["12.5 PCI DSS scope is documented and validated."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "be2399cf-051e-4e7f-948e-3cbdc593700a",
              component: "col",
              label: "",
              simplifiedLabel: "12.5.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a4eaacd6-c693-4f63-a00d-d12544d9c962",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An inventory of system components that are in scope for PCI DSS, including a description of function/use, is maintained and kept current.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "48d8e303-1c28-43ab-96bb-ee606209c761",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the inventory.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ed985296-985f-41df-ab30-574fe1cab224",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["18424e14-d625-4f87-ac95-145b43b0dbf8"],
              },
            },
            {
              _uid: "18424e14-d625-4f87-ac95-145b43b0dbf8",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "43d49e8a-7c5a-47f8-8c7e-68ca2dd62eae_ed985296-985f-41df-ab30-574fe1cab224",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2985ee0f-49d8-48df-9e73-8398cf671ebd",
              component: "col",
              label: "",
              simplifiedLabel: "12.5.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f0555f3a-420b-41fd-971c-b3f312a94216",
              component: "col",
              label: [],
              simplifiedLabel: [
                "PCI DSS scope is documented and confirmed by the entity at least once every 12 months and upon significant change to the in-scope environment.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "3644a5ee-f74e-4141-97e8-269ef0b90092",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented results of scope reviews", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "856a8d5e-81a4-480f-8a54-b8d0c99afd92",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["af1f8444-2b30-40a1-aacf-14d2fab32bcb"],
              },
            },
            {
              _uid: "af1f8444-2b30-40a1-aacf-14d2fab32bcb",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "b91fd898-ac88-4383-b980-a081bc20cd18_856a8d5e-81a4-480f-8a54-b8d0c99afd92",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "2985ee0f-49d8-48df-9e73-8398cf671ebd",
              component: "col",
              label: "",
              simplifiedLabel: "12.5.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f0555f3a-420b-41fd-971c-b3f312a94216",
              component: "col",
              label: [],
              simplifiedLabel: [
                "PCI DSS scope is documented and confirmed by the entity at least once every 12 months and upon significant change to the in-scope environment.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "3644a5ee-f74e-4141-97e8-269ef0b90092",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented results of scope reviews", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "9a830856-4384-4e5c-92b5-932e7818661a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a5c45cb3-d79a-44ee-84f9-4cd83f10a540"],
              },
            },
            {
              _uid: "a5c45cb3-d79a-44ee-84f9-4cd83f10a540",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "b91fd898-ac88-4383-b980-a081bc20cd18_9a830856-4384-4e5c-92b5-932e7818661a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9c54eb48-3d3d-44a2-8826-8ede7cdb949f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5098392b-8772-4b81-a1ab-c5c065cfb60f",
              component: "col",
              label: [],
              boldLabel: ["At a minimum, the scoping validation includes:"],
              simplifiedLabel: [
                "Identifying all data flows for the various payment stages (for example, authorization, capture settlement, chargebacks, and refunds) and acceptance channels (for example, card-present, card-not-present, and e-commerce).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "6c43d7ae-2271-4e69-a6a5-8af1e5ab8b94",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented results of scope reviews"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d9b46ce2-ee08-4ed4-81f1-4e182fcf08ea",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["97c2e8eb-d978-47ee-a785-dd2cb8e7b2df"],
              },
            },
            {
              _uid: "97c2e8eb-d978-47ee-a785-dd2cb8e7b2df",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "4c25eddc-eff2-4be8-8420-e5964478a734_d9b46ce2-ee08-4ed4-81f1-4e182fcf08ea",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7cae2042-8f47-4c43-a6f2-96cf72db953f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a21b865c-ec94-41cf-a0c3-42ac24550df8",
              component: "col",
              label: [],
              simplifiedLabel: ["Updating all data-flow diagrams per requirement 1.2.4. (continued)."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "79b7bb7c-75dd-4e7b-8ff2-238541d93d06",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "8763592d-8a00-4b72-9aea-a3225619bd51",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["5e86b687-6e26-44e9-9348-0ee82952e7b1"],
              },
            },
            {
              _uid: "5e86b687-6e26-44e9-9348-0ee82952e7b1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "7d524b8c-98e3-4d04-890c-1002bdf96841_8763592d-8a00-4b72-9aea-a3225619bd51",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        //126
        {
          fields: [
            {
              _uid: "d32e886f-0275-4419-95a0-5e788b53bc65",
              component: "col",
              label: "",
              simplifiedLabel: "12.5.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "4bfd35be-f00a-42d8-8689-cf4ce5d274ba",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Identifying all locations where account data is stored, processed, and transmitted, including but not limited to: 1) any locations outside of the currently defined CDE, 2) applications that process CHD, 3) transmissions between systems and networks, and 4) file backups.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "56195801-02bb-4216-93dd-4e6f4702093f",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b969fc3b-efbd-43da-83ec-229ebec09fde",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b81756bb-a47e-47ad-9d03-5d6d3fbe9e6b"],
              },
            },
            {
              _uid: "b81756bb-a47e-47ad-9d03-5d6d3fbe9e6b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "44bea758-4158-4a38-9eaf-38bac6f22fc0_b969fc3b-efbd-43da-83ec-229ebec09fde",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5b457f7a-4efc-4f44-9ee9-09f2b6844723",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2ed6d5c1-d982-47b9-8a16-65a01a0ede40",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Identifying all system components in the CDE, connected to the CDE, or that could impact security of the CDE.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "13d6d40c-a0ff-42ac-a8fe-bd3c362cb795",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "fc65a2e3-f213-4bf8-8cb1-5b6708905704",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e1a1f1f7-48bf-48b5-bfab-e74841f15fde"],
              },
            },
            {
              _uid: "e1a1f1f7-48bf-48b5-bfab-e74841f15fde",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "23af8bb1-efcd-4598-a2b3-1157d2c94735_fc65a2e3-f213-4bf8-8cb1-5b6708905704",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "ca62831c-316a-4a8e-b9a7-844c9ea01caa",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "fbff3c29-0aec-4705-b6f4-ccb7ff7a9259",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Identifying all segmentation controls in use and the environment(s) from which the CDE is segmented, including justification for environments being out of scope.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "1c13c8c3-422f-4585-a2db-2fd474dd2a07",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "85d2e403-7575-40d2-af51-a36e3f13278a",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a0146dd7-780d-4784-9fb6-a42958684d33"],
              },
            },
            {
              _uid: "a0146dd7-780d-4784-9fb6-a42958684d33",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c34f168d-85a8-4715-b4a2-fe75b32a13ff_85d2e403-7575-40d2-af51-a36e3f13278a",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1ae50f95-8af0-4586-92d6-0183c088b7f8",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6255b24b-3fa4-4dcb-92f7-2fd4d4711019",
              component: "col",
              label: [],
              simplifiedLabel: ["Identifying all connections from third-party entities with access to the CDE."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c96a4b2d-2e4e-41a8-92af-7490122efde4",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c3c530da-bf4f-4b4e-b9c4-e6e5ff08435e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e25932f2-2406-474d-861a-997448bb3a3a"],
              },
            },
            {
              _uid: "e25932f2-2406-474d-861a-997448bb3a3a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "be43af4f-bbf1-4e8f-ac0b-1fd901d35b7d_c3c530da-bf4f-4b4e-b9c4-e6e5ff08435e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3effece8-45d8-4ab4-84af-c70c122b3caa",
              component: "col",
              label: "",
              simplifiedLabel: "",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2cc2a005-582d-4b28-ad32-72fb7a686e4f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Confirming that all identified data flows, account data, system components, segmentation controls, and connections from third parties with access to the CDE are included in scope.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "046a7c2b-7c82-4555-ba84-916af19813c1",
              component: "col",
              label: [],
              simplifiedLabel: [],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ed1dc504-ad0d-4628-ba94-c515a0b1042c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["9955cde8-a232-4143-9694-e410630c16f7"],
              },
            },
            {
              _uid: "9955cde8-a232-4143-9694-e410630c16f7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "60d8d988-7945-4dc5-99bc-fa6d99c5a303_ed1dc504-ad0d-4628-ba94-c515a0b1042c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0a66e38d-a280-456d-97e4-be931e77989c",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This annual confirmation of PCI DSS scope is an activity expected to be performed by the entity under assessment, and is not the same, nor is it intended to be replaced by, the scoping confirmation performed by the entity’s assessor during the annual assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 127
        {
          fields: [
            {
              _uid: "6cb68e4e-166a-4877-aa26-8ab76e13dfb6",
              component: "col",
              label: "",
              simplifiedLabel: "12.5.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0bb7da67-f754-4daf-bf60-8351c0ea7e08",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "PCI DSS scope is documented and confirmed by the entity at least once every six months and upon significant change to the in-scope environment",
                "At a minimum, the scoping validation includes all the elements specified in Requirement 12.5.2.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4d198a07-7c47-48c5-a562-b0d70c1cc905",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented results of scope reviews.", "Interview personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6ef603ee-17bf-445c-a481-f16207db6a71",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f294532c-aedf-4a55-ac46-ed0dee830fb8"],
              },
            },
            {
              _uid: "f294532c-aedf-4a55-ac46-ed0dee830fb8",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "f859b4dd-defb-4cd8-9671-c41c28329ac5_6ef603ee-17bf-445c-a481-f16207db6a71",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9b02ae77-a8f9-433c-bcbe-b70e72ddb076",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "76984601-63ce-47c6-818c-4dd967e372d6",
              component: "col",
              label: "",
              simplifiedLabel: "12.5.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e01a1afa-5c45-4daa-9bae-ced6533ddeaf",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "Significant changes to organizational structure result in a documented (internal) review of the impact to PCI DSS scope and applicability of controls, with results communicated to executive management.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "c3f37d85-bed7-4346-9090-647d2d2724a0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Interview responsible personnel.",
                "Examine documentation (for example, meeting minutes).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e28d8cc0-65c6-4cc2-8085-1ced026d60e9",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b00da15f-098e-4070-a45a-9f2a3a1e84d0"],
              },
            },
            {
              _uid: "b00da15f-098e-4070-a45a-9f2a3a1e84d0",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "a2fa7093-2e2e-46be-9d5f-619eb6d694a8_e28d8cc0-65c6-4cc2-8085-1ced026d60e9",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "302ca593-5301-45b7-9c7e-0a0c469b216f",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider. This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c1afa99d-ad6d-4461-9139-f341e5833b0d",
              component: "col",
              label: "",
              simplifiedLabel: ["12.6 Security awareness education is an ongoing activity."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "083ffed5-ff71-44f5-92bc-fcb1f3a04984",
              component: "col",
              label: "",
              simplifiedLabel: "12.6.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "81ae63ca-e228-4b67-8091-c2496eefe51c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "A formal security awareness program is implemented to make all personnel aware of the entity’s information security policy and procedures, and their role in protecting the cardholder data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "690a3893-8e57-427d-9bdb-97d71543c236",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the security awareness program."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6c4632ed-6148-4812-a77a-88a2bda3c51c",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["7f8d2c8d-c196-4c0b-a2d2-d9d7366e6bba"],
              },
            },
            {
              _uid: "7f8d2c8d-c196-4c0b-a2d2-d9d7366e6bba",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "dbea4bea-cfaa-4fb4-9cd4-2f7fc941782d_6c4632ed-6148-4812-a77a-88a2bda3c51c",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 128
        {
          fields: [
            {
              _uid: "b1f38aa0-4033-416b-bc74-80bf1f0855d3",
              component: "col",
              label: "",
              simplifiedLabel: "12.6.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "4bfd35be-f00a-42d8-8689-cf4ce5d274ba",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The security awareness program is:",
                "Reviewed at least once every 12 months, and",
                "Updated as needed to address any new threats and vulnerabilities that may impact the security of the entity’s CDE, or the information provided to personnel about their role in protecting cardholder data.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "627b0cdf-c8c7-4857-8df3-dd154189df1e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine security awareness program content.",
                "Examine evidence of reviews.",
                "Interview personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "35efdc23-b8e2-4257-805b-62b570090f4f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c0c7ee76-1667-4f96-aa42-4d9f240d1f51"],
              },
            },
            {
              _uid: "c0c7ee76-1667-4f96-aa42-4d9f240d1f51",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "30755443-7c09-4ff6-8260-bc9673ca374a_35efdc23-b8e2-4257-805b-62b570090f4f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bb3bfbeb-10ba-462a-b859-dfc5ace002ff",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5f01819a-729b-4259-bd78-072c8dfd9f40",
              component: "col",
              label: "",
              simplifiedLabel: "12.6.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "efecb1ff-db13-4b5c-9084-502d40308150",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Personnel receive security awareness training as follows:",
                "Upon hire and at least once every 12 months.",
                "Multiple methods of communication are used.",
                "Personnel acknowledge at least once every 12 months that they have read and understood the information security policy and procedures.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "90221bb3-b66f-4395-9287-68da905ee2e1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine security awareness program records.",
                "Interview applicable personnel.",
                "Examine the security awareness program materials.",
                "Examine personnel acknowledgements.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ff189291-abd3-4a19-a936-8edfbf2fc71e",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["0a09d43a-8bcb-43e2-b69d-8708216a7def"],
              },
            },
            {
              _uid: "0a09d43a-8bcb-43e2-b69d-8708216a7def",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "0cb67f3a-1d78-4a2a-88b4-306a30983063_ff189291-abd3-4a19-a936-8edfbf2fc71e",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5874316d-23a3-4684-82db-80f7b1b4f4da",
              component: "col",
              label: "",
              simplifiedLabel: "12.6.3.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "00c1f941-b9d1-438d-b698-2de36cf9a9d0",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Security awareness training includes awareness of threats and vulnerabilities that could impact the security of the CDE, including but not limited to:",
                "Phishing and related attacks.",
                "Social engineering.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "f6bfd3d1-587a-444c-ba39-4e76758be004",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine security awareness training content."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "ebe3785c-2511-472c-9bbe-e666e3ff4165",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["de7ed07d-3162-4d1e-816d-99c7f704921a"],
              },
            },
            {
              _uid: "de7ed07d-3162-4d1e-816d-99c7f704921a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "e663ed59-1cf0-44b2-b6ab-41c27f5c2007_ebe3785c-2511-472c-9bbe-e666e3ff4165",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b94f216f-b0e8-43c8-bd16-daf47acec034",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "See Requirement 5.4.1 in PCI DSS for guidance on the difference between technical and automated controls to detect and protect users from phishing attacks, and this requirement for providing users security awareness training about phishing and social engineering. These are two separate and distinct requirements, and one is not met by implementing controls required by the other one.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 129
        {
          fields: [
            {
              _uid: "96464ed2-d5cd-40e1-a36a-b1f4a2584ca5",
              component: "col",
              label: "",
              simplifiedLabel: "12.6.3.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1567e93b-5ed1-408b-8b61-360fdf245af1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Security awareness training includes awareness about the acceptable use of end-user technologies in accordance with Requirement 12.2.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "4df11ce8-3c76-47bb-87b1-dbef0e9cfd95",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine security awareness training content."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6c70dbdf-3cf9-412c-a08d-3ed6542f7156",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["d38b89c3-2bac-4bb2-b62c-c86f1755340b"],
              },
            },
            {
              _uid: "d38b89c3-2bac-4bb2-b62c-c86f1755340b",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "ca942040-2136-4638-8bf1-3a331ecc5089_6c70dbdf-3cf9-412c-a08d-3ed6542f7156",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8fbba3ca-44b4-42ab-a06c-5d2f1ae6aa18",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "1b590fc9-2144-43e4-89f2-18373cdd1b93",
              component: "col",
              label: "",
              simplifiedLabel: ["12.7 Personnel are screened to reduce risks from insider threats."],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5f490c5f-fe1b-4699-bee9-cd7dc1cedec2",
              component: "col",
              label: "",
              simplifiedLabel: "12.7.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6ad10072-f3d1-4433-b0fe-65bc2cccc64a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Potential personnel who will have access to the CDE are screened, within the constraints of local laws, prior to hire to minimize the risk of attacks from internal sources.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "28e0449a-3422-4486-88f8-1435f6898f58",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview responsible Human Resource department management personnel."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7c3a0109-05a0-41ec-8d18-337dc862da41",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b9501274-1a26-4444-8b16-467e352784db"],
              },
            },
            {
              _uid: "b9501274-1a26-4444-8b16-467e352784db",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d9a494dc-c54e-4305-9e88-29ea43239d2b_7c3a0109-05a0-41ec-8d18-337dc862da41",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5b71ca15-7fac-4e65-8682-8bf3c18f569f",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "For those potential personnel to be hired for positions such as store cashiers, who only have access to one card number at a time when facilitating a transaction, this requirement is a recommendation only.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "96b8eb3f-59ca-442b-8bd9-2ebeb9f72a9a",
              component: "col",
              label: "",
              simplifiedLabel: [
                "12.8 Risk to information assets associated with third-party service provider (TPSP) relationships is managed.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "cc5339ec-0c9f-4993-8e81-356e1e3fd060",
              component: "col",
              label: "",
              simplifiedLabel: "12.8.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "77750b12-f26e-4a06-8a86-60b23e7c0506",
              component: "col",
              label: [],
              simplifiedLabel: [
                "A list of all third-party service providers (TPSPs) with which account data is shared or that could affect the security of account data is maintained, including a description for each of the services provided.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "49c99066-16d7-4180-af4c-5f4286ebce7b",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine policies and procedures.", "Examine list of TPSPs."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6513c7da-3894-4c92-ba89-bf75834c1b21",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["33370b6f-8461-41d8-ad6d-3061f80a4103"],
              },
            },
            {
              _uid: "33370b6f-8461-41d8-ad6d-3061f80a4103",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8bb4cc1d-ae6b-4d26-b468-2c605db60a1b_6513c7da-3894-4c92-ba89-bf75834c1b21",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "30eee53d-e324-4335-b5d7-ef8e70b81e37",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The use of a PCI DSS compliant TPSP does not make an entity PCI DSS compliant, nor does it remove the entity’s responsibility for its own PCI DSS compliance.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 130
        {
          fields: [
            {
              _uid: "93c2b8d3-1684-47ad-9f1d-6c7f99d64797",
              component: "col",
              label: "",
              simplifiedLabel: "12.8.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0d26a7c8-27e5-49a5-b1ed-7b389ed75e1f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Written agreements with TPSPs are maintained as follows:",
                "Written agreements are maintained with all TPSPs with which account data is shared or that could affect the security of the CDE.",
                "Written agreements include acknowledgments from TPSPs that they are responsible for the security of account data the TPSPs possess or otherwise store, process, or transmit on behalf of the entity, or to the extent that they could impact the security of the entity’s CDE.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "5598f7ca-0246-4e5e-9c78-d6a4d7c24123",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine policies and procedures.", "Examine written agreements with TPSPs."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "63fff20d-a022-42b9-8c16-bfec89f01384",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["172fb8df-2d5a-4fa8-9f2d-411e93dc6bd7"],
              },
            },
            {
              _uid: "172fb8df-2d5a-4fa8-9f2d-411e93dc6bd7",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "3abb8bce-42fa-4b9b-b1fb-f2b092511beb_63fff20d-a022-42b9-8c16-bfec89f01384",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6de5cd7f-12c3-42a8-897c-2074683b3215",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The exact wording of an acknowledgment will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgment does not have to include the exact wording provided in this requirement.",
                "Evidence that a TPSP is meeting PCI DSS requirements (for example, a PCI DSS Attestation of Compliance (AOC) or a declaration on a company’s website) is not the same as a written agreement specified in this requirement.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "13257d1f-e538-4fe9-92c2-91ab87cfaa6f",
              component: "col",
              label: "",
              simplifiedLabel: "12.8.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "6ef366ed-51a1-4b28-b96c-4f269458a0cc",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An established process is implemented for engaging TPSPs, including proper due diligence prior to engagement.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "856d5de2-514c-42df-b12a-b212d63033f9",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine evidence.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "c33690f2-0813-4a47-80f3-bc1fc453cb67",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8159ad20-54db-4a0f-a16c-f82fa1910fd6"],
              },
            },
            {
              _uid: "8159ad20-54db-4a0f-a16c-f82fa1910fd6",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "248c3931-0589-458e-9e59-81d1ca87c002_c33690f2-0813-4a47-80f3-bc1fc453cb67",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 131
        {
          fields: [
            {
              _uid: "50dbe4dd-86e6-4815-a3c7-1cc0c1842a55",
              component: "col",
              label: "",
              simplifiedLabel: "12.8.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "f24d027b-b146-48ba-9509-364e8f9f3f1f",
              component: "col",
              label: [],
              simplifiedLabel: [
                "A program is implemented to monitor TPSPs’ PCI DSS compliance status at least once every 12 months.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "36952c44-2fbb-414f-90aa-193929fb7294",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine documentation.",
                "Interview responsible personnel",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "384945ff-bca6-4ca0-948c-6168ceefda51",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["ebfcc76b-1a58-4965-bc53-d0e875f6bb82"],
              },
            },
            {
              _uid: "ebfcc76b-1a58-4965-bc53-d0e875f6bb82",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "54e0d5f9-af39-4778-94d3-b5af0b66e43a_384945ff-bca6-4ca0-948c-6168ceefda51",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "774c1f7d-7c04-486e-815c-56283c619f46",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "Where an entity has an agreement with a TPSP for meeting PCI DSS requirements on behalf of the entity (for example, via a firewall service), the entity must work with the TPSP to make sure the applicable PCI DSS requirements are met. If the TPSP does not meet those applicable PCI DSS requirements, then those requirements are also “not in place” for the entity.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "47421d6e-80d9-4f9d-82a6-eed98c922da6",
              component: "col",
              label: "",
              simplifiedLabel: "12.8.5",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "27bcb2b1-4c35-4603-82cc-e20e710675a1",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Information is maintained about which PCI DSS requirements are managed by each TPSP, which are managed by the entity, and any that are shared between the TPSP and the entity.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "40b3b7e2-6a9c-448f-a1ab-1db76ac672c8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine documentation.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "686e307f-e890-4567-8c1c-b945bdfd80f5",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["4ccf9f6c-1fc1-4051-83b7-aef8743772a4"],
              },
            },
            {
              _uid: "4ccf9f6c-1fc1-4051-83b7-aef8743772a4",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "5c6dc296-1ea5-4bc8-ba21-33b75cd4d804_686e307f-e890-4567-8c1c-b945bdfd80f5",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "afe4c20f-0f7c-4ec7-91c5-1ab2d2f2c22d",
              component: "col",
              label: "",
              simplifiedLabel: [
                "12.9 Third-party service providers (TPSPs) support their customers’ PCI DSS compliance.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "46219ab7-5a32-462c-bbbc-ecc32cd4dafc",
              component: "col",
              label: "",
              simplifiedLabel: "12.9.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "141aa9ef-d9db-403a-b8df-9902df79c16e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "TPSPs acknowledge in writing to customers that they are responsible for the security of account data the TPSP possesses or otherwise stores, processes, or transmits on behalf of the customer, or to the extent that they could impact the security of the customer’s CDE.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "b22b740c-4d2d-4ae1-8d46-bc40671cf01c",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine TPSP policies and procedures.",
                "Examine templates used for written agreements.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "52753050-9d1c-4845-94c4-d037feeb6285",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b5860297-0c56-44f0-96b0-94aeb73c7b08"],
              },
            },
            {
              _uid: "b5860297-0c56-44f0-96b0-94aeb73c7b08",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d20b1717-3821-4407-bb2c-25ab4d6a214b_52753050-9d1c-4845-94c4-d037feeb6285",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "28a7a487-4b53-48dd-9869-64046e474466",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
                "The exact wording of an acknowledgment will depend on the agreement between the two parties, the details of the service being provided, and the responsibilities assigned to each party. The acknowledgment does not have to include the exact wording provided in this requirement.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 132
        {
          fields: [
            {
              _uid: "f48415a8-4e7c-4042-8e1c-c24a28d92991",
              component: "col",
              label: "",
              simplifiedLabel: "12.9.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "47a2c360-1685-4fcb-9d34-deb44e6eb250",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "TPSPs support their customers’ requests for information to meet Requirements 12.8.4 and 12.8.5 by providing the following upon customer request:",
                "PCI DSS compliance status information for any service the TPSP performs on behalf of customers (Requirement 12.8.4).",
                "Information about which PCI DSS requirements are the responsibility of the TPSP and which are the responsibility of the customer, including any shared responsibilities (Requirement 12.8.5).",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "d147550f-f9e8-454e-81b2-6340765613ef",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine policies and procedures."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "d30fe39b-1adb-4981-848b-a21633c391ee",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["51aa6108-6b5d-42e4-972d-5f9436c6f404"],
              },
            },
            {
              _uid: "51aa6108-6b5d-42e4-972d-5f9436c6f404",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d2d13f27-1379-4e1d-89ad-c1b1b6d94971_d30fe39b-1adb-4981-848b-a21633c391ee",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8baaba7b-6708-40b2-894b-dcaa4cac5d54",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement applies only when the entity being assessed is a service provider.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 133
        {
          fields: [
            {
              _uid: "ed1ce795-0360-48fe-9201-6b1c682853d2",
              component: "col",
              label: "",
              simplifiedLabel: [
                "12.10 Suspected and confirmed security incidents that could impact the CDE are responded to immediately",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "9cafc999-3882-4b03-8bae-b36313d53667",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "8f084807-7ff6-4659-9176-39e5792403a3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "An incident response plan exists and is ready to be activated in the event of a suspected or confirmed security incident. The plan includes, but is not limited to:",
                "Roles, responsibilities, and communication and contact strategies in the event of a suspected or confirmed security incident, including notification of payment brands and acquirers, at a minimum.",
                "Incident response procedures with specific containment and mitigation activities for different types of incidents",
                "Business recovery and continuity procedures.",
                "Data backup processes",
                "Analysis of legal requirements for reporting compromises.",
                "Coverage and responses of all critical system components.",
                "Reference or inclusion of incident response procedures from the payment brands.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "ed76e428-eaa9-4bbc-aa28-be7a31741ef7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine the incident response plan.",
                "Interview personnel.",
                "Examine documentation from previously reported incidents.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["b6cd6b63-5105-4556-bfde-5e0f4ec5f21c"],
              },
            },
            {
              _uid: "b6cd6b63-5105-4556-bfde-5e0f4ec5f21c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8cd1e1f0-6783-410c-bc91-ebc5cafa0def_854f7ce6-3090-466c-ae10-9fdf2a4bd70f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f6fbaa5c-f577-4c18-85f3-5e7a0e82c2f8",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "ba7eadb1-77fa-4f54-8af2-9002d5c406a7",
              component: "col",
              label: [],
              simplifiedLabel: [
                "At least once every 12 months, the security incident response plan is:",
                "Reviewed and the content is updated as needed.",
                "Tested, including all elements listed in Requirement 12.10.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "176dd216-81ad-42ae-9e26-f088a4eb2afe",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview personnel.", "Examine documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "eadcd83a-60b4-4f92-ade4-c5d6927012e1",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["adc17ad5-3245-4d27-8a34-3cbf5c2fcc2c"],
              },
            },
            {
              _uid: "adc17ad5-3245-4d27-8a34-3cbf5c2fcc2c",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "87ad662e-f289-4e1c-99b9-b31c73ef53b7_eadcd83a-60b4-4f92-ade4-c5d6927012e1",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "83f59732-c00c-4f11-996b-bbd7e380f8ff",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "13482860-2fe5-4c66-8269-f35a05192792",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Specific personnel are designated to be available on a 24/7 basis to respond to suspected or confirmed security incidents.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2006801c-9de3-4b8e-a151-7cb828c9dc86",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview responsible personnel.", "Examine documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c99261e4-aa18-4ff8-a610-3791de0b117f"],
              },
            },
            {
              _uid: "c99261e4-aa18-4ff8-a610-3791de0b117f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "fb1245e2-3525-4a1f-a34d-00dcb434144f_bbd3ab16-680b-4614-8e42-570fcc6ac9a5",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 134
        {
          fields: [
            {
              _uid: "697e6527-d928-4692-8ee5-2acfee9a84e1",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "2f8599c1-9269-41ac-afdb-bea4e6bd6b72",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Personnel responsible for responding to suspected and confirmed security incidents are appropriately and periodically trained on their incident response responsibilities.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "016f1e3c-bd1c-41ca-b9c7-c056a652303d",
              component: "col",
              label: [],
              simplifiedLabel: ["Interview incident response personnel.", "Examine training documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "30011ed2-bede-4858-b98f-1c8a55dba635",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8616c811-0124-4694-9c90-a78f48065b60"],
              },
            },
            {
              _uid: "8616c811-0124-4694-9c90-a78f48065b60",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "89d948fb-d0cb-488a-867d-c8b2e8f48e79_30011ed2-bede-4858-b98f-1c8a55dba635",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "54401d46-cc5e-4c10-af25-270feecc542d",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.4.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "256c5fb8-5fb5-4c53-98aa-3e1620bc9152",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The frequency of periodic training for incident response personnel is defined in the entity’s targeted risk analysis, which is performed according to all elements specified in Requirement 12.3.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "a2b2687c-9fee-4192-8a98-5d1fa2c76803",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the targeted risk analysis."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "16af4c79-e20c-4cc6-b6b1-e66dd5473a70",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["f46b417f-f593-4c08-ba9f-d83be7aa938a"],
              },
            },
            {
              _uid: "f46b417f-f593-4c08-ba9f-d83be7aa938a",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "86cb273c-8407-4a1d-bf63-0e6eb4bbdfb1_16af4c79-e20c-4cc6-b6b1-e66dd5473a70",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "76f1ca47-1baa-4aa5-aa6c-9d77c4031c2e",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5da7525e-798d-4a7f-8c56-759a2c977d80",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "7c6268ba-53a9-44bb-9534-227fdf87829e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The security incident response plan includes monitoring and responding to alerts from security monitoring systems, including but not limited to:",
                "Intrusion-detection and intrusion-prevention systems.",
                "Network security controls.",
                "Change-detection mechanisms for critical files",
                "The change-and tamper-detection mechanism for payment pages. This bullet is a best practice until its effective date; refer to Applicability Notes below for details.",
                "Detection of unauthorized wireless access points.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "993b22f0-e97a-42e5-8f4a-717ba5087371",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation.", "Observe incident response processes"],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "382cb4bd-7f91-4df7-b150-69b4e7398339",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["2fd856bf-5f79-4953-ab6d-236b5eda1476"],
              },
            },
            {
              _uid: "2fd856bf-5f79-4953-ab6d-236b5eda1476",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "dc15ace0-1869-42ff-b64f-531a90264d83_382cb4bd-7f91-4df7-b150-69b4e7398339",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8937e0d4-e653-4d31-a23c-14558aeeb8ec",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "The bullet above (for monitoring and responding to alerts from a change- and tamperdetection mechanism for payment pages) is a best practice until 31 March 2025, after which it will be required as part of Requirement 12.10.5 and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 135
        {
          fields: [
            {
              _uid: "3bf36d8c-01df-46d2-8453-a104d5e1cbe6",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.6",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "e4df94d0-5496-4dd5-b701-375733d18aab",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The security incident response plan is modified and evolved according to lessons learned and to incorporate industry developments.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2cfa1e0a-e866-4ddd-b50c-34de18458309",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine policies and procedures.",
                "Examine the security incident response plan.",
                "Interview responsible personnel.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b45b2437-8952-4e62-a386-e5e51318a7cd",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["cb890837-d7f6-46b1-ac34-59fa865ae88f"],
              },
            },
            {
              _uid: "cb890837-d7f6-46b1-ac34-59fa865ae88f",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "8b5419aa-652f-4925-801b-2a9cf2331f48_b45b2437-8952-4e62-a386-e5e51318a7cd",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e75cf91c-e72f-4706-85eb-eb85c2c65254",
              component: "col",
              label: "",
              simplifiedLabel: "12.10.7",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "cfc12d0c-5784-4176-b6a9-9f20655ebdf6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Incident response procedures are in place, to be initiated upon the detection of stored PAN anywhere it is not expected, and include:",
                "Determining what to do if PAN is discovered outside the CDE, including its retrieval, secure deletion, and/or migration into the currently defined CDE, as applicable.",
                "Identifying whether sensitive authentication data is stored with PAN.",
                "Determining where the account data came from and how it ended up where it was not expected.",
                "Remediating data leaks or process gaps that resulted in the account data being where it was not expected.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "055b78c3-1ecd-457f-bf5e-5a70115596f6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documented incident response procedures.",
                "Interview personnel.",
                "Examine records of response actions.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "96b3a773-820b-4779-b812-6dd88b05b673",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["fa94e691-0a59-4675-a749-9c082b5085f1"],
              },
            },
            {
              _uid: "fa94e691-0a59-4675-a749-9c082b5085f1",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "08c8a2f7-9b70-437e-85c7-cbfe4258c6c9_96b3a773-820b-4779-b812-6dd88b05b673",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "43971561-0374-40e9-8cd2-e73ddc763db6",
              component: "col",
              label: "",
              simplifiedLabel: [
                "Applicability Notes",
                "This requirement is a best practice until 31 March 2025, after which it will be required and must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 136
        {
          fields: [
            {
              _uid: "a152b938-7b89-4f0e-87c5-d5167d27cb77",
              component: "col",
              label: "",
              simplifiedLabel: [
                "A1.1 Multi-tenant service providers protect and separate all customer environments and data.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "fb17b77f-6bec-4609-805e-106f089fc4b7",
              component: "col",
              label: "",
              simplifiedLabel: "A1.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "1a8ba2e1-5568-4804-a998-f72a7dba59e5",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Logical separation is implemented as follows:",
                "The provider cannot access its customers' environments without authorization.",
                "Customers cannot access the provider’s  environment without authorization.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2d3f3ca1-a751-4110-ae93-4c43833b7c21",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documentation. ",
                "Examine system and network  configurations.",
                " Interview responsible personnel. ",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "71e5ff41-24b4-423a-94c8-316e96fd0e7f",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["17695569-c83a-4394-a970-d0836e72f2bc"],
              },
            },
            {
              _uid: "17695569-c83a-4394-a970-d0836e72f2bc",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "21b3a9fc-7e59-42d7-8954-366515349a74_71e5ff41-24b4-423a-94c8-316e96fd0e7f",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "46281cc7-0a66-454c-8f0d-a30bab866898",
              component: "col",
              label: "",
              simplifiedLabel: [
                "This requirement is a best practice until 31 March 2025, after which it will be required and  must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c0c21b7e-4af7-4852-9697-1901d58484af",
              component: "col",
              label: "",
              simplifiedLabel: "A1.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "93ca66ee-bb45-4121-8188-92cb853da392",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Controls are implemented such that each customer  only has permission to access its own cardholder data  and CDE.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9baf9552-f74e-4672-8fb3-52c61b258790",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation. ", "Examine system configurations."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "7a9fa34a-5cfc-4dbb-9513-48da1fddb4da",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["a77fa690-d029-4aee-8030-7b9c4d2aaa93"],
              },
            },
            {
              _uid: "a77fa690-d029-4aee-8030-7b9c4d2aaa93",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "c0b9bc14-5cee-4110-837b-edc40ca91598_7a9fa34a-5cfc-4dbb-9513-48da1fddb4da",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "53d17ced-387c-4bff-9921-e9aca6e0aae8",
              component: "col",
              label: "",
              simplifiedLabel: "A1.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "17cefe64-8987-4d61-9528-321e19bdc655",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Controls are implemented such that each customer  can only access resources allocated to them.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "052147b1-afcb-44af-a707-2f99915060ff",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine customer privileges. "],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "04d882e3-f7af-4691-a406-60300159ecf3",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["476cac52-682b-4f3d-bbdd-1c11b5c3c754"],
              },
            },
            {
              _uid: "476cac52-682b-4f3d-bbdd-1c11b5c3c754",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "00af3975-1830-40d0-b878-47c7f49c3022_04d882e3-f7af-4691-a406-60300159ecf3",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 137
        {
          fields: [
            {
              _uid: "6dd82ad0-b02f-40e1-9dec-4d270ef31f88",
              component: "col",
              label: "",
              simplifiedLabel: "A1.1.4",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "b18c23c2-783e-44b3-ba56-5060f33153f3",
              component: "col",
              label: [],
              simplifiedLabel: [
                "The effectiveness of logical separation controls used  to separate customer environments is confirmed at  least once every six months via penetration testing.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "0e61e668-fe45-4d28-93f3-98e531802ca6",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine the results from the  most recent penetration test."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "3431e8da-057b-4f0f-b8d1-3308c69dee49",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["41ef1949-1064-4c24-ada6-619dd1508893"],
              },
            },
            {
              _uid: "41ef1949-1064-4c24-ada6-619dd1508893",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "6d1d7d0f-11d0-4dd5-a52d-84344ea43554_3431e8da-057b-4f0f-b8d1-3308c69dee49",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "4e008eb6-a31f-4a0f-bf85-8471f9253b12",
              component: "col",
              label: "",
              simplifiedLabel: [
                "The testing of adequate separation between customers in a multi-tenant service provider  environment is in addition to the penetration tests specified in Requirement 11.4.6.",
                "This requirement is a best practice until 31 March 2025, after which it will be required and  must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e5e2b30b-e223-4399-b307-4680dff23679",
              component: "col",
              label: "",
              simplifiedLabel: [
                "A1.2 Multi-tenant service providers facilitate logging and incident response for all customers.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "bf48bc4f-7126-41f6-9655-4b9e2bea3b0e",
              component: "col",
              label: "",
              simplifiedLabel: "A1.2.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "0852680c-b427-40b5-a08b-525873499aee",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Audit log capability is enabled for each customer’s  environment that is consistent with PCI DSS  Requirement 10, including:",
                "Logs are enabled for common third-party  applications.",
                "Logs are active by default.",
                "Logs are available for review only by the owning  customer.",
                "Log locations are clearly communicated to the  owning customer.",
                "Log data and availability is consistent with PCI  DSS Requirement 10.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e357b7e6-ac0f-44ea-8562-a60cedd0841c",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documentation. ", "Examine system configuration  settings."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "6855b70d-3612-480d-aaeb-3d9e6a514303",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["62b9afb5-2ca1-490e-b8da-0058a657d358"],
              },
            },
            {
              _uid: "62b9afb5-2ca1-490e-b8da-0058a657d358",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "0e0d6d24-d550-4d09-ac90-cf5545cbbfa8_6855b70d-3612-480d-aaeb-3d9e6a514303",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "c5eb3fff-5d86-4ad8-9a59-715aa7c0de10",
              component: "col",
              label: "",
              simplifiedLabel: "A1.2.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "c666a5e9-2cfc-40dd-8e03-1ef12e289823",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Processes or mechanisms are implemented to support  and/or facilitate prompt forensic investigations in the  event of a suspected or confirmed security incident for  any customer.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "424540a9-5334-4f0e-9b96-6d5c099ab54a",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented  procedures."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "10358195-7594-4c6c-94f7-af79539728dd",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["82d29089-8c94-4c96-ad6e-0e9d348fc9db"],
              },
            },
            {
              _uid: "82d29089-8c94-4c96-ad6e-0e9d348fc9db",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "fb06863e-ed07-4872-b723-cd6c104fc504_10358195-7594-4c6c-94f7-af79539728dd",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },

        // 138
        {
          fields: [
            {
              _uid: "4da6ef7b-c0ce-4c81-a837-97f8b59b293e",
              component: "col",
              label: "",
              simplifiedLabel: "A1.2.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "3b9bc6ff-9f17-45ef-8bd4-885fd309eb77",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Processes or mechanisms are implemented for  reporting and addressing suspected or confirmed  security incidents and vulnerabilities, including:",
                "Customers can securely report security incidents  and vulnerabilities to the provider.",
                "The provider addresses and remediates suspected  or confirmed security incidents and vulnerabilities  according to Requirement 6.3.1.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "e11c3d79-f6b5-4252-808d-ec1b5c886414",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine documented  procedures.", "Interview personnel. "],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "e67f9411-180f-4a86-b9f3-d58965fe27ee",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["8610cfe5-a9bd-471b-be69-07b838ce6595"],
              },
            },
            {
              _uid: "8610cfe5-a9bd-471b-be69-07b838ce6595",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "28e81391-7ba7-4141-a608-3774133cd0d6_e67f9411-180f-4a86-b9f3-d58965fe27ee",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "327569dc-87b3-4ae6-8f6d-35502fb95271",
              component: "col",
              label: "",
              simplifiedLabel: [
                "This requirement is a best practice until 31 March 2025, after which it will be required and  must be fully considered during a PCI DSS assessment.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 139
        {
          fields: [
            {
              _uid: "de2c4ea1-ee1d-4ce7-923b-27f1df606342",
              component: "col",
              label: "",
              simplifiedLabel: [
                "A2.1  POI terminals using SSL and/or early TLS are not susceptible to known SSL/TLS exploits.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e74ee9d0-66e4-445e-99b0-15fd077cf265",
              component: "col",
              label: "",
              simplifiedLabel: "A2.1.1",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "27591325-1a5a-4c69-9ff6-5c07153558e8",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Where POS POI terminals at the merchant or  payment acceptance location use SSL and/or early  TLS, the entity confirms the devices are not  susceptible to any known exploits for those protocols.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "2a92d50d-5724-45ed-b058-16a26056628e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Examine documentation (for  example, vendor documentation,  system/network configuration  details) that verifies the devices  are not susceptible to any known  exploits for SSL/early TLS.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "b75016ef-64f7-4791-997e-534b3b7fc9b2",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["c1139a25-fb1f-43e5-8a8a-d159f4689a7e"],
              },
            },
            {
              _uid: "c1139a25-fb1f-43e5-8a8a-d159f4689a7e",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "2669ca07-f68a-4d86-9d16-a677c58d2389_b75016ef-64f7-4791-997e-534b3b7fc9b2",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "52b0a4f9-787e-454d-ae48-a140bff8be1c",
              component: "col",
              label: "",
              simplifiedLabel: [
                "This requirement is intended to apply to the entity with the POS POI terminal, such as a  merchant. This requirement is not intended for service providers who serve as the termination  or connection point to those POS POI terminals. Requirements A2.1.2 and A2.1.3 apply to  POS POI service providers.",
                "The allowance for POS POI terminals that are not currently susceptible to exploits is based on  currently known risks. If new exploits are introduced to which POS POI terminals are  susceptible, the POS POI terminals will need to be updated immediately.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },

        // 140
        {
          fields: [
            {
              _uid: "59f3ccea-575c-4f10-b0af-af9375d3a1c1",
              component: "col",
              label: "",
              simplifiedLabel: "A2.1.2",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "64776b43-ea2b-4a04-be8f-bdc675edf935",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only:",
                "All service providers with existing connection points to  POS POI terminals that use SSL and/or early TLS as  defined in A2.1 have a formal Risk Mitigation and  Migration Plan in place that includes:",
                "Description of usage, including what data is being  transmitted, types and number of systems that use  and/or support SSL/early TLS, and type of  environment.",
                "Risk-assessment results and risk-reduction  controls in place.",
                "Description of processes to monitor for new  vulnerabilities associated with SSL/early TLS.",
                "Description of change control processes that are  implemented to ensure SSL/early TLS is not  implemented into new environments.",
                "Overview of migration project plan to replace  SSL/early TLS at a future date.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "9b31348d-997a-41f9-b583-0e094392632f",
              component: "col",
              label: [],
              simplifiedLabel: ["Review the documented Risk  Mitigation and Migration Plan."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "f9835668-177d-4e5d-8335-43d759ddbefa",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["e5feae33-f113-4875-aeda-cbfe2a191360"],
              },
            },
            {
              _uid: "e5feae33-f113-4875-aeda-cbfe2a191360",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d86a06b1-a3d8-4563-aefc-94fad473deea_f9835668-177d-4e5d-8335-43d759ddbefa",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e2dbf146-6f6b-4c4d-a46d-ea797c8ec82f",
              component: "col",
              label: "",
              simplifiedLabel: [
                "This requirement applies only when the entity being assessed is a service provider.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "cac068ae-85d3-4d20-8f10-71f1d4b21fa5",
              component: "col",
              label: "",
              simplifiedLabel: "A2.1.3",
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "a65330e8-17b4-4f7a-b6db-4d90ec75a6d6",
              component: "col",
              label: [],
              simplifiedLabel: [
                "Additional requirement for service providers only: ",
                "All service providers provide a secure service  offering.",
              ],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "15%",
            },
            {
              _uid: "11c28f34-9183-488f-9e5d-e2537e0f3098",
              component: "col",
              label: [],
              simplifiedLabel: ["Examine system configurations. ", "Examine supporting  documentation."],
              hasLi: "yes",
              type: "",
              col: "12",
              width: "20%",
            },
            {
              _uid: "5bec3e26-587f-4e73-8a8b-6aa0ca2feec7",
              component: "col",
              label: "",
              simplifiedLabel: "",
              type: "radio",
              options: [
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place",
                  value: "in_place",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "In Place with CCW",
                  value: "in_place_with_CCW",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "N/A",
                  value: "na",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not Tested",
                  value: "not_tested",
                },
                {
                  component: "option",
                  label: "",
                  simplifiedLabel: "Not in Place",
                  value: "not_in_place",
                },
              ],
              width: "40%",
              resetFields: {
                value: ["in_place", "in_place_with_CCW", "not_in_place", "not_tested"],
                _uids: ["22a841ec-85d4-4fea-81aa-a8d663503bfd"],
              },
            },
            {
              _uid: "22a841ec-85d4-4fea-81aa-a8d663503bfd",
              component: "text",
              label: "",
              simplifiedLabel: "",
              placeholder: "Please explain the reason of N/A",
              type: "textarea",
              textareaRows: "12",
              col: "12",
              enabledOn: "na",
              conditional: {
                value: "na",
                field: "d6cbbeac-b07f-4921-b491-b46472ef35b8_5bec3e26-587f-4e73-8a8b-6aa0ca2feec7",
              },
              width: "20%",
              maxLength: "320",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "01cd3383-fe1c-4e90-8fae-7a8edc48f8c2",
              component: "col",
              label: "",
              simplifiedLabel: [
                "This requirement applies only when the entity being assessed is a service provider.",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 5,
              width: "100%",
            },
          ],
        },
      ],
    },
  ],
},
  
 
  // page 141 NA
  // page 142
  {
    _uid: "dab5ee3f-880d-4aa2-9f08-457d4f3a9731",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: "Appendix B: Compensating Controls Worksheet",
    fields: [
      {
        _uid: "9daab1fd-0b33-4945-b3d1-0eee9eb91030",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [
          "This Appendix must be completed to define compensating controls for any requirement where In Place with CCW was selected.",
          "Note: Only entities that have a legitimate and documented technological or business constraint can consider the use of compensating controls to achieve compliance",
          "Refer to Appendices B and C in PCI DSS for information about compensating controls and guidance on how to complete this worksheet.",
        ],
        headers: [ "", "Information Required", "Explanation" ],
        fields: [
          {
            fields: [
              {
                _uid: "de0a670f-733d-499c-aaf3-1809dd7d9ee1",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "1. Constraints" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "945fb1ac-20f5-4fa4-aa84-fa2220e98ffd",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [
                  "Document the legitimate technical or business constraints precluding compliance with the original requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "fb2239c6-fa8b-479f-879b-452a4b5dce51",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "5",
                maxLength: "190",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c9d2277-a966-49d2-bfe8-7a4da7021bbc",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "2. Definition of Compensating Controls" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8664ee54-d714-4ff7-b14f-8fd1405e9fb6",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [
                  "Define the compensating controls: explain how they address the objectives of the original control and the increased risk, if any. ",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "7e1b04e8-df1d-4da2-8823-22aa1c320979",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "5",
                maxLength: "185",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "027ef055-9911-49d2-800a-00e0843df4a9",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "3. Objective" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "dae5ee30-a548-40c8-aeef-e8d1395482f7",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Define the objective of the original control." ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ec8d9a96-5d17-44f2-83a5-e84ee8db369b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "3",
                maxLength: "152",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "56148b2d-fcd8-43fc-bec1-261efbb88828",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "2aca286d-dc67-4e29-94ec-bbbb999c4321",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [
                  "Identify the objective met by the compensating control.",
                  "Note: This can be, but is not required to be, the stated Customized Approach Objective listed for this requirement in PCI DSS.",
                ],

                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "995ced2c-9ea4-4450-a23e-d1e97913163b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "8",
                maxLength: "300",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "d24ea8c5-8e3a-4169-9382-694d15de0095",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "4. Identified Risk" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c65b215d-9473-4a3b-83fa-4f38e280a86c",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Identify any additional risk posed by the lack of the original control." ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ac43edc2-cc76-4dab-a281-c0f4920e21d6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "3",
                maxLength: "100",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "95e41bd3-f17f-4913-8586-8ec91b525370",
                component: "col",
                label: [ "5. Validation of Compensating Controls" ],
                simplifiedLabel: [ "Validation of Compensating Controls" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3385059a-2a84-4c17-8fa6-71415e4fd63f",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Define how the compensating controls were validated and tested." ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "275d5b08-cd5d-4fac-a9a7-dcedd56bbb45",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "4",
                maxLength: "150",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7579bd14-4a0e-45fe-96a2-580c3633c55e",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "6. Maintenance" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "ee1d386c-8f68-477a-8d0c-f21049dc48d1",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Define process(es) and controls in place to maintain compensating controls." ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "f1b079bf-3df6-4939-891a-574c0fb4e583",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "40%",
                col: "12",
                textareaRows: "4",
                maxLength: "150",
              },
            ],
          },
        ],
      },
    ],
  },
  // page 143 - NA
  // page 144 - NA
  // page 145
  {
    _uid: "e35e31a9-31ce-4677-8777-bda46cf5f542",
    layout: "form",
    component: "page",
    label: "",
    simplifiedLabel: [ "Section 3: Validation and Attestation Details" ],
    fields: [
      {
        _uid: "6d65f61b-3db3-4dc2-bbf6-7aab1f08d25c",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "Part 3. PCI DSS Validation",
        fields: [
          {
            fields: [
              {
                _uid: "729ff1c4-24ce-4f23-830f-b2baf76fd02e",
                component: "text",
                label: "",
                simplifiedLabel: [
                  "This AOC is based on results noted in SAQ D (Section 2), dated (Self-assessment completion date YYYY-MM-DD).",
                  "Indicate below whether a full or partial PCI DSS assessment was completed:",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
        ],
      },
      {
        _uid: "b6315ee3-0ee0-4e2e-abab-9761ba95127f",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        fields: [
          {
            _uid: "1f3d6bb5-2ac3-4613-b47f-b992562f3992",
            component: "table",
            label: "",
            simplifiedLabel: "",
            type: "table",
            caption: [],
            simplifiedCaption: [ "" ],
            fields: [
              {
                _uid: "56b7ff3e-dd41-4600-b34e-03f4f413fbec",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "6b57e379-e4dd-4f8d-890d-e21c9ce40a98",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Full – All requirements have been assessed therefore no requirements were marked as Not Tested in the SAQ.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            _uid: "a16af1ef-b18c-43c8-b0ad-a978f53bcf74",
            component: "table",
            label: "",
            simplifiedLabel: "",
            type: "table",
            caption: [],
            simplifiedCaption: [ "" ],
            fields: [
              {
                _uid: "d2eff80e-cb55-45ca-975a-5977a51d842e",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "8b44f49e-2d6f-4d93-bc26-66fbedaa83a9",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Partial – One or more requirements have not been assessed and were therefore marked as Not Tested in the SAQ. Any requirement not assessed is noted as Not Tested in Part 2g above.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
        ],
      },
      {
        _uid: "b1f3af76-720b-4d92-925a-5a29a9aeeff9",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: "",
        simplifiedCaption: "",
        fields: [
          {
            fields: [
              {
                _uid: "7e1a41b9-a892-4ba6-b615-b4c1fa23b597",
                component: "text",
                label: "",
                simplifiedLabel: [
                  "Based on the results documented in the SAQ D noted above, each signatory identified in any of Parts 3b−3d, as applicable, assert(s) the following compliance status for the entity identified in Part 2 of this document.",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
        ],
      },
      {
        _uid: "85aa9fe7-1a0d-4a5d-9bb0-22990788f0dd",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [ "Select one:" ],
        fields: [
          {
            fields: [
              {
                _uid: "0921aee6-cd38-4f59-b3cd-617ac7678a47",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "yes",
                width: "20%",
              },
              {
                _uid: "340fbd87-d4f3-40a9-8337-7a4301d3c17d",
                component: "col",
                label: "",
                simplifiedLabel:
                  "Compliant: All sections of the PCI DSS SAQ are complete and all requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ.",
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5b41b378-2940-402d-82d5-9ca6f54861a8",
                component: "checkbox",
                type: "checkbox",
                label: "",
                simplifiedLabel: "",
                value: "Compliant",
                width: "20%",
              },
              {
                _uid: "5fd084e9-d0b2-4838-99e3-df498447b69a",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Non-Compliant: Not all sections of the PCI DSS SAQ are complete, or one or more requirements are marked as Not in Place, resulting in an overall NON-COMPLIANT rating; thereby (Merchant Company Name) has not demonstrated compliance with the PCI DSS requirements included in this SAQ",
                  "Target Date for Compliance: YYYY-MM-DD",
                  "A merchant submitting this form with a Non-Compliant status may be required to complete the Action Plan in Part 4 of this document. Confirm with the entity to which this AOC will be submitted before completing Part 4.",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dfb5ec40-858a-462a-b2ba-eac68fba610e",
                component: "checkbox",
                type: "checkbox",
                value: "yes",
                width: "20%",
                col: "12",
                resetFields: {
                  value: "",
                  _uids: [
                    "04340c67-b572-42a0-aa11-73d4bc27ce04",
                    "5ba8e632-bc5d-4767-a30b-0a2e0e148533",
                    "84ed53a3-feb2-4768-b520-e37dd424b118",
                    "1f559e4b-02e3-4443-a846-837debacbd65",
                    "f4c47047-3eb7-489a-ada9-749adff85201",
                    "8bf20c4d-dd5e-490e-861c-4ad4c268c9d4",
                    "715bb739-794d-46f4-9e82-a6b909a5b326",
                    "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                  ],
                },
              },
              {
                _uid: "2439ba3c-a98f-4259-8ecd-4d574697c1fe",
                component: "col",
                label: "",
                simplifiedLabel: [
                  "Compliant but with Legal exception: One or more requirements in the PCI DSS SAQ are marked as Not in Place due to a legal restriction that prevents the requirement from being met and all other requirements are marked as being either 1) In Place, 2) In Place with CCW, or 3) Not Applicable, resulting in an overall COMPLIANT BUT WITH LEGAL EXCEPTION rating; thereby (Merchant Company Name) has demonstrated compliance with all PCI DSS requirements included in this SAQ except those noted as Not in Place due to a legal restriction.",
                  "Target Date for Compliance: YYYY-MM-DD",
                  "This option requires additional review from the entity to which this AOC will be submitted. If selected, complete the following:",
                ],
                type: "",
                width: "80%",
                col: "12",
                textareaRows: "6",
                maxLength: "120",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "04340c67-b572-42a0-aa11-73d4bc27ce04",
                component: "text",
                label: "",
                simplifiedLabel: "Affected Requirement",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "71355183-e374-40b4-a665-f3d95b774918_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                width: "50%",
              },
              {
                _uid: "5ba8e632-bc5d-4767-a30b-0a2e0e148533",
                component: "text",
                label: "",
                simplifiedLabel: "Details of how legal constraint prevents requirement being met",
                type: "",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "950d2c19-48ef-406b-9e6a-7344bb848688_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                width: "50%",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "84ed53a3-feb2-4768-b520-e37dd424b118",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "48482a08-c167-4871-92fe-66fdc1d3d7d4_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "1f559e4b-02e3-4443-a846-837debacbd65",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "8a765eae-c4bd-4aac-a03c-09fa81bdab66_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "f4c47047-3eb7-489a-ada9-749adff85201",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "f9ed1cb6-919c-48d8-9f1d-80039ac8595f_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "8bf20c4d-dd5e-490e-861c-4ad4c268c9d4",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "39964ee3-b4c9-436f-bb53-2edffbb3b236_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "715bb739-794d-46f4-9e82-a6b909a5b326",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "6e3294ef-2eee-448a-a04f-4e1beb76d0cc_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "25",
              },
              {
                _uid: "e0920ac6-43fb-4bd4-ba44-723aa59322c6",
                component: "textarea",
                label: "",
                simplifiedLabel: "",
                type: "text",
                col: "12",
                conditional: {
                  value: "yes",
                  field: "d4cf1e05-f0bf-466b-b35e-e650a34950bf_dfb5ec40-858a-462a-b2ba-eac68fba610e",
                },
                textareaRows: 6,
                width: "50%",
                maxLength: "70",
              },
            ],
          },
        ],
      },
    ],
  },
  
  
// page - 146
 {
  _uid: "f7c40153-fe36-4570-82dd-520eae2fba93",
  layout: "form",
  component: "page",
  label: "",
  simplifiedLabel: "",
  fields: [
    {
      _uid: "3703ad33-f778-4bd8-b560-3398cb1513bb",
      component: "table",
      label: "",
      simplifiedLabel: "",
      type: "table",
      caption: [],
      simplifiedCaption: ["Part 3. PCI DSS Validation (continued)", "Part 3a. Service Provider Acknowledgement", "Signatory(s) confirms:", "(Select all that apply)"],
      fields: [
        {
          fields: [
            {
              _uid: "a63691e9-9567-4925-820d-8752abe6b612",
              component: "checkbox",
              type: "checkbox",
              label: "",
              simplifiedLabel: "",
              value: "yes",
              width: "20%",
            },
            {
              _uid: "ece6b93a-7d16-46da-8138-36ba3dc12eca",
              component: "col",
              label: "",
              simplifiedLabel:
                "PCI DSS Self-Assessment Questionnaire D, Version 4.0, was completed according to the instructions therein",
              type: "",
              width: "80%",
              col: "12",
              textareaRows: "6",
              maxLength: "120",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "38e7ba32-6b9e-4fc0-9d61-88fcd54ac6f5",
              component: "checkbox",
              type: "checkbox",
              label: "",
              simplifiedLabel: "",
              value: "yes",
              width: "20%",
            },
            {
              _uid: "e1d37b77-af21-404a-b097-f590e080d2fb",
              component: "col",
              label: "",
              simplifiedLabel:
                "All information within the above-referenced SAQ and in this attestation fairly represents the results of the entity’s assessment in all material respects.",
              type: "",
              width: "80%",
              col: "12",
              textareaRows: "6",
              maxLength: "120",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f7a669dc-9758-48d4-82b9-e6722b0c7702",
              component: "checkbox",
              type: "checkbox",
              label: "",
              simplifiedLabel: "",
              value: "yes",
              width: "20%",
            },
            {
              _uid: "e6471716-6d26-4d89-b774-02143b7dc6ed",
              component: "col",
              label: "",
              simplifiedLabel:
                "PCI DSS controls will be maintained at all times, as applicable to the entity’s environment.",
              type: "",
              width: "80%",
              col: "12",
              textareaRows: "6",
              maxLength: "120",
            },
          ],
        },
      ],
    },
    {
      _uid: "8f34029d-61d7-4367-aa3e-12f699040a34",
      component: "table",
      label: "",
      simplifiedLabel: "",
      type: "table",
      caption: "",
      simplifiedCaption: "Part 3b. Service Provider Attestation",
      fields: [
        {
          fields: [
            {
              _uid: "3ef29462-9468-467a-8d33-668475e19187",
              component: "col",
              label: ["Signature of Service Provider Executive Officer"],
              simplifiedLabel: [""],
              hasLi: "no",
              type: "text",
              col: "12",
              colSpan: "2",
              width: "60%",
              maxLength:"115",
            },
            {
              _uid: "b3e0e859-b26d-4b43-83fa-66ba717c8e2a",
              component: "col",
              label: ["Date: YYYY-MM-DD"],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              colSpan: "2",
              width: "40%",
              maxLength: "12",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "b89c195b-c9b3-4ce2-b42e-8ada2e40452e",
              component: "col",
              label: [""],
              simplifiedLabel: ["Signature of Service Provider Executive Officer"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "2",
              width: "60%",
            },
            {
              _uid: "faed680a-fdae-491b-8709-482415861e49",
              component: "col",
              label: [""],
              simplifiedLabel: ["Date: YYYY-MM-DD"],
              type: "",
              col: "12",
              colSpan: 2,
              width: "40%",
              maxLength: "28",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "8ccbfc40-c74c-44c9-a7c9-c7a287f5541b",
              component: "col",
              label: [""],
              simplifiedLabel: ["Service Provider Executive Officer Name: "],
              hasLi: "no",
              type: "",
              col: "10",
              width: "30%",
            },
            {
              _uid: "0089362f-b884-452d-9776-f263fdd3c854",
              component: "col",
              label: [""],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              width: "30%",
              maxLength: "20",
            },
            {
              _uid: "14b71baa-67ec-487c-b3ad-550a01c8bae6",
              component: "col",
              label: [""],
              simplifiedLabel: ["Title"],
              hasLi: "no",
              type: "",
              col: "12",
              width: "5%",
            },
            {
              _uid: "5b418f20-5a39-47cd-8461-547185b91a05",
              component: "col",
              label: [""],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              width: "35%",
              maxLength: "32",
            },
          ],
        },
      ],
    },
    {
      _uid: "6d65f61b-3db3-4dc2-bbf6-7aab1f08d25c",
      component: "table",
      label: "",
      simplifiedLabel: "",
      type: "table",
      caption: "",
      simplifiedCaption: "Part 3c. Qualified Security Assessor (QSA) Acknowledgement",
      fields: [
        {
          fields: [
            {
              _uid: "2bec4c53-6aef-41d8-9742-f87afea4130a",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If a QSA was involved or assisted with this assessment, indicate the role performed:",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "4",
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "342c7f00-e529-4caa-b61b-eadc43297e95",
              component: "checkbox",
              type: "checkbox",
              label: "",
              simplifiedLabel: "",
              value: "yes",
              width: "20%",
            },
            {
              _uid: "bd573f0c-ea66-42be-8361-f5d544c925b6",
              component: "col",
              label: "",
              simplifiedLabel: "QSA performed testing procedures.",
              type: "",
              width: "80%",
              col: "12",
              colSpan: "3",
              textareaRows: "6",
              maxLength: "120",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "f37d68dc-b295-4e6e-a257-d756f885ab53",
              component: "checkbox",
              type: "checkbox",
              label: "",
              simplifiedLabel: "",
              value: "yes",
              width: "20%",
              resetFields: {
                value: "",
                _uids: [
                  "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
                  "35f6ff12-551f-411c-9f09-5262a8bc9882",
                  "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
                  "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
                  "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
                  "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
                  "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
                  "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
                  "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
                  "af9fceed-d116-496d-abe6-e7364f54bc54",
                  "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
                  "a16d9f36-c251-418f-ae30-09a81476075c",
                  "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
                  "a3aa4592-abf0-446b-b9f4-2a254494befe",
                ],
              },
            },
            {
              _uid: "ae4da7e1-24d5-4500-81ed-f48ec5fffe81",
              component: "col",
              label: "",
              simplifiedLabel: "QSA provided other assistance. If selected, describe all role(s) performed:",
              type: "",
              width: "80%",
              col: "12",
              colSpan: "3",
              textareaRows: "6",
              maxLength: "120",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "3486fa5b-95b4-4231-be8d-562ac05cfe5f",
              component: "col",
              label: ["Signature of Lead QSA"],
              simplifiedLabel: [""],
              hasLi: "no",
              type: "text",
              col: "12",
              colSpan: "2",
              width: "50%",
              maxLength:"115",
              conditional: {
                value: "yes",
                field: "c52e2f18-f82c-4430-83af-7a1f504ec37a_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "35f6ff12-551f-411c-9f09-5262a8bc9882",
              component: "col",
              label: ["Date: YYYY-MM-DD"],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              colSpan: "2",
              width: "50%",
              maxLength: "10",
              conditional: {
                value: "yes",
                field: "d03ca81e-8fc0-40bb-8779-221afdca5777_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
          ],
        },
        {
          fields: [
            {
              _uid: "5286fbaf-d360-4fb0-a048-bd7e1bc315df",
              component: "col",
              label: [""],
              simplifiedLabel: ["Signature of Lead QSA"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "2",
              width: "50%",
              conditional: {
                value: "yes",
                field: "618009f8-60f2-4b71-ae30-ccc32ff61f9d_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "e5b153e5-c7cc-4ccd-a9d0-e5bbe989d107",
              component: "col",
              label: [""],
              simplifiedLabel: ["Date: YYYY-MM-DD"],
              type: "",
              col: "12",
              colSpan: "2",
              width: "50%",
              maxLength: "10",
              conditional: {
                value: "yes",
                field: "2e9289f6-2dd2-4a57-951e-8922ce0d230f_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
          ],
        },
        {
          fields: [
            {
              _uid: "71803f94-14e3-4aa0-9d62-16a2e3ee8086",
              component: "col",
              label: [""],
              simplifiedLabel: ["Lead QSA Name: "],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "2",
              width: "50%",
              conditional: {
                value: "yes",
                field: "f78aa84f-c10e-4245-90b3-8a77fa04bf48_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "945d2fc4-1f37-4597-93c8-d63dc498d4bd",
              component: "col",
              label: [""],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              colSpan: "2",
              width: "50%",
              maxLength: "95",
              conditional: {
                value: "yes",
                field: "24ff9345-8cde-42ef-bd4e-a9c8f08bd200_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
          ],
        },
        {
          fields: [
            {
              _uid: "0f3b652b-9c77-408d-8b9e-3b2e5bb62a2d",
              component: "col",
              label: ["Signature of Duly Authorized Officer of QSA Company"],
              simplifiedLabel: [""],
              hasLi: "no",
              type: "text",
              col: "12",
              colSpan: 2,
              maxLength: "115",
              width: "50%",
              conditional: {
                value: "yes",
                field: "d8b5ada2-e0bf-4c66-a7db-df659113c503_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "dd263f82-7859-497a-9bc1-e8ef0fe96ad4",
              component: "col",
              label: ["Date: YYYY-MM-DD"],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              colSpan: 2,
              width: "50%",
              maxLength: "10",
              conditional: {
                value: "yes",
                field: "0081a7e9-4a50-4471-a122-1838914e2bc4_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e57da8a6-cefc-4283-bab1-dc2bbaa452bc",
              component: "col",
              label: [""],
              simplifiedLabel: ["Signature of Duly Authorized Officer of QSA Company"],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: 2,
              width: "50%",
              conditional: {
                value: "yes",
                field: "0bf50a7d-1cae-437b-bc3b-d68d3ffbc2f0_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "af9fceed-d116-496d-abe6-e7364f54bc54",
              component: "col",
              label: [""],
              simplifiedLabel: ["Date: YYYY-MM-DD"],
              type: "",
              col: "12",
              colSpan: 2,
              width: "50%",
              maxLength: "28",
              conditional: {
                value: "yes",
                field: "37e9409a-415a-4ab6-bcdc-e52e4f182d62_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
          ],
        },
        {
          fields: [
            {
              _uid: "7feaaf13-2e3f-47b5-b10e-0ba4747f5ff0",
              component: "col",
              label: [""],
              simplifiedLabel: ["Duly Authorized Officer Name: "],
              hasLi: "no",
              type: "",
              col: "12",
              width: "30%",
              conditional: {
                value: "yes",
                field: "0dd0847a-6c4d-4084-8b9d-589a11e48f33_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "a16d9f36-c251-418f-ae30-09a81476075c",
              component: "col",
              label: [""],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              width: "25%",
              maxLength: "30",
              conditional: {
                value: "yes",
                field: "635a5887-6188-4ce1-8cf1-077188312f19_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "b6beebfb-5547-452e-8ade-bf1b5c55cbb9",
              component: "col",
              label: [""],
              simplifiedLabel: ["QSA Company:"],
              hasLi: "no",
              type: "",
              col: "12",
              width: "15%",
              conditional: {
                value: "yes",
                field: "0c0ca787-57d6-42a0-ac0d-a21218e17384_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
            {
              _uid: "a3aa4592-abf0-446b-b9f4-2a254494befe",
              component: "col",
              label: [""],
              simplifiedLabel: [""],
              type: "text",
              col: "12",
              width: "30%",
              maxLength: "25",
              conditional: {
                value: "yes",
                field: "a4c9e942-883a-4ddd-9657-a1b59cb7d73e_f37d68dc-b295-4e6e-a257-d756f885ab53",
              },
            },
          ],
        },
      ],
    },
    {
      _uid: "7dcf3b0b-4a10-4ab7-ad8c-0444a9e88f7b",
      component: "table",
      label: "",
      simplifiedLabel: "",
      type: "table",
      caption: "",
      simplifiedCaption: "Part 3d. PCI SSC Internal Security Assessor (ISA) Involvement",
      fields: [
        {
          fields: [
            {
              _uid: "57354855-b0ab-4f2d-8fcb-2609c472678e",
              component: "col",
              label: [],
              simplifiedLabel: [
                "If an ISA(s) was involved or assisted with this assessment, indicate the role performed:",
              ],
              hasLi: "no",
              type: "",
              col: "12",
              colSpan: "4",
              width: "100%",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "88542f99-4c83-4291-b18d-282e2b0632ee",
              component: "checkbox",
              type: "checkbox",
              label: "",
              simplifiedLabel: "",
              value: "yes",
              width: "20%",
            },
            {
              _uid: "ecf60fad-172b-48b7-af42-55583f2a3171",
              component: "col",
              label: "",
              simplifiedLabel: "ISA(s) performed testing procedures.",
              type: "",
              width: "80%",
              col: "12",
              colSpan: "3",
              textareaRows: "6",
              maxLength: "120",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "e2c67566-11eb-4f56-b495-8ea89f703fa9",
              component: "checkbox",
              type: "checkbox",
              label: "",
              simplifiedLabel: "",
              value: "yes",
              width: "20%",
              resetFields: {
                value: "",
                _uids: ["6bbfebb8-6022-4ccb-aa16-4249a6d38e02"],
              },
            },
            {
              _uid: "2462213e-afc6-4e28-9c7c-4d5cf4c2c54a",
              component: "col",
              label: "",
              simplifiedLabel: "ISA(s) provided other assistance. If selected, describe all role(s) performed:",
              type: "",
              width: "80%",
              col: "12",
              colSpan: "3",
              textareaRows: "6",
              maxLength: "120",
            },
          ],
        },
        {
          fields: [
            {
              _uid: "6bbfebb8-6022-4ccb-aa16-4249a6d38e02",
              component: "col",
              label: "",
              simplifiedLabel: "",
              placeholder: "Describe all role(s) performed",
              type: "textarea",
              textareaRows: "10",
              col: "12",
              colSpan: 4,
              conditional: {
                value: "yes",
                field: "7a710f1f-871f-4e23-b074-c2c0389ab984_e2c67566-11eb-4f56-b495-8ea89f703fa9",
              },
              width: "100%",
              maxLength: "820",
            },
          ],
        },
      ],
    },
  ],
 },
  
  
  // page 147
  {
    _uid: "6703f7b8-d620-4566-ba6b-57e9c2d3af2b",
    layout: "form",
    component: "page",
    label: "",
    simplifiedCaption: "",
    fields: [
      {
        _uid: "ad8680c0-ba56-4145-83bc-f20850f511f5",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: "",
        fields: [
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "" ],
                boldLabel: "Part 4. Action Plan for Non-Compliant Requirements",
                subBoldLabel: [
                  "Only complete Part 4 upon request of the entity to which this AOC will be submitted, and only if the Assessment has a Non-Compliant status noted in Section 3.",
                  "If asked to complete this section, select the appropriate response for “Compliant to PCI DSS Requirements” for each requirement below. For any “No” responses, include the date the merchant expects to be compliant with the requirement and a brief description of the actions being taken to meet the requirement.",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
            ],
          },
        ],
      },
      {
        _uid: "afb88315-dfc5-483e-b1d6-d727d7d569d6",
        component: "table",
        label: "",
        simplifiedLabel: "",
        type: "table",
        caption: [],
        simplifiedCaption: [],
        headers: [
          "PCI DSS Requirement*",
          "Description of Requirement",
          "Compliant to PCI DSS Requirements",
          "Remediation Date and Actions (If “NO” selected for any Requirement)",
        ],
        fields: [
          {
            fields: [
              {
                _uid: "09ed17e4-d7c2-4c1a-9635-d75f43c6ef56",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "1" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5b32c777-7921-484d-9d11-cf35e528cf98",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Install and maintain network security controls" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "9404507d-01cc-44c3-b92f-1698e361e7a3",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "1f162e1f-99ba-46fe-9e39-2e19c5eefaea" ],
                },
              },
              {
                _uid: "1f162e1f-99ba-46fe-9e39-2e19c5eefaea",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "998dfb9a-a74d-4b2c-be5a-ce3b59c69b66_9404507d-01cc-44c3-b92f-1698e361e7a3",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "a1bda2de-e162-424b-a4f1-30c43cf001ab",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "2" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "8fd97f10-d533-4004-a6ed-e4cad018e190",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Apply secure configurations to all system components" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "3de2fb2a-abeb-4d2a-8480-638084717840",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "0d523bb5-d058-402f-8abb-7f05a1d77a8e" ],
                },
              },
              {
                _uid: "0d523bb5-d058-402f-8abb-7f05a1d77a8e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "84f6b0b5-4187-4cb3-a2e6-3caeb9122eda_3de2fb2a-abeb-4d2a-8480-638084717840",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "4a799130-aef0-401e-8f88-a243cb56b628",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "3" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "7af99412-1790-49b0-80f3-8452bc7086d2",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Protect stored account data" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c03217d3-7e28-4aaa-96de-5d246e84b703",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "7a0eca31-d1df-4d1c-92c7-9841be86d4bc" ],
                },
              },
              {
                _uid: "7a0eca31-d1df-4d1c-92c7-9841be86d4bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "24b994f6-efac-43d7-ab03-bce46757fe95_c03217d3-7e28-4aaa-96de-5d246e84b703",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "5b297358-233c-4c5b-a62b-8258c1d53858",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "4" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "663133c3-d25c-4794-919c-a8dbc7f28794",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [
                  "Protect cardholder data with strong cryptography during transmission over open, public networks",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "99164538-358d-4dd4-9fe4-5418ba9fd53e",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "a8610dd8-67cc-4878-9bcf-5b55a57597bc" ],
                },
              },
              {
                _uid: "a8610dd8-67cc-4878-9bcf-5b55a57597bc",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "c4e6ee76-a639-4c03-98c4-df41ace82e27_99164538-358d-4dd4-9fe4-5418ba9fd53e",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "de255f00-67b9-4653-b803-8e8f7ed65dcb",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "5" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "b6440702-3c40-46ba-89ae-0e57b24edc8b",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Protect all systems and networks from malicious software" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "b603aa66-d295-4857-94a9-6d31164d4327",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "c852df55-3b4f-40d5-848d-9f04dddfa2ab" ],
                },
              },
              {
                _uid: "c852df55-3b4f-40d5-848d-9f04dddfa2ab",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "c5e90795-a214-425d-b351-823f3956edb6_b603aa66-d295-4857-94a9-6d31164d4327",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "7d909157-3e85-402c-afc9-9687534cc37e",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "6" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5aab4319-f9df-4a5a-b2ea-5d6c94adc638",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Develop and maintain secure systems and software" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "d218a370-bedf-4c06-ab0c-c3593d20ef19" ],
                },
              },
              {
                _uid: "d218a370-bedf-4c06-ab0c-c3593d20ef19",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "a1678c93-fcc2-43e8-9b43-0380a5d4b931_e80f7abe-0ad9-4cdf-8a81-c48e33bb9e8c",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dbc41201-0bb0-49d7-a574-d372248177a1",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "7" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "1e11bbe3-5422-4c0c-9acd-421efb0b2178",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Restrict access to system components and cardholder data by business need to know" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d001f65c-23dd-448c-8cbb-c84fd236f0d9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "dc744b62-f7df-4bea-a35d-cba35dd1e23a" ],
                },
              },
              {
                _uid: "dc744b62-f7df-4bea-a35d-cba35dd1e23a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "3d155a39-fd87-42ad-9981-3e8462e07a31_d001f65c-23dd-448c-8cbb-c84fd236f0d9",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "ed73014a-a854-4649-876e-0cf100b71974",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "8" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "5743ddfe-e0f4-4be0-b769-c499ea77d1c0",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Identify users and authenticate access to system components" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "d91076ae-a1e6-4aca-8f77-f4b61721f355",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "1206feba-b01d-4284-871f-6b56114cc49b" ],
                },
              },
              {
                _uid: "1206feba-b01d-4284-871f-6b56114cc49b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "37c917dd-1c63-4bbb-86a9-2205b056b248_d91076ae-a1e6-4aca-8f77-f4b61721f355",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "6d4ad0b7-0ba7-4c8b-80c6-a2a28e610800",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "9" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "eabb273e-9804-4ea8-860a-7cef8b416ed6",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Restrict physical access to cardholder data" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "1120c4c9-880b-4787-a77c-d854d94c1501",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "48fdc1a5-b71e-44dc-a3a9-8425ea492c6a" ],
                },
              },
              {
                _uid: "48fdc1a5-b71e-44dc-a3a9-8425ea492c6a",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "533b6281-8811-4282-ad80-fced4ac1b119_1120c4c9-880b-4787-a77c-d854d94c1501",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "3459a4e6-7b51-407a-b0a8-7843891f7534",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "10" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "c2c106bf-acb7-4285-8c80-e6fbbab39866",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Log and monitor all access to system components and cardholder data" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "dc3d0d5d-ef27-4e5b-8cfc-482311b6c4e2",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "5fbe169a-8069-47df-bda3-7f099bfe6ec1" ],
                },
              },
              {
                _uid: "5fbe169a-8069-47df-bda3-7f099bfe6ec1",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "dc24adda-e9fc-4d0a-b759-b4ca5bef8e9a_dc3d0d5d-ef27-4e5b-8cfc-482311b6c4e2",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "dea416ea-1090-4822-a15b-0245c4d48062",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "11" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "6c7c3e23-4fda-4ce8-8842-e2b23e879a26",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Test security systems and networks regularly" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "8542b132-8ccb-4a81-9b79-f820bc26ff56",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "a165d774-a674-435b-98c8-833d28279384" ],
                },
              },
              {
                _uid: "a165d774-a674-435b-98c8-833d28279384",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "a5d977a0-a124-4031-9d86-8624afe29381_8542b132-8ccb-4a81-9b79-f820bc26ff56",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "93106548-c28e-4007-9f0f-6567043bbda6",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "12" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "66c5df27-b83a-404e-9d01-a8f2beb5fda2",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Support information security with organizational policies and programs" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "50377fbd-8c89-4199-8ff4-30ad491f04a9" ],
                },
              },
              {
                _uid: "50377fbd-8c89-4199-8ff4-30ad491f04a9",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "4f90be87-24af-42b3-85f5-16ccba3819d5_b5435e94-84f6-42b5-ae06-298bcf5ecbcd",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "1c9e5670-100a-437c-b126-bc33acc1e7e3",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Appendix A1" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "240f5007-19d9-42fc-a95e-c9900eb4055a",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Additional PCI DSS Requirements for Multi-Tenant Service Providers" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "bb77d59e-2a43-4f08-8082-08a3f8af2ca4",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "bcd97409-41ba-4f73-825f-130cd1fd275b" ],
                },
              },
              {
                _uid: "bcd97409-41ba-4f73-825f-130cd1fd275b",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "d3c962d5-4672-4bcc-9af7-ec610c8e1e6f_bb77d59e-2a43-4f08-8082-08a3f8af2ca4",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
          {
            fields: [
              {
                _uid: "31825db1-0165-44c5-b9b7-ad5072604d67",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [ "Appendix A2" ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "15%",
              },
              {
                _uid: "709973f5-013a-4f94-b27f-b52b4a425db4",
                component: "col",
                label: [ "" ],
                simplifiedLabel: [
                  "Additional PCI DSS Requirements for Entities using SSL/Early TLS for CardPresent POS POI Terminal Connections",
                ],
                hasLi: "no",
                type: "",
                col: "12",
                width: "30%",
              },
              {
                _uid: "c5a786aa-a5cd-4213-b970-c4969783bdf6",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "radio",
                value: "yes",
                options: [
                  {
                    component: "option",
                    label: "Yes",
                    simplifiedLabel: "Yes",
                    value: "yes",
                  },
                  {
                    component: "option",
                    label: "No",
                    simplifiedLabel: "No",
                    value: "no",
                  },
                ],
                width: "25%",
                resetFields: {
                  value: "yes",
                  _uids: [ "c4012081-994a-4688-9931-fe5a06e8e697" ],
                },
              },
              {
                _uid: "c4012081-994a-4688-9931-fe5a06e8e697",
                component: "col",
                label: "",
                simplifiedLabel: "",
                type: "textarea",
                width: "30%",
                col: "12",
                conditional: {
                  value: "no",
                  field: "b7de43f0-faa0-48a3-8c74-956b65745f07_c5a786aa-a5cd-4213-b970-c4969783bdf6",
                },
                textareaRows: "3",
                maxLength: "90",
              },
            ],
          },
        ],
      },
    ],
  },
  
];
